// Английский словарь панели. Ключ — русский оригинал ровно в том виде, в каком
// он стоит в разметке: так место использования видно без сопоставления с кодом,
// а пропущенный перевод не ломает экран, а просто остаётся русским.
//
// Записи вида {0}, {1} — места подстановки из шаблонных строк. Их порядок в
// переводе менять можно: подстановка идёт по номеру, а не по позиции.

const EN = {
  // Окно публикации (AdModal)
  "проверка": "review",
  "Отпустите — фото добавятся в объявление": "Drop to add the photos to the listing",
  "До 20 снимков, первый станет обложкой": "Up to 20 photos, the first one is the cover",
  "К объявлениям": "Go to listings",
  "Создать ещё": "Create another",
  "Уникализировать название": "Rewrite title",
  "Уникализировать текст": "Rewrite text",
  "Добавьте фото": "Add photos",
  "Укажите PLZ": "Enter a postcode",
  "Готово: {0} из {1}": "{0} of {1} done",
  "пункт": "locality",
  "пункта": "localities",
  "пунктов": "localities",
  "До 20 снимков · первый станет обложкой": "Up to 20 photos · the first one is the cover",
  "Перетащите в окно или нажмите, чтобы выбрать · до 20 снимков, первый станет обложкой": "Drop them onto the window or click to choose · up to 20, the first one is the cover",
  " · перетащите, чтобы поменять порядок": " · drag to reorder",
  "Вставьте ссылку на лот — заберём название, описание и фото": "Paste a listing link — we'll take the title, description and photos",
  "Как называется товар?": "What are you selling?",
  "Расскажите о товаре: состояние, комплект, причина продажи…": "Describe the item: condition, what's included, why you're selling…",
  "Местоположение": "Location",
  "У этого PLZ несколько населённых пунктов": "This postcode covers several localities",
  "Выберите продавца — у одного PLZ бывает несколько населённых пунктов, список берётся с его аккаунта.": "Pick the seller — one postcode can cover several localities, and the list comes from their account.",
  "Готово {0} из {1}": "{0} of {1} done",
  "обязательных: {0}": "required: {0}",
  // Админка: встроенные прокси Umbrella
  "Сохранено · прокси в пуле: {0}. Проверка идёт в фоне — статусы обновятся сами.": "Saved · proxies in pool: {0}. Checking in the background — statuses will update on their own.",
  "Проверка закончена · активных {0} из {1}": "Check finished · {0} of {1} active",
  // Окно добавления аккаунта (AddAccountModal)
  "Убрать файл": "Remove file",
  "добавятся все": "all will be added",
  "Ещё файлы": "More files",
  "Ещё файлы — перетащите или нажмите": "More files — drop or click",
  "Перетащите файлы cookies": "Drop cookie files here",
  ".txt, .json, .cookies · можно несколько": ".txt, .json, .cookies · several allowed",
  "или нажмите, чтобы выбрать · .txt, .json, .cookies · можно несколько — добавятся все": "or click to choose · .txt, .json, .cookies · several allowed — all will be added",
  "Текст cookies": "Cookie text",
  "Вставьте содержимое файла cookies — JSON или строку. Несколько аккаунтов — блоками подряд.": "Paste the cookie file contents — JSON or a cookie string. Several accounts — one block after another.",
  "Имя профиля": "Profile name",
  "Ссылка из письма": "Link from the email",
  "Телефон DE без +49 (опционально)": "German phone without +49 (optional)",
  "SMS-код телефона": "SMS code",
  "Cookies Kleinanzeigen — текстом или файлом": "Kleinanzeigen cookies — as text or a file",
  "Способ добавления": "How to add",
  "Файл": "File",
  "Текст": "Text",
  "Определяем по cookies...": "Detecting from cookies...",
  "Не удалось определить": "Couldn't detect",
  "Определится по cookies": "Detected from the cookies",
  "Найден": "Found",
  "Частично": "Partial",
  "Через выбранный прокси аккаунт будет работать с Kleinanzeigen — его же стоит указать, чтобы имя определилось точно.": "The account works with Kleinanzeigen through this proxy — pick it first so the name is detected correctly.",
  "Добавить аккаунты: {0}": "Add accounts: {0}",
  "Файлов: {0}": "Files: {0}",
  "Блоков: {0}": "Blocks: {0}",
  "Массовый импорт: {0}": "Bulk import: {0}",
  // Книжечка обновлений и тикеты
  "Обновления и тикеты": "Updates and tickets",
  "Обновления": "Updates",
  "Что нового в панели — коротко": "What's new in the panel, in brief",
  "Нашли ошибку? Сообщите нам": "Found a bug? Let us know",
  "Создать тикет": "Create ticket",
  "Опишите проблему подробнее — хотя бы пару слов.": "Please describe the problem in a bit more detail.",
  "Не удалось отправить тикет": "Couldn't send the ticket",
  "Опишите, что произошло: что делали, что ожидали и что случилось. Тикет придёт администратору панели.": "Describe what happened: what you did, what you expected and what went wrong. The ticket goes to the panel admin.",
  "Например: в «Сообщениях» не открывается диалог с покупателем, крутится загрузка": "For example: in Messages a buyer conversation won't open and keeps loading",
  "Текст тикета": "Ticket text",
  "Срочный вопрос — пишите @umbrellacontact в Telegram": "Urgent? Message @umbrellacontact on Telegram",
  "Тикет отправлен": "Ticket sent",
  "Тикет #{0} у администратора. Спасибо!": "Ticket #{0} is with the admin. Thank you!",
  "Тикет у администратора. Спасибо!": "The ticket is with the admin. Thank you!",
  "Тикеты пользователей": "User tickets",
  " · открытых {0}": " · {0} open",
  " · открытых нет": " · none open",
  "Открытые": "Open",
  "Закрытые": "Closed",
  "Не загрузилось — нажмите «Обновить»": "Didn't load — press Refresh",
  "Открытых тикетов нет": "No open tickets",
  "Тикетов пока нет": "No tickets yet",
  "раздел: {0}": "section: {0}",
  "из бота": "from bot",
  "из панели": "from panel",
  "Открыть снова": "Reopen",
  // Язык категорий
  "Язык категорий": "Category language",
  "Названия категорий и их параметров в окнах объявлений и черновиках. В Kleinanzeigen объявление уходит как обычно — на немецком. Выбор сохраняется в этом браузере.": "Category and parameter names in listing windows and drafts. Listings still go to Kleinanzeigen in German, as usual. Saved in this browser.",
  "Зелёная": "Green",
  "Белая": "White",
  // Выбор темы
  "Применяется сразу ко всей панели и запоминается в этом браузере.": "Applies to the whole panel at once and is remembered in this browser.",
  "Индиго": "Indigo",
  "Мягкий красный": "Soft red",
  "Мягкий зелёный": "Soft green",
  "Белый": "White",
  "Для долгой работы": "For long sessions",
  "Высокий контраст": "High contrast",
  "Строгий тёмно-серый": "Strict dark grey",
  "Тёмная с красным": "Dark with red",
  "Тёмная с зелёным": "Dark with green",
  "Тёмная с белым": "Dark with white",
  "Бордовая": "Maroon",
  "Тёмно-бордовый": "Dark maroon",
  "Тёмная с бордовым": "Dark with maroon",
  // Главная без входа
  "2 новых": "2 new",
  "Объявление опубликовано": "Listing published",
  "Все диалоги в одном окне": "All conversations in one window",
  "Свой прокси у каждого аккаунта": "A proxy of its own for every account",
  "Демо без подписки": "Demo without a subscription",
  "Всё для работы с аккаунтами — в одном месте": "Everything for working with accounts — in one place",
  "То, что обычно разбросано по вкладкам, таблицам и заметкам, собрано в одну панель.": "What usually lives across tabs, spreadsheets and notes is gathered into one panel.",
  "Посмотрите панель изнутри": "See the panel from the inside",
  "Демо открывается сразу, без регистрации: все разделы работают на вымышленных данных, ничего не уходит на Kleinanzeigen.": "The demo opens right away, no sign-up needed: every section runs on made-up data, nothing reaches Kleinanzeigen.",
  // Окно входа и регистрации
  "Скрыть пароль": "Hide password",
  "Показать пароль": "Show password",
  "Вход или регистрация": "Sign in or sign up",
  // Экран «Подписка не активна» и демо-режим
  "Демо-доступ": "Demo access",
  "Сразу после регистрации откроется демо-панель на вымышленных данных.": "The demo panel with made-up data opens right after it.",
  "Если у аккаунта нет подписки, после входа сразу откроется демо-панель.": "If the account has no subscription, the demo panel opens right after you sign in.",
  "Создать аккаунт и открыть демо": "Create account and open the demo",
  "Панель на паузе.": "The panel is paused.",
  "Демо — открыто.": "The demo is open.",
  "Оформите подписку в Telegram — доступ откроется сразу после оплаты. А пока загляните в демо: все разделы работают на вымышленных данных, ничего не уходит на Kleinanzeigen и не тратит нейросеть.": "Subscribe in Telegram — access opens right after payment. Meanwhile, take a look at the demo: every section runs on made-up data, nothing reaches Kleinanzeigen and no AI is used.",
  "Оформить подписку": "Subscribe",
  "Открыть демо": "Open the demo",
  "Открыть демо-панель": "Open the demo panel",
  "Уже оплатили? Проверить статус": "Already paid? Check the status",
  "Подписка пока не активна. Если вы только что оплатили, подождите минуту и проверьте снова.": "The subscription isn't active yet. If you've just paid, wait a minute and check again.",
  "Не удалось проверить статус. Повторите позже.": "Couldn't check the status. Try again later.",
  "Тарифы": "Plans",
  "Оплата в Telegram-боте, в USDT": "Paid in the Telegram bot, in USDT",
  "Выгоднее всего": "Best value",
  "≈ {0} USDT в день": "≈ {0} USDT per day",
  "Что внутри": "What's inside",
  "Любой раздел открывается в демо одним нажатием": "Any section opens in the demo with one click",
  "Аккаунты и прокси": "Accounts and proxies",
  "Статусы, прогрев, телефоны и проверка прокси": "Statuses, warm-up, phones and proxy checks",
  "Все диалоги в одном окне, подсказки ответа и перевод": "All conversations in one window, reply suggestions and translation",
  "Публикация, резерв, правка и история": "Publishing, reserving, editing and history",
  "Рассылка по ссылкам и сбор email-лидов": "Messaging by links and collecting email leads",
  "Свежие объявления и скачки просмотров": "Fresh listings and view spikes",
  "Отложенная публикация по расписанию": "Scheduled publishing",
  "аккаунта": "accounts",
  "объявлений": "listings",
  "Язык": "Language",
  "Скопировать": "Copy",
  "Демо": "Demo",
  "Демо-режим": "Demo mode",
  "Демо-режим — подписка не оформлена": "Demo mode — no subscription",
  "Это песочница.": "This is a sandbox.",
  "Данные вымышленные. Жмите на что угодно.": "The data is made up. Click anything.",
  "Вымышленные данные": "Made-up data",
  "Выйти из демо": "Leave the demo",
  // Граббер объявлений с площадок
  "Площадка, с которой забирать объявление": "Marketplace to grab the listing from",
  "Не удалось загрузить объявление.": "Could not load the listing.",
  "Вставьте ссылку на товар {0}.": "Paste a link to the {0} item.",
  "Ссылка должна вести на страницу товара {0}.": "The link must point to an item page on {0}.",
  "Забираю данные со страницы {0}...": "Fetching data from the {0} page...",
  "Ссылка на лот ({0}) — заберём title, описание и фото": "Item link ({0}) — we will pull the title, description and photos",
  "Дерево категорий не прочитано с Kleinanzeigen — пересоберите его и повторите.": "The category tree was not read from Kleinanzeigen — rebuild it and try again.",
  "нажмите «Подобрать»": "press “Match”",
  "Подобрать": "Match",
  // Парсер: папки и закрепление
  "Закрепление": "Pinning",
  "Папки": "Folders",
  "Не удалось создать папку": "Could not create the folder",
  "Не удалось удалить папку": "Could not delete the folder",
  "Переименовать папку": "Rename folder",
  "Удалить папку": "Delete folder",
  "Имя папки": "Folder name",
  "Создать": "Create",
  "Новая папка": "New folder",
  "Новая папка…": "New folder…",
  "В папке пусто — добавьте объявления через значок папки на карточке.": "The folder is empty — add listings with the folder icon on a card.",
  "Закреплено": "Pinned",
  "Открепить": "Unpin",
  "Закрепить сверху": "Pin to top",
  "Закрепить сверху в этом виде": "Pin to the top of this view",
  "Открепить здесь": "Unpin here",
  "Закрепить": "Pin",
  "В папку": "To folder",
  "В папке": "In a folder",
  "Папок ещё нет — создайте первую.": "No folders yet — create the first one.",
  "Создать и положить сюда": "Create and add this listing",
  // Уникализация текста объявления
  "Уникализировать": "Make unique",
  // Подсказка ответа в поле ввода
  "Вставить подсказку": "Insert the suggestion",
  "Вставить подсказку (Tab)": "Insert the suggestion (Tab)",
  "Вставить": "Insert",
  // Шрифт в настройках
  // Эффект в настройках
  "Эффект": "Effect",
  "Зонтики из знака панели, медленно летящие поверх интерфейса. Работе не мешают — нажатия сквозь них проходят. Выбор хранится в этом браузере.": "Umbrellas from the panel logo drifting slowly over the interface. They do not get in the way — clicks pass right through. The choice is kept in this browser.",
  "Выключен": "Off",
  "Зонтики": "Umbrellas",
  "Шрифт": "Font",
  "Лёгкий — тонкий и компактный, больше текста на экране; стоит по умолчанию. Плотный — шире и жирнее.": "Light — thin and compact, more text on screen; the default. Dense — wider and bolder.",
  "Плотный": "Dense",
  "Лёгкий": "Light",
  // История публикаций
  "История публикаций": "Publishing history",
  "Активные": "Active",
  "История": "History",
  "На проверке": "Under review",
  "Отклонено модерацией": "Rejected by moderation",
  "Не подтверждено": "Not confirmed",
  "{0} с": "{0} s",
  "{0} мин {1} с": "{0} min {1} s",
  "Поиск по названию, аккаунту или ошибке": "Search by title, account or error",
  "Поиск по названию, пользователю, аккаунту или ошибке": "Search by title, user, account or error",
  "Все пользователи": "All users",
  "Мои": "Mine",
  "пользователь удалён": "deleted user",
  "Здесь появятся публикации всех пользователей — удачные и нет, с датой, аккаунтом и причиной.": "Publications of all users will appear here — successful or not, with the date, account and reason.",
  "{0} публикаций": "{0} publications",
  "Не удалось очистить историю": "Could not clear the history",
  "Не удалось удалить запись": "Could not delete the entry",
  "По этому запросу ничего нет.": "Nothing matches this search.",
  "Здесь появятся ваши публикации — удачные и нет, с датой, аккаунтом и причиной.": "Your publications will appear here — successful or not, with the date, account and reason.",
  "аккаунт #{0}": "account #{0}",
  "{0} фото": "{0} photos",
  "Открыть на Kleinanzeigen": "Open on Kleinanzeigen",
  "Убрать из истории": "Remove from the history",
  "Показать ещё": "Show more",
  // Редактор фото (чат с моделью)
  "Редактор фото": "Photo editor",
  "Редактор фото и генератор шрифтов": "Photo editor and the font generator",
  "Новый чат": "New chat",
  "Удалить чат": "Delete chat",
  "Не удалось загрузить историю": "Could not load the history",
  "Не удалось открыть чат": "Could not open the chat",
  "Не удалось удалить чат": "Could not delete the chat",
  "Открываем чат...": "Opening the chat...",
  "Приложите фото и скажите, что с ним сделать": "Attach a photo and say what to do with it",
  "Фон, свет, лишнее в кадре, кадрирование. Сам предмет модель не меняет. Следующая просьба применяется к последней картинке.": "Background, light, clutter, cropping. The item itself stays as it is. The next request applies to the latest picture.",
  "Модель рисует... обычно 5–15 секунд": "The model is drawing... usually 5–15 seconds",
  "Прикрепить к сообщению": "Attach to the message",
  "Прикреплено к сообщению.": "Attached to the message.",
  "Не удалось прикрепить фото.": "Could not attach the photo.",
  "Скачать": "Download",
  "Взять за основу": "Use as the base",
  "Не удалось взять это фото за основу.": "Could not use this photo as the base.",
  "Приложить фото": "Attach a photo",
  "Что сделать с фото?": "What should be done with the photo?",
  "Сделать": "Go",
  "Приложите фото, с которого начать.": "Attach a photo to start from.",
  "Фото не прочиталось.": "The photo could not be read.",
  "Не удалось обработать фото": "Could not process the photo",
  "Белый фон": "White background",
  "Убрать лишнее из кадра": "Remove clutter from the frame",
  "Студийный свет": "Studio lighting",
  "Выровнять и обрезать по предмету": "Straighten and crop to the item",
  "Убрать коробку и упаковку": "Remove the box and packaging",
  "Сделать резче и ярче": "Sharper and brighter",
  // Предложения покупки в диалоге
  "Предложение отклонено": "Offer declined",
  "Предложение истекло": "Offer expired",
  "Предложение принято": "Offer accepted",
  "Предложение отозвано": "Offer withdrawn",
  "Предложение завершено": "Offer ended",
  "Оплачено": "Paid",
  "Встречное предложение": "Counter-offer",
  "Предложение отправлено": "Offer sent",
  "Предложение покупки": "Purchase offer",
  "Безопасная оплата": "Secure payment",
  "Товар": "Item",
  "страховка до {0}": "insured up to {0}",
  "Отклонить предложение": "Decline the offer",
  "Отклоняем...": "Declining...",
  "Отклонить предложение?": "Decline the offer?",
  "Покупатель увидит, что предложение отклонено. Отменить это будет нельзя.": "The buyer will see the offer as declined. This cannot be undone.",
  "Отклонить": "Decline",
  // Настройки нейросети
  "Нейросеть": "AI",
  "Пометки в диалогах": "Dialog badges",
  "Поиск по названию": "Search by title",
  "Поиск по имени или ID": "Search by name or ID",
  "Поиск": "Search",
  "Ничего не найдено": "Nothing found",
  "Имя, ID или Telegram": "Name, ID or Telegram",
  "Открыть чат в Telegram": "Open chat in Telegram",
  "Telegram привязан": "Telegram linked",
  "TG: {0}": "TG: {0}",
  "аккаунтов подключено": "accounts connected",
  "сообщений всего": "messages in total",
  "непрочит.": "unread",
  "Выбрать аккаунт": "Select account",
  "Фолловеры": "Followers",
  "выбрано": "selected",
  "Удаляется...": "Deleting…",
  "Смена прокси у выбранных": "Change proxy for selected",
  "Аккаунтов: {0}": "Accounts: {0}",
  "Обновление аккаунтов": "Refreshing accounts",
  "Обновлено {0} из {1}": "Refreshed {0} of {1}",
  "Удалить аккаунтов: {0}": "Delete accounts: {0}",
  "Аккаунты будут удалены из панели вместе с их cookie. Объявления на Kleinanzeigen останутся.": "The accounts will be removed from the panel along with their cookies. The listings on Kleinanzeigen stay.",
  "Удаление аккаунтов": "Deleting accounts",
  "Удалено {0} из {1}": "Deleted {0} of {1}",
  "Смена прокси": "Proxy change",
  "Прокси сменён у {0} из {1}": "Proxy changed for {0} of {1}",
  "Выбрано: {0}": "Selected: {0}",
  "Обновить выбранные": "Refresh selected",
  "Удалить выбранные": "Delete selected",
  "Снять выделение": "Clear selection",
  "в {0}": "in {0}",
  "Введите значение": "Enter a value",
  "Индекс": "Postcode",
  "Обложка": "Cover",
  "Загружаем фото объявления…": "Loading the listing photos…",
  "Первое фото — обложка. Порядок меняется перетаскиванием или кнопками на фото. Что осталось в сетке, то и будет на объявлении.": "The first photo is the cover. Reorder by dragging or with the buttons on a photo. Whatever stays in the grid stays on the listing.",
  "Новых фото: {0}": "New photos: {0}",
  "Очистить поиск": "Clear search",
  "По запросу «{0}» ничего не найдено.": "Nothing found for “{0}”.",
  "Приостановлено": "Paused",
  "Временно выключено на сервере, чтобы не расходовать лимит нейросети.": "Temporarily switched off on the server to save the model quota.",
  "Angebot, PayPal F&F и W&D, Versand и Abholung — по последнему входящему": "Angebot, PayPal F&F and W&D, Versand and Abholung — from the last incoming message",
  "Подсказка ответа в поле ввода": "Reply suggestion in the composer",
  "Готовый ответ серым текстом; Tab или «Вставить» кладут его в поле": "A ready reply in grey; Tab or “Insert” puts it into the field",
  "Объявление по фото": "Listing from photos",
  "Кнопка «Описать по фото» в карточке объявления": "The “Describe from photos” button in the listing editor",
  "Быстрые действия ассистента": "Assistant quick actions",
  "Переписка не загрузилась": "The conversation didn't load",
  "Попробуйте ещё раз.": "Please try again.",
  "Панель не открылась": "The panel didn't open",
  "Раздел не открылся": "This section didn't open",
  "Панель обновилась, пока страница была открыта. Обновите страницу — всё загрузится заново.": "The panel was updated while this page was open. Reload the page and everything will load again.",
  "Что-то пошло не так при показе. Попробуйте ещё раз или обновите страницу.": "Something went wrong while showing this. Try again or reload the page.",
  "Обновить страницу": "Reload the page",
  "Подставить PLZ аккаунта": "Use the account's postcode",
  "Подставить PLZ прокси": "Use the proxy's postcode",
  "Населённый пункт": "Locality",
  "{0} у этого PLZ": "{0} for this postcode",
  // Сводка справа от переписки (ConversationSummary)
  "< 1 мин": "< 1 min",
  "Среднее по ответам в этом диалоге: {0}": "Average over {0} replies in this conversation",
  "В этом диалоге ещё не отвечал на ваши сообщения": "Hasn't replied to your messages in this conversation yet",
  "Перечитать объявление с Kleinanzeigen: статус, просмотры, избранное": "Reload the listing from Kleinanzeigen: status, views, saves",
  "Снять резерв — объявление снова активно": "Remove the reservation — the listing is active again",
  "Отметить объявление зарезервированным": "Mark the listing as reserved",
  "Kleinanzeigen принял запрос — статус обновится через несколько секунд.": "Kleinanzeigen accepted the request — the status will update in a few seconds.",
  "Расстояние": "Distance",
  "км": "km",
  "Место из его объявлений на Kleinanzeigen": "Place from their listings on Kleinanzeigen",
  "Показать полностью": "Show all",
  "Сводка": "Summary",
  "Скрыть сводку": "Hide summary",
  "Сводка по диалогу": "Conversation summary",
  "Оценки покупателей на Kleinanzeigen": "Buyer ratings on Kleinanzeigen",
  "на KL с {0}": "on KL since {0}",
  "Профиль не загрузился": "Profile didn't load",
  "Профиль недоступен": "Profile unavailable",
  "Объявлений": "Listings",
  "Отвечает": "Replies in",
  "Откуда": "Location",
  "Заметка о пользователе": "Note about this user",
  "Не сохранилось": "Not saved",
  "Видна только вам во всех чатах с ним": "Only you see it, in all your chats with them",
  "Объявления нет среди активных — продано, удалено или чужое.": "Not among active listings — sold, deleted or not yours.",
  "Частное лицо": "Private seller",
  "Компания": "Business",
  "мин": "min",
  "дн": "d",
  "Свернуть панель": "Collapse the sidebar",
  "Закрепить панель": "Pin the sidebar",
  "Прокси аккаунта не отвечает": "The account's proxy is not responding",
  "Прокси аккаунта выходит не из Германии": "The account's proxy exits outside Germany",
  "Не удалось определить страну прокси аккаунта": "Couldn't determine the country of the account's proxy",
  "Прокси аккаунта не прошёл проверку": "The account's proxy failed the check",
  "Очистить историю публикаций?": "Clear the publishing history?",
  "Объявления на Kleinanzeigen это не затронет.": "Your listings on Kleinanzeigen stay as they are.",
  "Удалить все": "Delete all",
  "Удалить чат?": "Delete this chat?",
  "Чат удалится вместе со всеми картинками в нём.": "The chat is deleted together with all its images.",
  "Удалить папку «{0}»?": "Delete the folder “{0}”?",
  "Объявления из неё вернутся в общую ленту.": "Its listings go back to the main feed.",
  "Язык «Перевода» и «Анализа» в чате с ассистентом — не зависит от языка панели. Покупателю ответ всегда по-немецки": "Language of “Translation” and “Analysis” in the assistant chat — independent of the panel language. Replies to buyers are always in German",
  "Язык быстрых действий": "Quick actions language",
  "Не удалось сохранить настройку": "Could not save the setting",
  // Замок на парсере
  "Парсер закрыт": "Parser is locked",
  "Раздел выдаётся отдельно: он собирает объявления за всю панель сразу. Напишите администратору — и он откроется здесь же, перезаходить не нужно.": "This section is granted separately — it collects listings for the whole panel at once. Message the admin and it opens right here, no need to sign in again.",
  "Написать администратору": "Message the admin",
  "Парсер открыт": "Parser unlocked",
  // Центр уведомлений
  "Всё прочитано": "All caught up",
  "Отметить все прочитанными": "Mark all as read",
  "Система": "System",
  "В этом разделе пусто": "Nothing in this section",
  "Здесь появятся уведомления выбранного типа.": "Notifications of the selected type will show up here.",
  "Новые сообщения, события прокси и объявления панели появятся здесь.": "New messages, proxy events and panel announcements will show up here.",
  "Раньше": "Earlier",
  "Всего: {0}": "Total: {0}",
  "Уведомления приходят и в Telegram": "Notifications also arrive in Telegram",
  "Настроить": "Settings",
  // AI-ассистент
  "Печатает...": "Typing...",
  "Помощник по диалогу": "Conversation helper",
  "Ассистент": "Assistant",
  "Чем помочь?": "How can I help?",
  "Переведу входящее, напишу ответ или разберу, на какой стадии сделка. Или задайте свой вопрос ниже.": "I can translate the incoming message, draft a reply or assess where the deal stands. Or ask your own question below.",
  "Выберите диалог слева — и я подключусь к нему.": "Pick a conversation on the left and I will join it.",
  "на русский": "into Russian",
  "на английский": "into English",
  "вежливый, по-немецки": "polite, in German",
  "стадия и риски": "stage and risks",
  "Копировать": "Copy",
  "Администратор выдал доступ — раздел готов к работе.": "The admin granted access — the section is ready.",
  "Доступ выдаёт администратор": "Access is granted by the admin",
  "Доступ к парсеру": "Parser access",
  "Фото без предела": "Unlimited photos",
  "Снимает дневной предел генераций фото": "Removes the daily photo generation limit",
  "{0}: генерация фото без дневного предела.": "{0}: photo generation without a daily limit.",
  "{0}: снова четыре генерации фото в сутки.": "{0}: back to four photo generations a day.",
  "Осталось генераций сегодня: {0} из {1}": "Generations left today: {0} of {1}",
  "Дневной предел исчерпан. Новые генерации — после полуночи по Берлину.": "Daily limit reached. New generations after midnight Berlin time.",
  "Открывает раздел «Парсер». По умолчанию он закрыт у всех.": "Opens the Parser section. It is locked for everyone by default.",
  "{0}: раздел «Парсер» открыт.": "{0}: the Parser section is now open.",
  "{0}: раздел «Парсер» закрыт.": "{0}: the Parser section is now locked.",

  // Пометки в диалогах
  // Объявление по фото
  "Описать по фото": "Describe from photos",
  "Смотрим фото...": "Looking at the photos...",
  "Модель посмотрит фото и напишет название, описание, подберёт категорию и обложку": "The model looks at the photos and writes the title and description, picks a category and a cover",
  "Составлено по фото: название": "Written from the photos: title",
  "Составлено по фото: описание": "Written from the photos: description",
  "Не удалось прочитать фото": "Could not read the photos",
  "Не удалось описать фото": "Could not describe the photos",
  "Модель ничего не предложила": "The model suggested nothing",
  "Готово: {0}": "Done: {0}",
  "название объявления": "title",
  "текст описания": "description",
  "категория": "category",
  "обложка — фото {0}": "cover — photo {0}",
  "в обложку лучше фото {0}": "photo {0} would make a better cover",
  "замечаний к фото: {0}": "photo warnings: {0}",
  "Переписываем...": "Rewriting...",
  "Перевести на немецкий и переписать другими словами": "Translate into German and reword",
  "Переписано на немецком: название": "Rewritten in German: title",
  "Переписано на немецком: описание": "Rewritten in German: description",
  "Вернуть как было": "Undo",
  "Модель вернула пустой текст — повторите.": "The model returned empty text — try again.",
  "Не удалось переписать текст": "Could not rewrite the text",
  // Выбор категории и подсказка по названию
  "Поиск категории": "Search categories",
  "Подбираем...": "Matching...",
  "Похоже на": "Looks like",
  "по названию объявления": "from the listing title",
  "Выбрать эту категорию": "Pick this category",
  "Подобрать заново": "Match again",
  "Подходящая категория не нашлась": "No matching category found",
  "Не удалось подобрать категорию": "Could not match a category",
  "Раздел": "Section",
  "Подсказка категорий не настроена: на сервере нет KL_GEMINI_API_KEY.": "Category matching is not configured: KL_GEMINI_API_KEY is missing on the server.",
  "Введите название объявления — по нему подбирается категория.": "Enter the listing title — the category is matched from it.",
  "Нужен accountId: запрос идёт через прокси аккаунта.": "accountId is required: the request goes through the account's proxy.",
  "Дерево категорий пустое — пересоберите его и повторите.": "The category tree is empty — rebuild it and try again.",
  "Модель не предложила подходящую категорию.": "The model did not suggest a suitable category.",
  "Аккаунт должен быть привязан к прокси для подсказки категории.": "The account must be bound to a proxy to match a category.",
  "Красная": "Red",
  // Обновление одного объявления
  "Обновить это объявление": "Refresh this listing",
  "Обновление": "Refresh",
  "Не удалось определить объявление для обновления.": "Could not identify the listing to refresh.",
  "Не удалось обновить данные объявления": "Could not refresh the listing's data",
  "Kleinanzeigen не вернул это объявление. Обновите список целиком, чтобы проверить, на месте ли оно.": "Kleinanzeigen did not return this listing. Refresh the whole list to check whether it is still there.",
  "Объявления больше нет на Kleinanzeigen — убрали его из списка.": "This listing is no longer on Kleinanzeigen — removed it from the list.",
  "Прокси аккаунта не может подключиться к Kleinanzeigen. Проверьте прокси и повторите.": "The account's proxy cannot reach Kleinanzeigen. Check the proxy and try again.",
  // Письма о сообщениях (переключатель в меню аккаунта)
  "Не удалось связаться с Kleinanzeigen через прокси аккаунта. Проверьте прокси и повторите.": "Could not reach Kleinanzeigen through the account's proxy. Check the proxy and try again.",
  "Прокси аккаунта не настроен — запрос к Kleinanzeigen не отправлен.": "The account has no proxy configured — the request to Kleinanzeigen was not sent.",
  "Kleinanzeigen вернул не настройки. Проверьте прокси и сессию аккаунта.": "Kleinanzeigen returned something other than the settings. Check the proxy and the account session.",
  "Запрос к Kleinanzeigen не удался.": "The request to Kleinanzeigen failed.",
  "Письма о сообщениях": "Message e-mails",
  "Письма от Kleinanzeigen о новых сообщениях на почту аккаунта": "E-mails from Kleinanzeigen about new messages, sent to the account's mailbox",
  "Включены": "On",
  "Выключены": "Off",
  "Нажмите, чтобы проверить": "Click to check",
  "Kleinanzeigen снова будет присылать письма о новых сообщениях.": "Kleinanzeigen will send e-mails about new messages again.",
  "Kleinanzeigen больше не будет присылать письма о новых сообщениях.": "Kleinanzeigen will no longer send e-mails about new messages.",
  "Не удалось прочитать настройку на Kleinanzeigen.": "Could not read the setting on Kleinanzeigen.",
  "Не удалось изменить настройку на Kleinanzeigen.": "Could not change the setting on Kleinanzeigen.",
  "Не удалось прочитать настройки уведомлений.": "Could not read the notification settings.",
  "Kleinanzeigen не принял смену настройки.": "Kleinanzeigen did not accept the setting change.",
  "Kleinanzeigen не принял сессию аккаунта.": "Kleinanzeigen did not accept the account session.",
  "Kleinanzeigen не подтвердил смену настройки.": "Kleinanzeigen did not confirm the setting change.",
  "Прокси обязателен для чтения настроек.": "A proxy is required to read the settings.",
  "Прокси обязателен для смены настроек.": "A proxy is required to change the settings.",
  "Ожидается поле enabled: true или false.": "Expected the field enabled: true or false.",
  "Аккаунт должен быть привязан к прокси для чтения настроек.": "The account must be bound to a proxy to read the settings.",
  "Аккаунт должен быть привязан к прокси для смены настроек.": "The account must be bound to a proxy to change the settings.",
  "Только воркеры": "Workers only",
  "Добавьте хотя бы одно фото: без фото объявление не публикуется.": "Add at least one photo: a listing without photos can't be published.",
  "Добавьте хотя бы одно фото в черновик: без фото объявление не публикуется.": "Add at least one photo to the draft: a listing without photos can't be published.",
  "Kleinanzeigen временно закрыл доступ (403). Сессия жива, cookie менять не нужно — повторите через минуту.": "Kleinanzeigen has temporarily blocked access (403). The session is alive and the cookies are fine — try again in a minute.",
  " (до {0})": " (until {0})",
  " (нет подписки)": " (no subscription)",
  " · {0} назад": " · {0} ago",
  " · порядок — перетаскиванием или кнопками на фото": " · reorder by dragging or with the buttons on a photo",
  " · чатов: {0}": " · chats: {0}",
  " Причина: {0}": " Reason: {0}",
  " и другие": " and others",
  " и ещё {0}": " and {0} more",
  " символов": " characters",
  "% выполнено": "% done",
  "(не найдено)": "(not found)",
  "(нем.)": "(de)",
  "(нет)": "(none)",
  "(отправить всем привязанным пользователям)": "(send to all linked users)",
  "+ Добавить": "+ Add",
  "+{0}ч для {1} подписок": "+{0}h for {1} subscriptions",
  ". Правой кнопкой мыши зажмите и перетащите для смены порядка.": ". Hold the right mouse button and drag to reorder.",
  "/api/accounts - список аккаунтов": "/api/accounts - list of accounts",
  "/api/proxies - список прокси": "/api/proxies - list of proxies",
  "/buy — покупка подписки": "/buy — buy a subscription",
  "/cancel — отмена текущего шага": "/cancel — cancel the current step",
  "/health - статус сервиса": "/health - service status",
  "/login — вход по логину/паролю": "/login — sign in with username and password",
  "/logout — выход": "/logout — sign out",
  "/register — регистрация": "/register — register",
  "/status — статус аккаунта": "/status — account status",
  "/ч": "/h",
  "1-е сообщение (приветствие)": "1st message (greeting)",
  "2-е сообщение (после ответа)": "2nd message (after a reply)",
  "2-е сообщение пустое в настройках Sender.": "The 2nd message is empty in the Sender settings.",
  "3-е отправлено": "3rd sent",
  "3-е сообщение (по email)": "3rd message (by email)",
  "3-е сообщение доступно только для лидов с найденной почтой.": "The 3rd message is only available for leads with a known email address.",
  "3-е сообщение отправлено": "3rd message sent",
  "3-е сообщение пустое в настройках Sender.": "The 3rd message is empty in the Sender settings.",
  "3-е сообщение уже было отправлено ранее": "The 3rd message has already been sent",
  "4 шага": "4 steps",
  "AI ассистент": "AI assistant",
  "AI ассистент вернул пустой ответ.": "The AI assistant returned an empty response.",
  "AI ассистент не настроен: отсутствует KL_GEMINI_API_KEY на сервере.": "The AI assistant is not configured: KL_GEMINI_API_KEY is missing on the server.",
  "AI ассистента": "the AI assistant",
  "AI думает...": "AI is thinking...",
  "Cookie аккаунта пустые.": "The account's cookies are empty.",
  "Cookie пустые.": "The cookies are empty.",
  "Cookie файл пустой": "The cookie file is empty",
  "Cookie файл пустой или не распознан": "The cookie file is empty or unrecognised",
  "Cookies распознаны частично": "Cookies partially recognised",
  "Cookies скопированы": "Cookies copied",
  "Email лид удалён": "Email lead deleted",
  "Email-лиды продавцов": "Seller email leads",
  "Email-ссылка открыта. Теперь можно выполнить вход и добавить аккаунт.": "The email link is open. You can now sign in and add the account.",
  "Gemini не вернул текстовый ответ.": "Gemini returned no text.",
  "KL отклонил запрос через все прокси, которые были испробованы. Похоже, пул исчерпан — проверьте его в настройках парсера.": "Kleinanzeigen rejected the request through every proxy tried. The pool looks exhausted — check it in the parser settings.",
  "KL_ADMIN_SYNC_KEY не настроен. Добавьте переменную окружения.": "KL_ADMIN_SYNC_KEY is not configured. Add the environment variable.",
  "Kleinanzeigen блокирует действие страницей согласия cookie/GDPR. Откройте Kleinanzeigen в браузере через этот же прокси, нажмите «Alle akzeptieren», затем повторите действие.": "Kleinanzeigen is blocking the action with its cookie/GDPR consent page. Open Kleinanzeigen in a browser through the same proxy, press «Alle akzeptieren», then try again.",
  "Kleinanzeigen блокирует отправку страницей согласия cookie/GDPR. Откройте Kleinanzeigen в браузере через этот же прокси, нажмите «Alle akzeptieren», затем повторите отправку.": "Kleinanzeigen is blocking the send with its cookie/GDPR consent page. Open Kleinanzeigen in a browser through the same proxy, press «Alle akzeptieren», then send again.",
  "Kleinanzeigen вернул ошибки формы редактирования.": "Kleinanzeigen returned errors from the edit form.",
  "Kleinanzeigen вернул ошибку для всех endpoints настроек (вероятно, антибот-блок или истёкшие cookies/прокси). Привязка номера могла быть выполнена раньше, но сейчас определить нельзя. Попробуйте обновить cookies или сменить прокси.": "Kleinanzeigen returned an error for every settings endpoint (most likely an anti-bot block, or expired cookies/proxy). The phone number may already have been linked earlier, but there is no way to tell right now. Try refreshing the cookies or switching the proxy.",
  "Kleinanzeigen вернул ошибку загрузки изображений.": "Kleinanzeigen returned an image upload error.",
  "Kleinanzeigen временно заблокировал IP-диапазон выбранного прокси. Повторять регистрацию через этот IP сейчас нельзя.": "Kleinanzeigen has temporarily blocked the chosen proxy's IP range. Registration cannot be retried through this IP for now.",
  "Kleinanzeigen временно ограничил запросы для аккаунта.": "Kleinanzeigen has temporarily rate-limited this account.",
  "Kleinanzeigen запросил captcha/challenge. Аккаунт временно поставлен на паузу.": "Kleinanzeigen asked for a captcha/challenge. The account has been paused for now.",
  "Kleinanzeigen запросил подтверждение телефона (\"Bist du's wirklich?\"). Подтвердите номер в аккаунте и повторите публикацию.": "Kleinanzeigen asked to verify the phone (\"Bist du's wirklich?\"). Confirm the number on the account and publish again.",
  "Kleinanzeigen не подтвердил отправку сообщения/фото. Повторите отправку.": "Kleinanzeigen did not confirm the message/photo was sent. Try sending again.",
  "Kleinanzeigen не подтвердил смену имени.": "Kleinanzeigen did not confirm the name change.",
  "Kleinanzeigen не применил действие к объявлению. Проверьте статус объявления и повторите попытку.": "Kleinanzeigen did not apply the action to the listing. Check the listing status and try again.",
  "Kleinanzeigen отвечает слишком долго через этот прокси при чтении PLZ. Попробуйте еще раз через 20-40 секунд.": "Kleinanzeigen is answering too slowly through this proxy while reading the postcode. Try again in 20-40 seconds.",
  "Kleinanzeigen отклонил данные регистрации.": "Kleinanzeigen rejected the registration details.",
  "Kleinanzeigen отклонил действие (доступ/CSRF). Попробуйте снова через несколько секунд.": "Kleinanzeigen rejected the action (access/CSRF). Try again in a few seconds.",
  "Kleinanzeigen отклонил запрос (403). Cookie при этом могут быть в порядке — чаще всего дело в IP прокси или защите от ботов. Повторите попытку или смените прокси.": "Kleinanzeigen rejected the request (403). The cookies may well be fine — usually it is the proxy's IP or bot protection. Try again, or switch the proxy.",
  "Kleinanzeigen отклонил запрос из-за слишком больших заголовков.": "Kleinanzeigen rejected the request because the headers were too large.",
  "Kleinanzeigen отклонил номер телефона для выбранной страны.": "Kleinanzeigen rejected the phone number for the chosen country.",
  "Kleinanzeigen отклонил номер телефона.": "Kleinanzeigen rejected the phone number.",
  "Kleinanzeigen отклонил регистрацию.": "Kleinanzeigen rejected the registration.",
  "Kleinanzeigen перенаправил на страницу логина. Проверьте актуальность cookies.": "Kleinanzeigen redirected to the login page. Check that the cookies are still valid.",
  "Kleinanzeigen перенаправляет на логин": "Kleinanzeigen redirects to the login page",
  "Kleinanzeigen показал капчу / challenge.": "Kleinanzeigen showed a captcha / challenge.",
  "Kleinanzeigen показал проверку «вы не робот». Повторите попытку через минуту.": "Kleinanzeigen showed an \"are you a robot\" check. Try again in a minute.",
  "Lead ID не указан.": "No lead ID given.",
  "Live-данные по объявлениям недоступны, отображены сохраненные данные.": "Live listing data is unavailable; the saved data is shown instead.",
  "Owner context отсутствует": "Owner context is missing",
  "PLZ (опц.)": "Postcode (opt.)",
  "PLZ аккаунта": "Account postcode",
  "PLZ не найден на странице, использован сохраненный PLZ.": "No postcode was found on the page, so the saved one was used.",
  "PLZ прокси": "Proxy postcode",
  "PicClick вернул 0 лотов (возможна блокировка/лимит источника). Предыдущие данные сохранены.": "PicClick returned 0 items — the source may be blocking or rate-limiting. The previous data has been kept.",
  "PicClick вернул пустые категории (возможна блокировка/изменение верстки). Предыдущие данные сохранены.": "PicClick returned no categories — the source may be blocking, or its markup changed. The previous data has been kept.",
  "PicClick вернул пустые категории. Проверьте доступность источника и повторите синхронизацию.": "PicClick returned no categories. Check that the source is reachable and sync again.",
  "PicClick заблокировал запрос через все прокси. Добавьте больше рабочих (DE) прокси и повторите.": "PicClick blocked the request through every proxy. Add more working German proxies and try again.",
  "SMS-код отправлен. Введите код из сообщения.": "The SMS code has been sent. Enter the code from the message.",
  "SMS-код телефона:": "Phone SMS code:",
  "SOCKS прокси: проверено только TCP-соединение (без handshake)": "SOCKS proxy: only the TCP connection was checked, without a handshake",
  "Sender задача остановлена": "Sender task stopped",
  "Sender запущен: {0} ссылок": "Sender started: {0} links",
  "Sender, диалоги и объявления в одном окне": "Sender, conversations and listings in one window",
  "Sender, диалоги, публикация объявлений и прокси — в одном рабочем контуре. Быстрый вход, прозрачные статусы, никакой ручной рутины.": "Sender, conversations, listing publication and proxies — in a single workflow. Fast sign-in, clear statuses, no manual routine.",
  "Sender-бот активен. Используйте кнопки меню.": "The Sender bot is active. Use the menu buttons.",
  "Sender-задача не найдена.": "Sender task not found.",
  "Shift+Enter для отправки, Enter для новой строки": "Shift+Enter to send, Enter for a new line",
  "TXT список ссылок загружен": "TXT link list loaded",
  "Telegram-бот": "Telegram bot",
  "accountId и categoryId/categoryUrl обязательны": "accountId and categoryId/categoryUrl are required",
  "accountId обязателен (или allowAll=1).": "accountId is required (or allowAll=1).",
  "accountId обязателен.": "accountId is required.",
  "debugId и file обязательны.": "debugId and file are required.",
  "debugId или requestId обязателен.": "debugId or requestId is required.",
  "debugId обязателен.": "debugId is required.",
  "https://... (опционально)": "https://... (optional)",
  "itemId обязателен.": "itemId is required.",
  "notificationId не указан": "notificationId is missing",
  "sessionId и file обязательны.": "sessionId and file are required.",
  "sessionId обязателен.": "sessionId is required.",
  "socks5://user:pass@host:port — по одному в строке": "socks5://user:pass@host:port — one per line",
  "{0} без наших опросов": "{0} without our polling",
  "{0} дн": "{0}d",
  "{0} из {1}": "{0} of {1}",
  "{0} мин": "{0} min",
  "{0} непрочит.": "{0} unread",
  "{0} просм.": "{0} views",
  "{0} ч": "{0} h",
  "{0} шт. в буфере обмена": "{0} copied to clipboard",
  "{0} — заголовки на Kleinanzeigen латиницей, такое слово ничего не найдёт.": "{0} — Kleinanzeigen titles use the Latin alphabet, so this word will never match.",
  "{0}: удаление объявлений у всех {1}.": "{0}: deleting listings for everyone {1}.",
  "{0}д {1}ч": "{0}d {1}h",
  "{0}мс": "{0}ms",
  "{0}ч": "{0}h",
  "© 2026 umbrella. Все права защищены.": "© 2026 umbrella. All rights reserved.",
  "« В начало": "« First page",
  "· всплесков:": "· spikes:",
  "· до": "· until",
  "· обязательно": "· required",
  "» будет удален без возможности восстановления.": "» will be deleted permanently.",
  "Автоответы": "Auto-replies",
  "Администратор": "Administrator",
  "Администратор создан": "Administrator created",
  "Администрирование": "Administration",
  "Адрес": "Address",
  "Адрес / вставьте прокси целиком": "Address / paste the whole proxy",
  "Аккаунт": "Account",
  "Аккаунт #{0}": "Account #{0}",
  "Аккаунт Offline": "Account offline",
  "Аккаунт Sender не найден или недоступен.": "The Sender account was not found or is unavailable.",
  "Аккаунт Sender не найден.": "Sender account not found.",
  "Аккаунт {0}": "Account {0}",
  "Аккаунт временно ограничен (429).": "The account is temporarily rate-limited (429).",
  "Аккаунт временно ограничен anti-bot системой Kleinanzeigen.": "The account is temporarily limited by Kleinanzeigen's anti-bot system.",
  "Аккаунт заблокирован Kleinanzeigen.": "The account has been blocked by Kleinanzeigen.",
  "Аккаунт заблокирован или отклонен при входе.": "The account was blocked or rejected during sign-in.",
  "Аккаунт заблокирован при входе.": "The account was blocked during sign-in.",
  "Аккаунт зарегистрирован и добавлен": "Account registered and added",
  "Аккаунт зарегистрирован, вход подтвержден, аккаунт сохранен.": "The account was registered, the sign-in confirmed and the account saved.",
  "Аккаунт лида не найден или недоступен.": "The lead's account was not found or is unavailable.",
  "Аккаунт не в статусе Active.": "The account is not in the Active state.",
  "Аккаунт не выбран": "No account selected",
  "Аккаунт не найден": "Account not found",
  "Аккаунт не найден или недоступен.": "The account was not found or is unavailable.",
  "Аккаунт не передан": "No account given",
  "Аккаунт обнаружен": "Account detected",
  "Аккаунт обновлен": "Account updated",
  "Аккаунт отклонен при входе после регистрации.": "The account was rejected when signing in after registration.",
  "Аккаунт отключен": "Account disabled",
  "Аккаунт перенаправляет на einloggen. Обновите cookies (аккаунт исключен из загрузки сообщений).": "The account redirects to einloggen. Refresh the cookies — it has been excluded from message loading.",
  "Аккаунт пока не помечен как Sender-аккаунт.": "The account is not marked as a Sender account yet.",
  "Аккаунт с этими cookies уже добавлен. Возвращаем существующую запись.": "An account with these cookies already exists. Returning the existing record.",
  "Аккаунт требует повторного входа.": "The account needs to sign in again.",
  "Аккаунт удален": "Account deleted",
  "Аккаунт уже был добавлен. Возвращаем существующую запись.": "This account has already been added. Returning the existing record.",
  "Аккаунт черновика не найден": "The draft's account was not found",
  "Аккаунт-отправитель": "Sending account",
  "Аккаунтов подключено": "Accounts connected",
  "Аккаунты": "Accounts",
  "Аккаунты пока не добавлены": "No accounts added yet",
  "Аккаунты:": "Accounts:",
  "Активация": "Activation",
  "Активация...": "Activating...",
  "Активен": "Active",
  "Активен до {0}": "Active until {0}",
  "Активировать": "Activate",
  "Активна": "Active",
  "Активная заморозка не найдена": "No active freeze found",
  "Активная подписка не найдена": "No active subscription found",
  "Активно": "Active",
  "Активной Sender-задачи нет. Запустите новую или выберите из истории ниже.": "There is no active Sender task. Start a new one or pick from the history below.",
  "Активные объявления": "Active listings",
  "Активных объявлений не найдено.": "No active listings found.",
  "Анализ": "Analysis",
  "Артефакты не найдены.": "No artifacts found.",
  "Архив пуст для вкладки {0}": "The archive is empty for the {0} tab",
  "Архивировать диалог": "Archive conversation",
  "Аудитория": "Audience",
  "Аудитория уведомления": "Notification audience",
  "Базовая задержка": "Base delay",
  "Без аккаунта": "No account",
  "Без заголовка": "No title",
  "Без имени": "No name",
  "Без названия": "Untitled",
  "Без объявления": "No listing",
  "Без описания": "No description",
  "Без привязки к объявлению": "Not linked to a listing",
  "Без прокси": "No proxy",
  "Без промокода": "No promo code",
  "Без пушей": "No boosts",
  "Больше просмотров": "Most views",
  "Браузер не дал доступ к буферу обмена": "The browser denied clipboard access",
  "Браузер не запущен: прокси аккаунта непригоден, а без него запрос раскрыл бы IP сервера.": "The browser was not started: the account's proxy is unusable, and without it the request would expose the server's IP.",
  "Браузерная очередь занята. Подождите 20-40 секунд и повторите попытку.": "The browser queue is busy. Wait 20-40 seconds and try again.",
  "Браузерный движок временно перегружен. Повторите запрос через 20-40 секунд.": "The browser engine is overloaded for the moment. Try again in 20-40 seconds.",
  "Браузерный движок временно перегружен. Повторите запуск Sender через 20-40 секунд.": "The browser engine is overloaded for the moment. Start Sender again in 20-40 seconds.",
  "Браузерный движок временно перегружен. Повторите попытку через 20-40 секунд.": "The browser engine is overloaded for the moment. Try again in 20-40 seconds.",
  "Браузерный движок перегружен, использован сохраненный PLZ.": "The browser engine is overloaded, so the saved postcode was used.",
  "Браузерный движок сервера временно перегружен. Черновик будет повторно отправлен автоматически.": "The server's browser engine is overloaded for the moment. The draft will be resubmitted automatically.",
  "Быстрее растут": "Fastest growing",
  "Быстрые ответы": "Quick replies",
  "Быстрый": "Fast",
  "Быстрый выбор категории": "Quick category picker",
  "Быстрый ответ не найден.": "Quick reply not found.",
  "В cookie нет CSRF-TOKEN.": "The cookies contain no CSRF-TOKEN.",
  "В избранное": "Add to favourites",
  "В избранном": "In favourites",
  "В избранном пусто — отметьте объявления сердечком на карточке.": "Favourites are empty — mark listings with the heart on the card.",
  "В сообщении обнаружены русские буквы. Отправить сообщение?": "The message contains Cyrillic letters. Send it anyway?",
  "В черновик": "Save as draft",
  "В черновике не выбрана категория": "The draft has no category selected",
  "В черновике не заполнены обязательные поля": "The draft is missing required fields",
  "Ваш профиль": "Your profile",
  "Введите SMS-код, который пришел на указанный телефон.": "Enter the SMS code sent to that phone.",
  "Введите длинное сообщение...": "Enter a long message...",
  "Введите желаемый логин:": "Enter the username you want:",
  "Введите заголовок рассылки.": "Enter a broadcast title.",
  "Введите заголовок уведомления.": "Enter a notification title.",
  "Введите запрос или выберите категорию.": "Enter a query or pick a category.",
  "Введите корректное имя (2–40 символов).": "Enter a valid name (2–40 characters).",
  "Введите корректное имя профиля (2-40 символов).": "Enter a valid profile name (2-40 characters).",
  "Введите корректную цену числом:": "Enter a valid price as a number:",
  "Введите корректную цену:": "Enter a valid price:",
  "Введите корректный 5-значный почтовый индекс (PLZ):": "Enter a valid 5-digit postcode:",
  "Введите корректный IBAN.": "Enter a valid IBAN.",
  "Введите корректный PayPal email.": "Enter a valid PayPal email.",
  "Введите корректный PayPal тег.": "Enter a valid PayPal tag.",
  "Введите корректный SMS-код телефона": "Enter a valid phone SMS code",
  "Введите корректный SMS-код телефона.": "Enter a valid phone SMS code.",
  "Введите корректный код подтверждения.": "Enter a valid confirmation code.",
  "Введите корректный номер телефона (без кода страны).": "Enter a valid phone number (without the country code).",
  "Введите логин и пароль": "Enter your username and password",
  "Введите логин:": "Enter your username:",
  "Введите минимум 2 символа": "Enter at least 2 characters",
  "Введите новый номер для смены. Код придет в SMS.": "Enter the new number. The code will arrive by SMS.",
  "Введите номер без префикса страны. Код придет в SMS.": "Enter the number without the country prefix. The code will arrive by SMS.",
  "Введите описание (10-4000 символов)": "Enter a description (10-4000 characters)",
  "Введите ответ...": "Type a reply...",
  "Введите пароль (минимум 6 символов):": "Enter a password (at least 6 characters):",
  "Введите пароль:": "Enter your password:",
  "Введите промокод или '-'": "Enter a promo code, or '-'",
  "Введите промокод одним сообщением или отправьте '-' без промокода.": "Send the promo code in one message, or send '-' for none.",
  "Введите реквизиты.": "Enter the payment details.",
  "Введите текст": "Enter text",
  "Введите текст быстрого ответа.": "Enter the quick reply text.",
  "Введите текст запроса для AI ассистента.": "Enter a prompt for the AI assistant.",
  "Введите текст ответа": "Enter the reply text",
  "Введите текст рассылки.": "Enter the broadcast text.",
  "Введите текст уведомления.": "Enter the notification text.",
  "Введите текущий и новый пароль": "Enter the current and the new password",
  "Вернуть из архива": "Restore from archive",
  "Вернуться к первой странице": "Back to the first page",
  "Включить заморозку": "Enable freeze",
  "Включить приватный режим": "Enable private mode",
  "Внимание": "Warning",
  "Внутренняя ошибка": "Internal error",
  "Внутри панели": "Inside the panel",
  "Возможности": "Features",
  "Войдите в систему и продолжайте работу": "Sign in and pick up where you left off",
  "Войти": "Sign in",
  "Войти в систему": "Sign in",
  "Войти и добавить": "Sign in and add",
  "Вопрос или команда...": "A question or a command...",
  "Вопросы покупателя (": "Buyer questions (",
  "Восстанавливаем сессию...": "Restoring the session...",
  "Вперёд →": "Next →",
  "Время добавлено": "Time added",
  "Время публикации должно быть в будущем": "The publication time must be in the future",
  "Все": "All",
  "Все аккаунты.": "All accounts.",
  "Все диалоги, уведомления и лиды в одном окне с быстрым переключением контекстов.": "Every conversation, notification and lead in one window, with fast context switching.",
  "Все категории": "All categories",
  "Все категории уже в кеше": "Every category is already cached",
  "Все прокси проверены.": "All proxies checked.",
  "Все разделы": "All sections",
  "Все сервисы недоступны через прокси": "No service is reachable through this proxy",
  "Всего": "Total",
  "Всего на мониторинге: {0}": "Total monitored: {0}",
  "Всего: {0} · Запланировано: {1}": "Total: {0} · Scheduled: {1}",
  "Всем активным": "All active",
  "Всем пользователям": "All users",
  "Вставить в поле ответа": "Insert into the reply box",
  "Вставить текст": "Paste text",
  "Вставьте содержимое файла куки здесь...": "Paste the contents of the cookie file here...",
  "Вставьте ссылку на товар eBay.": "Paste an eBay item link.",
  "Вставьте ссылку подтверждения из письма": "Paste the confirmation link from the email",
  "Вставьте ссылку подтверждения из письма и продолжите.": "Paste the confirmation link from the email and continue.",
  "Вставьте ссылку подтверждения из письма.": "Paste the confirmation link from the email.",
  "Встроенный": "Built-in",
  "Встроенный прокси": "Built-in proxy",
  "Встроенный прокси Umbrella": "Built-in Umbrella proxy",
  "Встроенный прокси панели нельзя удалить.": "The panel's built-in proxy cannot be deleted.",
  "Вход": "Sign in",
  "Вход выполнен автоматически.": "Signed in automatically.",
  "Вход не завершен — неизвестная страница.": "The sign-in did not finish — unknown page.",
  "Вход по логину и паролю · owner-изоляция данных": "Username and password sign-in · per-owner data isolation",
  "Вход после регистрации выполнен успешно.": "Signed in successfully after registration.",
  "Входящие сообщения от покупателей": "Incoming messages from buyers",
  "Вчера": "Yesterday",
  "Вы": "You",
  "Вы вышли из аккаунта.": "You have signed out.",
  "Вы: {0}": "You: {0}",
  // Автообновление сообщений (настройки).
  "Обновление сообщений": "Message updates",
  "Автообновление сообщений": "Message auto-refresh",
  "Как часто панель проверяет новые сообщения на ваших аккаунтах.": "How often the panel checks your accounts for new messages.",
  "Интервал автообновления сообщений": "Message auto-refresh interval",
  "1 мин": "1 min",
  "2 мин": "2 min",
  "5 мин": "5 min",
  "10 мин": "10 min",
  "Новые сообщения и уведомления в Telegram — в течение минуты. Так по умолчанию.": "New messages and Telegram notifications arrive within a minute. This is the default.",
  "Новые сообщения и уведомления в Telegram — в течение 2 минут.": "New messages and Telegram notifications arrive within 2 minutes.",
  "Новые сообщения и уведомления в Telegram — в течение 5 минут.": "New messages and Telegram notifications arrive within 5 minutes.",
  "Новые сообщения и уведомления в Telegram — в течение 10 минут.": "New messages and Telegram notifications arrive within 10 minutes.",
  "Диалог «{0}»: {1}": "Dialog “{0}”: {1}",
  "Выберите": "Select",
  "Выберите <b>тип цены</b>:": "Choose the <b>price type</b>:",
  "Выберите аккаунт": "Select an account",
  "Выберите аккаунт Sender": "Select a Sender account",
  "Выберите аккаунт Sender.": "Select a Sender account.",
  "Выберите аккаунт для черновика": "Select an account for the draft",
  "Выберите аккаунт, чтобы загрузить параметры категории": "Select an account to load the category fields",
  "Выберите аккаунт, чтобы загрузить параметры категории.": "Select an account to load the category fields.",
  "Выберите дату и время публикации": "Choose the publication date and time",
  "Выберите диалог": "Select a conversation",
  "Выберите диалог из списка слева для просмотра сообщений и ответа": "Pick a conversation on the left to read and reply",
  "Выберите диалог.": "Select a conversation.",
  "Выберите категорию": "Select a category",
  "Выберите код страны.": "Select a country code.",
  "Выберите прокси": "Select a proxy",
  "Выберите прокси для аккаунта": "Select a proxy for the account",
  "Выберите прокси для аккаунта.": "Select a proxy for the account.",
  "Выберите прокси для регистрации": "Select a proxy for registration",
  "Выберите прокси для регистрации.": "Select a proxy for the registration.",
  "Выберите прокси кликом. Для текущего прокси выбор отключен.": "Click to pick a proxy. The current one cannot be selected.",
  "Выберите прокси:": "Select a proxy:",
  "Выберите реквизиты.": "Select the payment details.",
  "Выберите способ добавления": "Choose how to add it",
  "Выберите…": "Select…",
  "Выбираем категорию": "Choosing the category",
  "Выбор сохраняется в этом браузере. Тексты от Kleinanzeigen остаются на языке оригинала.": "The choice is saved in this browser. Text coming from Kleinanzeigen stays in its original language.",
  "Выбранные реквизиты не найдены.": "The selected payment details were not found.",
  "Выбранный прокси не найден": "The selected proxy was not found",
  "Выбрано": "Selected",
  "Выбрано файлов:": "Files selected:",
  "Выйти": "Sign out",
  "Выйти из аккаунта": "Sign out",
  "Выключить приватный режим": "Disable private mode",
  "Выполняется...": "Running...",
  "Выполняю…": "Working…",
  "Гибкие сценарии ответов, статусы по лидам и передача диалога оператору.": "Flexible reply scenarios, lead statuses and handing a conversation to an operator.",
  "Готов к использованию": "Ready to use",
  "Готово": "Done",
  "Готово к публикации": "Ready to publish",
  "Граббер не нашел данных на странице.": "The grabber found no data on the page.",
  "Графит": "Graphite",
  "Данные аккаунта успешно обновлены": "Account details updated",
  "Данные объявления загружены, но фото скачать/подготовить не удалось.": "The listing data loaded, but the photos could not be downloaded or prepared.",
  "Данные объявления не переданы": "No listing data was supplied",
  "Данных мало — график появится после нескольких проверок.": "Not enough data yet — the chart appears after a few checks.",
  "Дата регистрации ещё не получена. Добавлен в панель: {0}": "The registration date has not been fetched yet. Added to the panel: {0}",
  "Дашборд": "Dashboard",
  "Движок браузера на сервере временно перегружен. Повторите попытку через 10-20 секунд.": "The server's browser engine is overloaded for the moment. Try again in 10-20 seconds.",
  "Действие в сообщениях заняло слишком много времени. Проверьте прокси аккаунта и попробуйте снова.": "The message action took too long. Check the account's proxy and try again.",
  "Действие временно ограничено для защиты аккаунта.": "The action is limited for now, to protect the account.",
  "Действие временно ограничено.": "The action is limited for now.",
  "Действие для этого аккаунта уже выполняется.": "An action is already running for this account.",
  "Действие для этого аккаунта уже выполняется. Дождитесь завершения и попробуйте снова.": "An action is already running for this account. Wait for it to finish and try again.",
  "Действие необратимо": "This cannot be undone",
  "Действие отменено.": "The action was cancelled.",
  "Действия": "Actions",
  "Диалог": "Conversation",
  "Диалог в Kleinanzeigen не успел прогрузиться (загрузка/скелетон). Обновите диалог и попробуйте снова.": "The Kleinanzeigen conversation had not finished loading. Refresh it and try again.",
  "Диалог не выбран": "No conversation selected",
  "Диалог не найден. Обновите сообщения.": "Conversation not found. Refresh the messages.",
  "Диалоги": "Conversations",
  "Длинное сообщение": "Long message",
  "Для AI ассистента нужен accountId (запрос выполняется через прокси аккаунта).": "The AI assistant needs an accountId — the request goes through that account's proxy.",
  "Для аккаунта Sender не назначен валидный прокси.": "The Sender account has no valid proxy assigned.",
  "Для аккаунта Sender нужен валидный прокси.": "The Sender account needs a valid proxy.",
  "Для аккаунта лида не назначен прокси.": "The lead's account has no proxy assigned.",
  "Для аккаунта не назначен валидный прокси.": "The account has no valid proxy assigned.",
  "Для аккаунта не назначен прокси.": "The account has no proxy assigned.",
  "Для аккаунта черновика не назначен валидный прокси": "The draft's account has no valid proxy assigned",
  "Для выбранной аудитории укажите хотя бы один ownerId.": "For the chosen audience, give at least one ownerId.",
  "Для выбранной категории нет дополнительных параметров.": "The selected category has no extra fields.",
  "Для выбранных категорий нет ссылок на PicClick.": "There are no PicClick links for the chosen categories.",
  "Для добавления аккаунта нужен прокси.": "Adding an account requires a proxy.",
  "Для обновления аккаунта нужен прокси.": "Refreshing an account requires a proxy.",
  "Для отправки фото нужен conversationId диалога. Откройте диалог и попробуйте снова.": "Sending a photo needs the conversation id. Open the conversation and try again.",
  "Для перевода сообщений нужен accountId (перевод выполняется через прокси аккаунта).": "Translating messages needs an accountId — the translation goes through that account's proxy.",
  "Для перевода требуется рабочий прокси аккаунта (без прокси перевод не выполняется).": "Translation requires a working proxy on the account; without one it does not run.",
  "Для пользователя не задан ownerId": "The user has no ownerId set",
  "Для прогрева нужен прокси, привязанный к аккаунту.": "A warm-up needs a proxy linked to the account.",
  "Для продолжения работы оформите подписку через Telegram-бота.": "To continue, take out a subscription through the Telegram bot.",
  "Для текущего тарифа заморозка недоступна.": "Freezing is not available on the current plan.",
  "Для удаления передайте adId или adHref/adTitle + accountId": "To delete, pass adId, or adHref/adTitle together with accountId",
  "Для этого аккаунта включена пауза безопасности. Подождите и повторите попытку.": "A safety pause is active for this account. Wait and try again.",
  "Для этого аккаунта выбор кода страны недоступен в текущей форме Kleinanzeigen.": "Choosing a country code is not available for this account in the current Kleinanzeigen form.",
  "Для этого аккаунта уже выполняется действие. Дождитесь завершения текущей операции.": "An action is already running for this account. Wait for it to finish.",
  "Для этого аккаунта уже выполняется другое действие. Повторите запуск позже.": "Another action is already running for this account. Start again later.",
  "Для этого аккаунта уже выполняется другое действие. Повторите позже.": "Another action is already running for this account. Try again later.",
  "Для этого аккаунта уже выполняется публикация. Дождитесь завершения и запустите публикацию снова.": "A publication is already running for this account. Wait for it to finish and start again.",
  "Для этого аккаунта уже выполняется публикация. Дождитесь завершения текущей попытки.": "A publication is already running for this account. Wait for the current attempt to finish.",
  "Для этого лида уже выполняется отправка 3-го сообщения.": "The 3rd message is already being sent for this lead.",
  "Для этого пользователя лимит промокода исчерпан": "This user has used up the promo code's limit",
  "Для этого тарифа заморозка недоступна": "Freezing is not available on this plan",
  "Для этой категории нужно выбрать минимум один способ доставки.": "This category needs at least one delivery method.",
  "Дни заморозки (необязательно)": "Freeze days (optional)",
  "Добавить": "Add",
  "Добавить аккаунт": "Add account",
  "Добавить аккаунт(ы)": "Add account(s)",
  "Добавить время": "Add time",
  "Добавить из текста": "Add from text",
  "Добавить прокси": "Add proxy",
  "Добавить слово": "Add a word",
  "Добавить фото": "Add photos",
  "Добавление {0}/{1}...": "Adding {0}/{1}...",
  "Добавление...": "Adding...",
  "Добавлено {0} из {1}.\\nОшибок: {2}{3}": "Added {0} of {1}.\\nErrors: {2}{3}",
  "Добавлено аккаунтов: {0}": "Accounts added: {0}",
  "Добавлено прокси: {0}": "Proxies added: {0}",
  "Добавлено: {0}. Не распознано: {1}": "Added: {0}. Not recognised: {1}",
  "Добавьте txt-список ссылок": "Add a txt list of links",
  "Добавьте аккаунты, прокси и настройте сценарии.": "Add accounts and proxies, then set up your scenarios.",
  "Добавьте первый аккаунт, чтобы начать работу": "Add your first account to get started",
  "Добавьте первый прокси в форме выше, чтобы выполнять действия через аккаунты": "Add your first proxy in the form above so accounts can act through it",
  "Добавьте свой первый прокси для использования с Kleinanzeigen": "Add your first proxy to use with Kleinanzeigen",
  "Добавьте шаблоны ответов ниже.": "Add reply templates below.",
  "Добро пожаловать. Войдите или зарегистрируйтесь, чтобы использовать Sender.": "Welcome. Sign in or register to use Sender.",
  "Договорная (VB)": "Negotiable (VB)",
  "Дождитесь загрузки параметров категории": "Wait for the category fields to load",
  "Доставка": "Delivery",
  "Достигнут лимит": "Limit reached",
  "Достигнут лимит: не более {0} отправленных реквизитов.": "Limit reached: no more than {0} sets of payment details may be sent.",
  "Доступ в панель": "Panel access",
  "Доступ запрещен.": "Access denied.",
  "Доступ отклонен при входе.": "Access was denied during sign-in.",
  "Дублировать в Telegram": "Mirror to Telegram",
  "Если код не пришел — отправьте повторно.": "If the code did not arrive, send it again.",
  "Если оставить пустым, будет использовано текущее описание объявления.": "Leave empty to use the listing's current description.",
  "Ещё": "More",
  "Ещё нет доступа? ": "No access yet? ",
  "Ждем подтверждение от Kleinanzeigen": "Waiting for confirmation from Kleinanzeigen",
  "Жирный": "Bold",
  "Жирный курсивный": "Bold italic",
  "Жирный курсивный с засечками": "Bold italic serif",
  "Жирный с засечками": "Bold serif",
  "Забираю данные со страницы eBay...": "Fetching data from the eBay page...",
  "Забрать": "Fetch",
  "Забрать cookies": "Fetch cookies",
  "Завершено с ошибкой": "Finished with an error",
  "Заголовки cookie слишком большие. Очистите трекинг-cookie и повторите.": "The cookie headers are too large. Clear the tracking cookies and try again.",
  "Заголовок": "Title",
  "Заголовок не может быть пустым. Введите текст:": "The title cannot be empty. Enter some text:",
  "Заголовок уведомления": "Notification title",
  "Загружаем Sender...": "Loading Sender...",
  "Загружаем email-лиды...": "Loading email leads...",
  "Загружаем описание…": "Loading the description…",
  "Загружаем параметры категории...": "Loading category fields...",
  "Загружаем статус мониторинга...": "Loading monitoring status...",
  "Загружаем фотографии": "Uploading photos",
  "Загружаем…": "Loading…",
  "Загружаю диалоги…": "Loading conversations…",
  "Загружаю полный текст...": "Loading the full text...",
  "Загружаю фото {0}/{1}...": "Uploading photo {0}/{1}...",
  "Загружаю…": "Loading…",
  "Загружено файлов:": "Files uploaded:",
  "Загрузите файл .txt": "Upload a .txt file",
  "Загрузить .txt": "Upload .txt",
  "Загрузить файл": "Upload file",
  "Загрузка диалога...": "Loading the conversation...",
  "Загрузка инструментов...": "Loading tools...",
  "Загрузка параметров категории...": "Loading category fields...",
  "Загрузка черновиков...": "Loading drafts...",
  "Загрузка...": "Loading...",
  "Задачи Sender по аккаунтам": "Sender tasks by account",
  "Закрепить диалог": "Pin conversation",
  "Закрыть": "Close",
  "Закрыть просмотр изображения": "Close image viewer",
  "Заменить текущие фото (иначе новые добавятся к существующим)": "Replace the current photos (otherwise new ones are added to them)",
  "Заморозка включена": "Freeze enabled",
  "Заморозка отключена": "Freeze disabled",
  "Заморозка подписки": "Subscription freeze",
  "Заморозка уже активна для этой подписки": "A freeze is already active on this subscription",
  "Запланировано": "Scheduled",
  "Запланировано на:": "Scheduled for:",
  "Запланировано:": "Scheduled:",
  "Запланировать": "Schedule",
  "Заполните 1-е сообщение": "Fill in the 1st message",
  "Заполните 2-е сообщение": "Fill in the 2nd message",
  "Заполните 3-е сообщение": "Fill in the 3rd message",
  "Заполните email, пароль и имя профиля": "Fill in the email, password and profile name",
  "Заполните адрес и порт прокси": "Fill in the proxy address and port",
  "Заполните все обязательные поля": "Fill in every required field",
  "Заполните все поля для смены пароля": "Fill in every field to change the password",
  "Заполните заголовок, описание и цену": "Fill in the title, description and price",
  "Заполните обязательные параметры категории: {0}": "Fill in the required category fields: {0}",
  "Заполните обязательные поля": "Fill in the required fields",
  "Заполните обязательные поля объявления": "Fill in the listing's required fields",
  "Заполните: {0}": "Fill in: {0}",
  "Заполните: {0} и ещё {1}": "Fill in: {0} and {1} more",
  "Заполняем и валидируем поля объявления": "Filling in and validating the listing fields",
  "Заполняем и отправляем форму": "Filling in and submitting the form",
  "Запуск браузера": "Starting the browser",
  "Запуск браузера...": "Starting the browser...",
  "Запуск задач": "Starting tasks",
  "Запускаем попытку публикации": "Starting a publication attempt",
  "Запускаем публикацию черновика": "Publishing the draft",
  "Запустить Sender": "Start Sender",
  "Зарегистрирован {0}": "Registered {0}",
  "Аккаунт добавил {0}": "Account added by {0}",
  "Зарезервировано": "Reserved",
  "Звук": "Sound",
  "Звук при новом сообщении": "Sound on a new message",
  "Здесь появится текст выбранным шрифтом": "Your text will appear here in the chosen font",
  "Значение не может быть пустым:": "The value cannot be empty:",
  "Избранное": "Favourites",
  "Изображение не найдено.": "Image not found.",
  "Импорт завершен.": "Import finished.",
  "Импорт завершен: {0}.": "Import finished: {0}.",
  "Импорт ссылок": "Import links",
  "Импорт...": "Importing...",
  "Имя профиля обновлено.": "Profile name updated.",
  "Имя профиля:": "Profile name:",
  "Инбокс, лиды и автоответы": "Inbox, leads and auto-replies",
  "Инструменты": "Tools",
  "Инструменты сообщений": "Message tools",
  "Искать сейчас": "Search now",
  "Использован сохраненный PLZ прокси.": "The saved proxy postcode was used.",
  "Используйте /api/debug/message-actions/log?requestId=... чтобы найти debugId.": "Use /api/debug/message-actions/log?requestId=... to find the debugId.",
  "История запусков": "Run history",
  "История цены": "Price history",
  "Исходный текст": "Original text",
  "Ищем новые...": "Searching...",
  "К активному предложению": "To the active offer",
  "Как работает": "How it works",
  "Как это работает": "How it works",
  "Категории": "Categories",
  "Категории PicClick пока не загружены. Запустите синхронизацию.": "The PicClick categories have not loaded yet. Run a sync.",
  "Категории не найдены": "No categories found",
  "Категория": "Category",
  "Категория {0}": "Category {0}",
  "Категория выбрана": "Category selected",
  "Категория не выбрана": "No category selected",
  "Категория объявления не определена.": "The listing's category could not be determined.",
  "Категория:": "Category:",
  "Кнопка «Отправить 3-е сообщение» приходит в уведомлении о найденном email.": "The «Send the 3rd message» button arrives with the notification about the email that was found.",
  "Кнопка повторной отправки не найдена.": "The resend button was not found.",
  "Код активен до": "Code valid until",
  "Код из SMS": "Code from the SMS",
  "Код отправлен повторно.": "The code has been resent.",
  "Код отправлен. Введите SMS-код для подтверждения номера.": "The code has been sent. Enter the SMS code to confirm the number.",
  "Код подтверждения неверный.": "The confirmation code is wrong.",
  "Код пока нельзя отправить повторно. Подождите немного.": "The code cannot be resent yet. Wait a moment.",
  "Код страны": "Country code",
  "Код уже запрошен. Введите код подтверждения.": "A code has already been requested. Enter the confirmation code.",
  "Код на этот номер уже отправлен. Введите его или нажмите «Отправить код снова».": "A code has already been sent to this number. Enter it or press “Send the code again”.",
  "Комментарий": "Comment",
  "Коммерческий": "Commercial",
  "Контекст диалога": "Conversation context",
  "Контекст сообщений не передан.": "No message context was supplied.",
  "Контроль": "Control",
  "Копируем...": "Copying...",
  "Куки валидны, аккаунт сохранен": "The cookies are valid; the account has been saved",
  "Куки невалидны": "The cookies are invalid",
  "Купить подписку в Telegram": "Buy a subscription in Telegram",
  "Курсивный": "Italic",
  "Курсивный с засечками": "Italic serif",
  "Лид не найден.": "Lead not found.",
  "Лиды появятся автоматически после первых ответов.": "Leads appear automatically once the first replies come in.",
  "Лимит времени заморозки исчерпан": "The freeze time allowance is used up",
  "Лимит заморозок исчерпан": "The freeze allowance is used up",
  "Лимит фото: {0}. Лишние файлы пропущены.": "Photo limit: {0}. The extra files were skipped.",
  "Лимит:": "Limit:",
  "Логин": "Username",
  "Логин Telegram не указан": "No Telegram username given",
  "Логин должен быть не короче 3 символов": "The username must be at least 3 characters",
  "Логин может содержать только латиницу, цифры, '.', '_' и '-'": "The username may contain only Latin letters, digits, '.', '_' and '-'",
  "Логин слишком длинный": "The username is too long",
  "Логин:": "Username:",
  "Логин: {0}": "Username: {0}",
  "Локация": "Location",
  "Любая": "Any",
  "Любой": "Any",
  "Массовая отправка приветствий продавцам и диалог по ответам": "Bulk greetings to sellers, and a conversation once they reply",
  "Массовая рассылка с персонализацией, шаблонами и автосценариями по каждому аккаунту.": "Bulk outreach with personalisation, templates and per-account automation.",
  "Медленный": "Slow",
  "Минимум 8 символов": "At least 8 characters",
  "Модалка подтверждения недоступна.": "The confirmation dialog is unavailable.",
  "Можно выбрать максимум {0} фото.": "You can select at most {0} photos.",
  "Мои реквизиты": "My payment details",
  "Мониторинг ответов": "Reply monitoring",
  "Мониторинг прокси, статусов аккаунтов и соединений с автопроверкой пула.": "Monitoring of proxies, account statuses and connections, with automatic pool checks.",
  "Моноширинный": "Monospace",
  "Мультиаккаунт-инбокс": "Multi-account inbox",
  "На модерации": "Under review",
  "На рассмотрении": "Pending",
  "Навигация по категориям": "Category navigation",
  "Нажмите \"Обновить\" для загрузки": "Press \"Refresh\" to load",
  "Нажмите «Обновить» у аккаунта, чтобы подтянуть ссылку профиля.": "Press «Refresh» on the account to pull in its profile link.",
  "Назад": "Back",
  "Название": "Title",
  "Название объявления": "Listing title",
  "Название объявления не заполнено.": "The listing title is empty.",
  "Название слишком длинное. Максимум {0} символов.": "The title is too long. Maximum {0} characters.",
  "Назначенный прокси не найден или недоступен.": "The assigned proxy was not found, or is unavailable.",
  "Найден устаревший статус публикации. Запускаю новую попытку.": "A stale publication status was found. Starting a new attempt.",
  "Напишите задачу или используйте кнопки снизу: «Перевод», «Ответ», «Анализ».": "Describe the task, or use the buttons below: «Translate», «Reply», «Analyse».",
  "Например:\\n{0}": "For example:\\n{0}",
  "Настройки": "Settings",
  "Настройки Sender недоступны.": "The Sender settings are unavailable.",
  "Настройки Sender сохранены": "Sender settings saved",
  "Настройки из бота:": "Settings from the bot:",
  "Начать регистрацию": "Start registration",
  "Начните вводить категорию...": "Start typing a category...",
  "Не все фотографии были добавлены в форму редактирования.": "Not every photo made it into the edit form.",
  "Не выбрана": "Not selected",
  "Не добавлено": "Not added",
  "Не заполнен заголовок объявления.": "The listing title is empty.",
  "Не заполнен почтовый индекс.": "The postcode is empty.",
  "Не заполнена категория объявления.": "The listing category is empty.",
  "Не заполнена цена объявления.": "The listing price is empty.",
  "Не заполнено описание объявления.": "The listing description is empty.",
  "Не найден идентификатор email-активации.": "The email activation id was not found.",
  "Не найден идентификатор диалога.": "The conversation id was not found.",
  "Не найдено валидных ссылок объявлений Kleinanzeigen.": "No valid Kleinanzeigen listing links were found.",
  "Не найдено поле ввода SMS-кода подтверждения.": "The SMS confirmation code field was not found.",
  "Не найдено поле ввода номера телефона.": "The phone number field was not found.",
  "Не найдено поле имени в текущей форме Kleinanzeigen для этого аккаунта.": "No name field was found in the current Kleinanzeigen form for this account.",
  "Не передан идентификатор сессии подтверждения.": "No confirmation session id was given.",
  "Не получили sessionId": "No sessionId received",
  "Не привязан": "Not linked",
  "Не проверен": "Not checked",
  "Не работает": "Not working",
  "Не работают": "Not working",
  "Не удалось автоматически выбрать платные опции Top-Anzeige и Galerie на финальном шаге публикации.": "Could not select the paid Top-Anzeige and Galerie options automatically on the final publication step.",
  "Не удалось автоматически выбрать платные опции Top-Anzeige и Galerie перед публикацией.": "Could not select the paid Top-Anzeige and Galerie options automatically before publishing.",
  "Не удалось активировать": "Could not activate",
  "Не удалось включить заморозку": "Could not enable the freeze",
  "Не удалось войти": "Could not sign in",
  "Не удалось войти после регистрации.": "Could not sign in after registration.",
  "Не удалось выбрать код страны.": "Could not select the country code.",
  "Ошибка входа через Telegram": "Telegram sign-in error",
  "Не удалось подтвердить вход из Telegram. Откройте панель кнопкой в боте ещё раз.": "Couldn't confirm the Telegram sign-in. Open the panel from the bot button again.",
  "Этот Telegram не привязан к аккаунту панели. Войдите в боте или здесь — логином и паролем.": "This Telegram isn't linked to a panel account. Sign in via the bot or here with your username and password.",
  "Cookie аккаунта слишком большие — Kleinanzeigen не принимает запрос. Обновите cookie.": "The account's cookies are too large — Kleinanzeigen rejects the request. Update the cookies.",
  "Прокси аккаунта не работает. Проверьте его в разделе «Прокси».": "The account's proxy isn't working. Check it in the “Proxies” section.",
  "Kleinanzeigen не ответил на запрос кода. Попробуйте ещё раз.": "Kleinanzeigen didn't respond to the code request. Please try again.",
  "Kleinanzeigen не подтвердил отправку SMS. Попробуйте ещё раз.": "Kleinanzeigen didn't confirm sending the SMS. Please try again.",
  "Не удалось выбрать пункт «Nein, Direkt kaufen nicht nutzen». Проверьте блок Direkt kaufen.": "Could not select «Nein, Direkt kaufen nicht nutzen». Check the Direkt kaufen block.",
  "Не удалось выбрать пункт «Nein, Direkt kaufen не использовать». Пожалуйста, проверьте форму на сайте.": "Could not select «Nein, Direkt kaufen nicht nutzen». Please check the form on the site.",
  "Не удалось выдать подписку": "Could not grant the subscription",
  "Не удалось выполнить действие.": "Could not perform the action.",
  "Не удалось выполнить парс.": "Could not run the parse.",
  "Не удалось выполнить регистрацию": "Registration failed",
  "Не удалось выполнить регистрацию.": "Registration failed.",
  "Не удалось добавить": "Could not add",
  "Не удалось добавить аккаунт.": "Could not add the account.",
  "Не удалось добавить аккаунты ({0}/{1}).{2}": "Could not add the accounts ({0}/{1}).{2}",
  "Не удалось добавить время": "Could not add time",
  "Не удалось добавить прокси": "Could not add the proxy",
  "Не удалось добавить реквизиты.": "Could not add the payment details.",
  "Не удалось догрузить объявления по категориям.": "Could not load the remaining listings by category.",
  "Не удалось дождаться поля ввода SMS-кода. Возможно выбранная страна/номер не поддерживается Kleinanzeigen.": "The SMS code field never appeared. The chosen country or number may not be supported by Kleinanzeigen.",
  "Не удалось дождаться финального статуса активной публикации": "Timed out waiting for the final status of the active publication",
  "Не удалось дождаться финального статуса публикации": "Timed out waiting for the final publication status",
  "Не удалось завершить вход после регистрации.": "Could not finish signing in after registration.",
  "Не удалось завершить публикацию. Проверьте вкладку «Объявления».": "Could not finish publishing. Check the «Listings» tab.",
  "Не удалось завершить регистрацию": "Could not finish the registration",
  "Не удалось завершить регистрацию.": "Could not finish the registration.",
  "Не удалось завершить сессию": "Could not end the session",
  "Не удалось загрузить": "Could not load",
  "Не удалось загрузить быстрые ответы.": "Could not load the quick replies.",
  "Не удалось загрузить данные объявления.": "Could not load the listing data.",
  "Не удалось загрузить данные.": "Could not load the data.",
  "Не удалось загрузить дерево категорий": "Could not load the category tree",
  "Не удалось загрузить инструменты.": "Could not load the tools.",
  "Не удалось загрузить категории": "Could not load the categories",
  "Не удалось загрузить категории (PicClick заблокировал через все прокси).": "Could not load the categories (PicClick blocked every proxy).",
  "Не удалось загрузить лиды сендера.": "Could not load the Sender leads.",
  "Не удалось загрузить новые фотографии в форму редактирования.": "Could not upload the new photos into the edit form.",
  "Не удалось загрузить объявление с eBay.": "Could not load the listing from eBay.",
  "Не удалось загрузить параметры категории": "Could not load the category fields",
  "Не удалось загрузить параметры категории. Публикация недоступна, пока параметры не будут загружены.": "Could not load the category fields. Publishing stays unavailable until they load.",
  "Не удалось загрузить параметры категории:": "Could not load the category fields:",
  "Не удалось загрузить подкатегории. Нажмите «Обновить».": "Could not load the subcategories. Press «Refresh».",
  "Не удалось загрузить подкатегории: {0}": "Could not load the subcategories: {0}",
  "Не удалось загрузить пользователей": "Could not load the users",
  "Не удалось загрузить прокси": "Could not load the proxies",
  "Не удалось загрузить рассылки": "Could not load the broadcasts",
  "Не удалось загрузить сообщения": "Could not load the messages",
  "Не удалось загрузить статус мониторинга Sender.": "Could not load the Sender monitoring status.",
  "Не удалось загрузить страницу категорий Kleinanzeigen": "Could not load the Kleinanzeigen categories page",
  "Не удалось загрузить уведомления": "Could not load the notifications",
  "Не удалось загрузить файлы объявления": "Could not upload the listing files",
  "Не удалось загрузить файлы сообщения": "Could not upload the message files",
  "Не удалось загрузить форму публикации Kleinanzeigen для чтения PLZ (timeout). Проверьте прокси и повторите попытку.": "Could not load the Kleinanzeigen publication form to read the postcode (timeout). Check the proxy and try again.",
  "Не удалось загрузить фото, попробуйте другое.": "Could not upload the photo — try another one.",
  "Не удалось загрузить фото, попробуйте снова.": "Could not upload the photo — try again.",
  "Не удалось загрузить — нажмите, чтобы повторить": "Could not load — tap to retry",
  "Не удалось закрыть сессию подтверждения.": "Could not close the confirmation session.",
  "Не удалось запланировать публикацию": "Could not schedule the publication",
  "Не удалось заполнить форму редактирования объявления.": "Could not fill in the listing edit form.",
  "Не удалось запустить SMS-верификацию телефона.": "Could not start the phone SMS verification.",
  "Не удалось запустить SMS-подтверждение телефона.": "Could not start the phone SMS confirmation.",
  "Не удалось запустить Sender: {0}": "Could not start Sender: {0}",
  "Не удалось запустить подтверждение телефона.": "Could not start the phone confirmation.",
  "Не удалось запустить поиск": "Could not start the search",
  "Не удалось запустить прогрев": "Could not start the warm-up",
  "Не удалось запустить синхронизацию PicClick.": "Could not start the PicClick sync.",
  "Не удалось зарегистрироваться": "Registration failed",
  "Не удалось зарезервировать": "Could not reserve",
  "Не удалось извлечь CSRF-токен из формы. Возможно, kleinanzeigen изменил разметку.": "Could not extract the CSRF token from the form. Kleinanzeigen may have changed its markup.",
  "Не удалось извлечь CSRF-токен формы аккаунта.": "Could not extract the CSRF token from the account form.",
  "Не удалось извлечь данные объявления из страницы eBay.": "Could not extract the listing data from the eBay page.",
  "Не удалось извлечь дерево категорий": "Could not extract the category tree",
  "Не удалось изменить имя профиля (gewerblich).": "Could not change the profile name (gewerblich).",
  "Не удалось изменить имя профиля.": "Could not change the profile name.",
  "Не удалось изменить право": "Could not change the permission",
  "Не удалось найти кнопку публикации на Kleinanzeigen": "Could not find the publish button on Kleinanzeigen",
  "Не удалось найти поле загрузки изображений на форме редактирования.": "Could not find the image upload field on the edit form.",
  "Не удалось найти форму создания объявления на странице.": "Could not find the listing creation form on the page.",
  "Не удалось начать регистрацию.": "Could not start the registration.",
  "Не удалось нормализовать ссылку объявления": "Could not normalise the listing link",
  "Не удалось обновить Sender: {0}": "Could not update Sender: {0}",
  "Не удалось обновить аккаунт": "Could not refresh the account",
  "Не удалось обновить настройки Sender.": "Could not update the Sender settings.",
  "Не удалось обновить объявление": "Could not update the listing",
  "Не удалось обновить платеж.": "Could not update the payment.",
  "Не удалось обновить подписку (запись не найдена)": "Could not update the subscription (record not found)",
  "Не удалось обновить статус подписки": "Could not refresh the subscription status",
  "Не удалось обновить статус телефона.": "Could not refresh the phone status.",
  "Не удалось обновить статус.": "Could not refresh the status.",
  "Не удалось обновить шаблон сообщения.": "Could not update the message template.",
  "Не удалось определить аккаунт по cookies.": "Could not identify the account from the cookies.",
  "Не удалось определить данные аккаунта из cookies.": "Could not work out the account details from the cookies.",
  "Не удалось определить объявление для активации.": "Could not identify which listing to activate.",
  "Не удалось определить объявление для редактирования.": "Could not identify which listing to edit.",
  "Не удалось определить объявление для резерва.": "Could not identify which listing to reserve.",
  "Не удалось определить объявление для удаления.": "Could not identify which listing to delete.",
  "Не удалось опубликовать объявление.": "Could not publish the listing.",
  "Не удалось опубликовать черновик": "Could not publish the draft",
  "Не удалось остановить Sender: {0}": "Could not stop Sender: {0}",
  "Не удалось отклонить заявку": "Could not decline the request",
  "Не удалось отклонить предложение": "Could not decline the offer",
  "Не удалось отключить заморозку": "Could not disable the freeze",
  "Не удалось открыть полный текст.": "Could not open the full text.",
  "Не удалось открыть ссылку подтверждения.": "Could not open the confirmation link.",
  "Не удалось открыть стартовую страницу Kleinanzeigen, использован сохраненный PLZ.": "Could not open the Kleinanzeigen home page, so the saved postcode was used.",
  "Не удалось открыть страницу входа после регистрации.": "Could not open the sign-in page after registration.",
  "Не удалось открыть страницу объявлений через прокси за отведенное время. Повторите действие.": "Could not open the listings page through the proxy in time. Try again.",
  "Не удалось открыть страницу регистрации Kleinanzeigen.": "Could not open the Kleinanzeigen registration page.",
  "Не удалось открыть страницу редактирования объявления через прокси за отведенное время.": "Could not open the listing edit page through the proxy in time.",
  "Не удалось открыть форму входа после регистрации.": "Could not open the sign-in form after registration.",
  "Не удалось открыть форму данных аккаунта (истекли cookie или изменилась разметка Kleinanzeigen).": "Could not open the account details form — the cookies have expired, or Kleinanzeigen changed its markup.",
  "Не удалось открыть форму пароля после регистрации.": "Could not open the password form after registration.",
  "Не удалось открыть форму публикации, использован сохраненный PLZ.": "Could not open the publication form, so the saved postcode was used.",
  "Не удалось открыть форму смены имени профиля.": "Could not open the profile name form.",
  "Не удалось открыть форму смены номера телефона.": "Could not open the phone number form.",
  "Не удалось отметить уведомление": "Could not mark the notification",
  "Не удалось отметить уведомления": "Could not mark the notifications",
  "Не удалось отправить": "Could not send",
  "Не удалось отправить 2-е сообщение.": "Could not send the 2nd message.",
  "Не удалось отправить 3-е сообщение.": "Could not send the 3rd message.",
  "Не удалось отправить 3-е сообщение: {0}": "Could not send the 3rd message: {0}",
  "Не удалось отправить код повторно.": "Could not resend the code.",
  "Не удалось отправить код подтверждения на телефон.": "Could not send the confirmation code to the phone.",
  "Не удалось отправить код подтверждения.": "Could not send the confirmation code.",
  "Не удалось отправить ответ.": "Could not send the reply.",
  "Не удалось отправить рассылку": "Could not send the broadcast",
  "Не удалось отправить форму редактирования.": "Could not submit the edit form.",
  "Не удалось отправить фото": "Could not send the photo",
  "Не удалось отправить фото.": "Could not send the photo.",
  "Не удалось отправить.": "Could not send.",
  "Не удалось отредактировать объявление.": "Could not edit the listing.",
  "Не удалось перевести": "Could not translate",
  "Не удалось перевести текст.": "Could not translate the text.",
  "Не удалось перейти к вводу номера телефона.": "Could not get to the phone number step.",
  "Не удалось подготовить объявление.": "Could not prepare the listing.",
  "Не удалось подготовить прокси для настроек аккаунта.": "Could not prepare a proxy for the account settings.",
  "Не удалось подготовить прокси для проверки PLZ.": "Could not prepare a proxy for the postcode check.",
  "Не удалось подготовить прокси для чтения PLZ, использован сохраненный PLZ.": "Could not prepare a proxy to read the postcode, so the saved one was used.",
  "Не удалось подготовить форму редактирования.": "Could not prepare the edit form.",
  "Не удалось подготовить фото: {0}{1}.{2}": "Could not prepare the photos: {0}{1}.{2}",
  "Не удалось подключиться к прокси (proxy-chain).": "Could not connect to the proxy (proxy-chain).",
  "Не удалось подключиться через прокси.": "Could not connect through the proxy.",
  "Не удалось подтвердить SMS-код телефона.": "Could not confirm the phone SMS code.",
  "Не удалось подтвердить email-ссылку.": "Could not confirm the email link.",
  "Не удалось подтвердить авторизацию по сессии": "Could not confirm the session sign-in",
  "Не удалось подтвердить вход в аккаунт (страница: /m-einloggen.html).": "Could not confirm the sign-in (page: /m-einloggen.html).",
  "Не удалось подтвердить код.": "Could not confirm the code.",
  "Не удалось подтвердить код. Попробуйте еще раз или запросите новый код.": "Could not confirm the code. Try again or request a new one.",
  "Не удалось подтвердить номер телефона.": "Could not confirm the phone number.",
  "Не удалось подтвердить обновление индекса объявления.": "Could not confirm the listing's postcode was updated.",
  "Не удалось подтвердить обновление названия объявления.": "Could not confirm the listing's title was updated.",
  "Не удалось подтвердить обновление описания объявления.": "Could not confirm the listing's description was updated.",
  "Не удалось подтвердить обновление цены объявления.": "Could not confirm the listing's price was updated.",
  "Изменения сохранены, но новые фото на объявлении не появились.": "The changes were saved, but the new photos did not appear on the listing.",
  "Вернуть текущую": "Restore current",
  "Черновик:": "Draft:",
  "Можно приложить не больше {0} фото — не добавлено: {1}.": "You can attach at most {0} photos — not added: {1}.",
  "Убрать фото": "Remove photo",
  "Учитывать прошлый результат": "Use the previous result",
  "Отдать модели вместе с новыми фото то, что она нарисовала в этом чате, — чтобы объединить": "Give the model what it drew in this chat together with the new photos, so it can combine them",
  "вместе с прошлым результатом": "together with the previous result",
  "Приложить фото (до 4)": "Attach photos (up to 4)",
  "Фон, свет, лишнее в кадре, кадрирование. Сам предмет модель не меняет. Следующая просьба применяется к последней картинке; можно приложить до 4 фото — модель объединит их с тем, что уже нарисовала.": "Background, lighting, clutter, cropping. The model doesn't change the item itself. The next request applies to the latest picture; you can attach up to 4 photos — the model will combine them with what it has already drawn.",
  "Можно не больше {0} фото в объявлении — не добавлено: {1}.": "A listing can have at most {0} photos — not added: {1}.",
  "Эти фото уже добавлены.": "These photos have already been added.",
  "Прокси аккаунта невалиден — ничего не отправлялось. Проверьте прокси или привяжите к аккаунту другой.": "The account's proxy is not valid — nothing was sent. Check the proxy or assign a different one to the account.",
  "Прокси аккаунта невалиден — сообщение не отправлялось. Проверьте прокси или привяжите к аккаунту другой.": "The account's proxy is not valid — the message was not sent. Check the proxy or assign a different one to the account.",
  "С невалидным прокси не обновлялись: {0}": "Not refreshed because of an invalid proxy: {0}",
  "eBay показал проверку браузера вместо страницы товара (защита от ботов) и не пропустил ни один из путей. Попробуйте ещё раз через пару минут.": "eBay showed a browser check instead of the item page (bot protection) and didn't let any of the routes through. Try again in a couple of minutes.",
  "Язык промта": "Prompt language",
  "Язык промта. При смене в поле подставляется стандартный промт на этом языке — сохраните, чтобы применить.": "Prompt language. Switching it fills in the standard prompt in that language — save to apply.",
  "Отменить": "Discard",
  "Промты нейросети": "AI prompts",
  "Инструкции, по которым нейросеть пишет за вас. Стандартный текст уже вставлен — допишите его под себя или замените целиком. Промты свои у каждого пользователя.": "The instructions the AI follows when it writes for you. The standard text is already filled in — adjust it to your needs or replace it entirely. Every user has their own prompts.",
  "Ассистент в диалогах": "Assistant in conversations",
  "Как ассистент отвечает покупателям: тон, торг, доставка, оплата, резерв.": "How the assistant answers buyers: tone, haggling, shipping, payment, reservations.",
  "Объявление, сегодняшняя дата и переписка добавляются к запросу сами — писать их сюда не нужно.": "The listing, today's date and the conversation are added to the request automatically — no need to include them here.",
  "Быстрый ответ в поле ввода": "Quick reply in the input field",
  "Правила для готового ответа, который появляется серым текстом в поле ввода.": "Rules for the ready-made reply shown as grey text in the input field.",
  "Формат ответа нейросети сервер дописывает сам, его указывать не нужно. Подсказка включается в разделе «Нейросеть» выше.": "The server adds the AI's answer format itself, so you don't need to specify it. The suggestion is switched on in the “AI” section above.",
  "Загружаем промты…": "Loading prompts…",
  "Не удалось загрузить промты": "Could not load the prompts",
  "Свой": "Custom",
  "Стандартный": "Standard",
  "● не сохранено": "● unsaved",
  "{0} из {1} символов": "{0} of {1} characters",
  "Вернуть стандартный": "Restore standard",
  "Подставить стандартный текст — сохранится, когда нажмёте «Сохранить»": "Fill in the standard text — it is saved when you press “Save”",
  "Сохраняем…": "Saving…",
  "Промт пустой. Чтобы вернуть стандартный, нажмите «Вернуть стандартный».": "The prompt is empty. To restore the standard one, press “Restore standard”.",
  "Свой промт сохранён — нейросеть уже работает по нему.": "Your prompt is saved — the AI already follows it.",
  "Действует стандартный промт.": "The standard prompt is in effect.",
  "Не удалось сохранить промт": "Could not save the prompt",
  "новая": "new",
  "Сейчас: {0}": "Currently: {0}",
  "изменено": "changed",
  "Загружаем параметры…": "Loading parameters…",
  "Заполните параметры новой категории: {0}": "Fill in the parameters of the new category: {0}",
  "Параметры новой категории ещё загружаются — подождите пару секунд.": "The new category's parameters are still loading — wait a couple of seconds.",
  "Не удалось сменить категорию объявления.": "Could not change the listing's category.",
  "Kleinanzeigen принял фото, но не вернул ссылку на него — объявление не изменено. Попробуйте ещё раз.": "Kleinanzeigen accepted the photo but did not return a link to it — the listing was not changed. Please try again.",
  "Не удалось подтвердить отправку объявления: форма осталась открытой без признаков успешной публикации.": "Could not confirm the listing was submitted: the form stayed open with no sign of a successful publication.",
  "Не удалось подтвердить смену имени. Попробуйте ещё раз.": "Could not confirm the name change. Try again.",
  "Не удалось получить PLZ аккаунта": "Could not get the account postcode",
  "Не удалось получить PLZ аккаунта.": "Could not get the account's postcode.",
  "Не удалось получить PLZ прокси": "Could not get the proxy postcode",
  "Не удалось получить PLZ прокси.": "Could not get the proxy's postcode.",
  "Не удалось получить PLZ.": "Could not get the postcode.",
  "Не удалось получить cookies": "Could not get the cookies",
  "Не удалось получить live-данные объявлений. Повторите обновление.": "Could not fetch live listing data. Refresh again.",
  "Не удалось получить актуальные объявления — показаны последние известные. Попробуйте ещё раз.": "Could not fetch live listings — the last known ones are shown. Try again.",
  "Не удалось получить артефакты.": "Could not fetch the artifacts.",
  "Не удалось получить геоданные прокси.": "Could not get the proxy's location data.",
  "Не удалось получить полный текст сообщения.": "Could not fetch the full message text.",
  "Не удалось получить служебные поля формы.": "Could not read the form's internal fields.",
  "Не удалось получить статус подписки": "Could not get the subscription status",
  "Не удалось применить выбранный код страны.": "Could not apply the chosen country code.",
  "Не удалось применить порядок существующих фото объявления.": "Could not apply the order of the listing's existing photos.",
  "Не удалось проверить": "Could not check",
  "Не удалось проверить cookies по HTTP (прокси недоступен или сессия истекла).": "Could not check the cookies over HTTP (the proxy is unreachable, or the session has expired).",
  "Не удалось проверить объявление": "Could not check the listing",
  "Не удалось проверить промокод": "Could not check the promo code",
  "Не удалось проверить сессию аккаунта.": "Could not check the account's session.",
  "Не удалось проверить статус": "Could not check the status",
  "Не удалось прочитать txt: {0}": "Could not read the txt: {0}",
  "Не удалось прочитать директорию артефактов.": "Could not read the artifacts directory.",
  "Не удалось прочитать файл cookies.": "Could not read the cookie file.",
  "Не удалось прочитать файл фотографии.": "Could not read the photo file.",
  "Не удалось прочитать форму регистрации Kleinanzeigen.": "Could not read the Kleinanzeigen registration form.",
  "Не удалось распознать URL загруженной фотографии.": "Could not work out the uploaded photo's URL.",
  "Не удалось сменить пароль": "Could not change the password",
  "Не удалось сменить прокси аккаунта": "Could not change the account's proxy",
  "Не удалось создать администратора": "Could not create the administrator",
  "Не удалось создать пользователя": "Could not create the user",
  "Не удалось создать рассылку": "Could not create the broadcast",
  "Не удалось создать счет": "Could not create the invoice",
  "Не удалось сохранить": "Could not save",
  "Не удалось сохранить seen-маркер.": "Could not save the seen marker.",
  "Не удалось сохранить администратора. Проверьте доступ backend/data/users.json к записи для backend.": "Could not save the administrator. Check that backend/data/users.json is writable by the backend.",
  "Не удалось сохранить быстрый ответ.": "Could not save the quick reply.",
  "Не удалось сохранить данные входа. Проверьте доступ backend/data/users.json к записи для backend.": "Could not save the sign-in details. Check that backend/data/users.json is writable by the backend.",
  "Не удалось сохранить изменения.": "Could not save the changes.",
  "Не удалось сохранить настройки Sender: {0}": "Could not save the Sender settings: {0}",
  "Не удалось сохранить новое имя профиля.": "Could not save the new profile name.",
  "Не удалось сохранить новый пароль. Проверьте доступ backend/data/users.json к записи для backend.": "Could not save the new password. Check that backend/data/users.json is writable by the backend.",
  "Не удалось сохранить платеж.": "Could not save the payment.",
  "Не удалось сохранить право": "Could not save the permission",
  "Не удалось сохранить прокси": "Could not save the proxy",
  "Не удалось сохранить регистрацию. Проверьте доступ backend/data/users.json к записи для backend.": "Could not save the registration. Check that backend/data/users.json is writable by the backend.",
  "Не удалось сохранить реквизиты.": "Could not save the payment details.",
  "Не удалось сохранить стоп-слова": "Could not save the stop words",
  "Не удалось сохранить черновик": "Could not save the draft",
  "Не удалось удалить": "Could not delete",
  "Не удалось удалить быстрый ответ.": "Could not delete the quick reply.",
  "Не удалось удалить запись.": "Could not delete the record.",
  "Не удалось удалить лид.": "Could not delete the lead.",
  "Не удалось удалить лид: {0}": "Could not delete the lead: {0}",
  "Не удалось удалить лиды.": "Could not delete the leads.",
  "Не удалось удалить лиды: {0}": "Could not delete the leads: {0}",
  "Не удалось удалить платеж.": "Could not delete the payment.",
  "Не удалось удалить реквизиты.": "Could not delete the payment details.",
  "Не удалось удалить текущие фото объявления перед заменой.": "Could not delete the listing's current photos before replacing them.",
  "Не удалось удалить черновик": "Could not delete the draft",
  "Не указан credentialId.": "No credentialId given.",
  "Не указан leadId.": "No leadId given.",
  "Не указан paymentId.": "No paymentId given.",
  "Не указан quickReplyId.": "No quickReplyId given.",
  "Не указан диалог": "No conversation given",
  "Не указан хост или порт прокси": "The proxy host or port is missing",
  "Не хватает служебных полей формы.": "The form's internal fields are incomplete.",
  "Неактивно": "Inactive",
  "Невалидные строки:": "Invalid lines:",
  "Неверный ключ": "Invalid key",
  "Неверный логин или пароль": "Wrong username or password",
  "Неверный статус платежа.": "Invalid payment status.",
  "Неверный тип реквизитов.": "Invalid payment method type.",
  "Недопустимое поле.": "Field not allowed.",
  "Недостаточно данных диалога для открытия полного текста.": "Not enough conversation data to open the full text.",
  "Недостаточно данных диалога для отправки 3-го сообщения.": "Not enough conversation data to send the 3rd message.",
  "Недостаточно данных диалога для отправки.": "Not enough conversation data to send.",
  "Недостаточно данных для загрузки диалога.": "Not enough data to load the conversation.",
  "Недостаточно данных для отклонения заявки.": "Not enough data to decline the request.",
  "Недостаточно данных для отправки.": "Not enough data to send.",
  "Недостаточно прав для использования прокси.": "Not enough rights to use that proxy.",
  "Недостаточно прав для этой сессии подтверждения.": "Not enough rights for this confirmation session.",
  "Неизвестная ошибка": "Unknown error",
  "Неизвестная ошибка Sender.": "Unknown Sender error.",
  "Неизвестно": "Unknown",
  "Неизвестное действие.": "Unknown action.",
  "Неизвестный": "Unknown",
  "Неизвестный провайдер": "Unknown provider",
  "Некорректная дата планирования": "Invalid scheduling date",
  "Некорректная категория объявления.": "Invalid listing category.",
  "Некорректная ссылка Kleinanzeigen (ожидается URL объявления /s-anzeige/...)": "Invalid Kleinanzeigen link (a listing URL /s-anzeige/... is expected)",
  "Некорректная цена объявления.": "Invalid listing price.",
  "Некорректное имя файла.": "Invalid file name.",
  "Некорректное поле attributeMap.": "Invalid attributeMap field.",
  "Некорректные данные объявления.": "Invalid listing data.",
  "Некорректные параметры seen-маркера.": "Invalid seen-marker parameters.",
  "Некорректный URL изображения.": "Invalid image URL.",
  "Некорректный accountId.": "Invalid accountId.",
  "Некорректный payload объявления.": "Invalid listing payload.",
  "Некорректный payload редактирования.": "Invalid edit payload.",
  "Некорректный requestId": "Invalid requestId",
  "Некорректный аккаунт для ответа.": "Invalid account for the reply.",
  "Некорректный аккаунт лида.": "Invalid lead account.",
  "Некорректный аккаунт черновика": "Invalid draft account",
  "Некорректный запрос изображения черновика.": "Invalid draft image request.",
  "Некорректный запрос на перевод.": "Invalid translation request.",
  "Некорректный идентификатор способа доставки.": "Invalid delivery method id.",
  "Некорректный идентификатор черновика": "Invalid draft id",
  "Некорректный почтовый индекс.": "Invalid postcode.",
  "Некорректный путь.": "Invalid path.",
  "Некорректный формат загрузки изображений.": "Invalid image upload format.",
  "Нельзя сменить прокси, пока действие аккаунта выполняется. Дождитесь завершения.": "The proxy cannot be changed while an action is running on the account. Wait for it to finish.",
  "Непрочитанные": "Unread",
  "непрочитанных": "unread",
  "всех диалогов": "all conversations",
  "Непрочитанных: {0}": "Unread: {0}",
  "Нет": "No",
  "Нет cookies для входа в аккаунт.": "There are no cookies to sign in to the account.",
  "Нет email": "No email",
  "Нет аккаунтов": "No accounts",
  "Нет аккаунтов с включенным Sender.": "No accounts have Sender enabled.",
  "Нет активных аккаунтов с рабочим прокси для синхронизации": "No active accounts with a working proxy to sync",
  "Нет вариантов": "No options",
  "Нет диалогов": "No conversations",
  "Нет добавленных прокси": "No proxies added",
  "Нет добавленных прокси. Сначала добавьте прокси в разделе «Прокси».": "No proxies added. Add one in the «Proxies» section first.",
  "Нет доступа к выбранному прокси": "No access to the selected proxy",
  "Нет доступа к выбранному прокси.": "No access to the selected proxy.",
  "Нет доступа к прокси регистрации.": "No access to the registration proxy.",
  "Нет доступных вариантов": "No options available",
  "Нет доступных прокси": "No proxies available",
  "Нет доступных прокси для парсера.": "No proxies available for the parser.",
  "Нет доступных прокси для парсера. Добавьте рабочий прокси в разделе «Прокси».": "No proxies available for the parser. Add a working one in the «Proxies» section.",
  "Нет зарегистрированных пользователей": "No registered users",
  "Никто не найден": "Nobody found",
  "Нет подкатегорий - эта категория финальная": "No subcategories — this is the final category",
  "Нет подписки": "No subscription",
  "Нет права удалять объявления у всех": "No permission to delete listings for everyone",
  "Нет превью": "No preview",
  "Нет прокси": "No proxy",
  "Нет реквизитов": "No payment details",
  "Нет сообщений в этом диалоге": "No messages in this conversation",
  "Нет сообщений для вкладки {0}": "No messages for the {0} tab",
  "Нет сохраненных ответов.": "No saved replies.",
  "Нет уведомлений": "No notifications",
  "Новое имя профиля": "New profile name",
  "Новое объявление": "New listing",
  "Новое сообщение": "New message",
  "Новое уведомление": "New notification",
  "Новые": "New",
  "Новые пользователи": "New users",
  "Новые сообщения": "New messages",
  "Новый пароль": "New password",
  "Новый пароль должен отличаться от текущего": "The new password must differ from the current one",
  "Новый прокси": "New proxy",
  "Новых сообщений: {0}": "New messages: {0}",
  "Новых уведомлений: {0}": "New notifications: {0}",
  "Номер без кода страны": "Number without the country code",
  "Номер не привязан": "No number linked",
  "Номер привязан": "Number linked",
  "Номер телефона подтвержден.": "Phone number confirmed.",
  "Нужно передать хотя бы один categoryId.": "At least one categoryId must be given.",
  "Обнаружен captcha/challenge для аккаунта.": "A captcha/challenge was raised for this account.",
  "Обнаружена зависшая попытка публикации. Запускаю новую попытку.": "A stuck publication attempt was found. Starting a new one.",
  "Обновить": "Refresh",
  "Обновить данные": "Refresh data",
  "Обновить данные аккаунта": "Refresh account data",
  "Обновить статус": "Refresh status",
  "Обновление...": "Refreshing...",
  "Обновлено": "Updated",
  "Обновляем список черновиков...": "Refreshing the draft list...",
  "Обновляем токен и повторяем отправку": "Refreshing the token and sending again",
  "Обновляется...": "Refreshing...",
  "Обработка...": "Processing...",
  "Объявл.": "List.",
  "Объявл.:": "List.:",
  "Объявление": "Listing",
  "Объявление {0}": "Listing {0}",
  "Объявление не найдено": "Listing not found",
  "Объявление отклонено модерацией Kleinanzeigen": "The listing was rejected by Kleinanzeigen moderation",
  "Объявление отправлено на модерацию": "The listing has been sent for review",
  "Объявление отправлено на публикацию.": "The listing has been submitted for publication.",
  "Объявление отправлено на публикацию. Проверьте итоговый статус во вкладке «Объявления».": "The listing has been submitted. Check the final status in the «Listings» tab.",
  "Объявление отправлено на публикацию. Проверьте статус публикации во вкладке «Объявления».": "The listing has been submitted. Check the publication status in the «Listings» tab.",
  "Объявление отправлено, но KL не вернул его идентификатор — публикация не подтверждена.": "The listing was submitted, but Kleinanzeigen returned no id — the publication is unconfirmed.",
  "Объявление отсутствует на Kleinanzeigen и удалено из локального списка.": "The listing is gone from Kleinanzeigen and has been removed from the local list.",
  "Объявление снято": "Listing taken down",
  "Объявление убрано из ленты всех пользователей.": "The listing has been removed from everyone's feed.",
  "Объявление убрано у всех и осталось у вас — оно в избранном.": "The listing was removed for everyone and kept for you — it is in your favourites.",
  "Объявление уже успело завершить публикацию перед отменой. Проверьте статус во вкладке «Объявления».": "The listing finished publishing before it could be cancelled. Check the status in the «Listings» tab.",
  "Объявление успешно обновлено.": "Listing updated.",
  "Объявления": "Listings",
  "Объявления обновлены частично": "Listings partially updated",
  "Обычные": "Regular",
  "Обычный без засечек": "Regular sans-serif",
  "Одна": "One",
  "Ожидаем ответ Kleinanzeigen": "Waiting for Kleinanzeigen to answer",
  "Ожидаемо: €": "Expected: €",
  "Ожидается": "Pending",
  "Ожидается файл с куками": "A cookie file is expected",
  "Ожидание отменено.": "The wait was cancelled.",
  "Онлайн": "Online",
  "Онлайн: {0}": "Online: {0}",
  "С подпиской: {0}": "Subscribed: {0}",
  "Операция не настроена на сервере.": "This operation is not configured on the server.",
  "Описание": "Description",
  "Описание не загружено.": "The description has not loaded.",
  "Описание не заполнено": "The description is empty",
  "Описание не может быть пустым. Введите текст:": "The description cannot be empty. Enter some text:",
  "Описание объявления не заполнено.": "The listing description is empty.",
  "Оплата подтверждена": "Payment confirmed",
  "Оплата пока не подтверждена": "The payment is not confirmed yet",
  "Оплачен": "Paid",
  "Определяем аккаунт по cookies...": "Identifying the account from the cookies...",
  "Опубликовано": "Published",
  "Опубликовать": "Publish",
  "Опубликовать сейчас": "Publish now",
  "Основное:": "Main:",
  "Оставить текущую": "Keep the current one",
  "Осталось заполнить {0} {1}": "{0} {1} left to fill in",
  "Осталось:": "Remaining:",
  "Останавливаем публикацию": "Stopping the publication",
  "Остановить Sender": "Stop Sender",
  "Остановка синхронизации...": "Stopping the sync...",
  "От создания доступа до запущенных задач — обычно меньше десяти минут.": "From creating access to running tasks — usually under ten minutes.",
  "Ответ": "Reply",
  "Ответ на сообщения прямо из Telegram": "Reply to messages straight from Telegram",
  "Ответы покупателей (из кэша Сообщений)": "Buyer replies (from the Messages cache)",
  "Отдам даром": "Free to a good home",
  "Отдельный пул для парсинга публичных страниц. Не пересекается со встроенным прокси панели и прокси аккаунтов — сгоревший IP не заденет сессии.": "A separate pool for scraping public pages. It does not overlap with the panel's built-in proxy or the accounts' proxies, so a burnt IP cannot touch your sessions.",
  "Отклонён": "Rejected",
  "Отключить заморозку": "Disable the freeze",
  "Открепить диалог": "Unpin conversation",
  "Открываем форму объявления": "Opening the listing form",
  "Открываем форму публикации": "Opening the publication form",
  "Открываю…": "Opening…",
  "Открыт не тот диалог получателя. Отправка остановлена для безопасности. Откройте нужный диалог и повторите.": "The wrong recipient's conversation is open. Sending was stopped as a precaution. Open the right conversation and try again.",
  "Открытие главной": "Opening the home page",
  "Открытие полного текста через Telegram пока не настроено на сервере.": "Opening the full text through Telegram is not configured on the server yet.",
  "Открыть email-ссылку": "Open the email link",
  "Открыть изображение": "Open image",
  "Открыть изображение {0} из {1}": "Open image {0} of {1}",
  "Открыть на KL →": "Open on KL →",
  "Открыть объявление на Kleinanzeigen": "Open the listing on Kleinanzeigen",
  "Открыть профиль на Kleinanzeigen": "Open the profile on Kleinanzeigen",
  "Открыть расширенный редактор": "Open the advanced editor",
  "Отмена": "Cancel",
  "Отменено": "Cancelled",
  "Отметить все": "Mark all",
  "Отправить": "Send",
  "Отправить 3-е": "Send the 3rd",
  "Отправить код": "Send code",
  "Отправить код снова": "Send the code again",
  "Отправить уведомление": "Send notification",
  "Отправка": "Sending",
  "Отправка медиа заняла слишком много времени. Проверьте прокси аккаунта и попробуйте снова.": "Sending the media took too long. Check the account's proxy and try again.",
  "Отправка ответа через Telegram пока не настроена на сервере.": "Sending a reply through Telegram is not configured on the server yet.",
  "Отправка...": "Sending...",
  "Отправленные реквизиты": "Payment details sent",
  "Отправляем объявление": "Submitting the listing",
  "Отправляю 3-е сообщение...": "Sending the 3rd message...",
  "Отправьте именно фото, либо /cancel.": "Send a photo, or /cancel.",
  "Отправьте фото": "Send a photo",
  "Отправьте фото изображением, либо нажмите «Готово».": "Send the photo as an image, or press «Done».",
  "Оформление": "Appearance",
  "Оффер \"{0}\". Gesamt: {1}. Betrag: {2}. Versand: {3}.": "Offer \"{0}\". Gesamt: {1}. Betrag: {2}. Versand: {3}.",
  "Оффлайн": "Offline",
  "Очень медленный": "Very slow",
  "Очередь": "Queue",
  "Очистить": "Clear",
  "Очистить все": "Clear all",
  "Очистить диалог": "Clear conversation",
  "Ошибка": "Error",
  "Ошибка AI ассистента": "AI assistant error",
  "Ошибка SSL/TLS соединения через прокси.": "SSL/TLS connection error through the proxy.",
  "Ошибка SSL/TLS соединения через прокси. Проверьте работу прокси.": "SSL/TLS connection error through the proxy. Check that the proxy works.",
  "Ошибка входа": "Sign-in error",
  "Подтвердите, что вы не робот.": "Confirm that you're not a robot.",
  "Не удалось загрузить проверку от ботов. Обновите страницу или отключите блокировщик рекламы.": "Couldn't load the security check. Reload the page or turn off your ad blocker.",
  "Проверка от ботов не загрузилась. Обновите страницу.": "The security check didn't load. Reload the page.",
  "Проверка от ботов временно недоступна. Попробуйте ещё раз через минуту.": "The security check is temporarily unavailable. Try again in a minute.",
  "Проверка от ботов настроена неверно. Сообщите администратору.": "The security check is misconfigured. Please contact the administrator.",
  "Проверка устарела. Пройдите её ещё раз.": "The security check has expired. Please complete it again.",
  "Проверка от ботов не пройдена. Попробуйте ещё раз.": "Security check failed. Please try again.",
  "Ошибка выполнения Sender-задачи.": "The Sender task failed.",
  "Ошибка загрузки": "Loading error",
  "Ошибка загрузки изображений": "Image upload error",
  "Ошибка загрузки параметров категории": "Error loading the category fields",
  "Ошибка загрузки черновиков: {0}": "Error loading drafts: {0}",
  "Ошибка запроса": "Request error",
  "Ошибка запроса к AI ассистенту.": "Error requesting the AI assistant.",
  "Ошибка запуска": "Start-up error",
  "Ошибка настройки аккаунта": "Account setup error",
  "Ошибка операции.": "The operation failed.",
  "Ошибка опроса прогресса": "Error polling for progress",
  "Ошибка парсера": "Parser error",
  "Ошибка перевода": "Translation error",
  "Ошибка поиска": "Search error",
  "Ошибка получения статуса прогрева": "Error getting the warm-up status",
  "Ошибка при отправке сообщения": "Error sending the message",
  "Ошибка при проверке прокси": "Error checking the proxy",
  "Ошибка при прогреве аккаунта": "Error warming up the account",
  "Ошибка при смене прокси аккаунта": "Error changing the account's proxy",
  "Ошибка при создании объявления: {0}": "Error creating the listing: {0}",
  "Ошибка при тестировании прокси": "Error testing the proxy",
  "Ошибка при удалении аккаунта": "Error deleting the account",
  "Ошибка при удалении прокси": "Error deleting the proxy",
  "Ошибка проверки сессии": "Session check error",
  "Ошибка прогрева": "Warm-up error",
  "Ошибка публикации черновика": "Error publishing the draft",
  "Ошибка регистрации": "Registration error",
  "Ошибка сети": "Network error",
  "Ошибка смены пароля": "Password change error",
  "Ошибка создания администратора": "Error creating the administrator",
  "Ошибка сохранения черновика": "Error saving the draft",
  "Ошибка сохранения черновика: {0}": "Error saving the draft: {0}",
  "Ошибки": "Errors",
  "Панель мультиаккаунтинга": "Multi-account panel",
  "Параметр": "Field",
  "Параметры": "Fields",
  "Параметры категории": "Category fields",
  "Пароли не совпадают": "The passwords do not match",
  "Пароли не совпадают. Запустите регистрацию заново кнопкой «Регистрация».": "The passwords do not match. Start again with the «Register» button.",
  "Пароль": "Password",
  "Пароль должен быть не короче 6 символов": "The password must be at least 6 characters",
  "Пароль должен быть не короче 8 символов.": "The password must be at least 8 characters.",
  "Пароль изменён успешно.": "Password changed.",
  "Пароль изменён. Сессии на других устройствах завершены: {0}": "Password changed. Sessions ended on other devices: {0}",
  "Пароль обновлён": "Password updated",
  "Пароль слишком длинный": "The password is too long",
  "Пароль успешно обновлён": "Password updated",
  "Пароль:": "Password:",
  "Парсер": "Parser",
  "Парсер и граббер": "Parser and grabber",
  "Перевести": "Translate",
  "Перевести заново": "Translate again",
  "Перевести на русский": "Translate into Russian",
  "Перевести название и описание": "Translate the title and description",
  "Перевести последнее входящее сообщение": "Translate the last incoming message",
  "Перевод": "Translation",
  "Перевод...": "Translating...",
  "Переводчик не настроен на сервере.": "The translator is not configured on the server.",
  "Передайте accountId": "Pass an accountId",
  "Передайте adId и accountId": "Pass adId and accountId",
  "Передайте adId и accountId.": "Pass adId and accountId.",
  "Передайте linksText с ссылками (каждая ссылка с новой строки).": "Pass linksText with the links, one per line.",
  "Передайте txt-список ссылок (каждая ссылка с новой строки).": "Pass a txt list of links, one per line.",
  "Передайте текст cookies.": "Pass the cookie text.",
  "Передайте хотя бы одно поле для редактирования объявления или добавьте фото.": "Pass at least one listing field to edit, or add a photo.",
  "Перейти к активному предложению: {0}": "Go to the active offer: {0}",
  "Перейти к разморозке": "Go to unfreeze",
  "Перетащите файл сюда или": "Drag a file here, or",
  "Перетащите фото сюда или": "Drag photos here, or",
  "Пинг": "Ping",
  "Платеж не найден": "Payment not found",
  "Платеж не найден.": "Payment not found.",
  "Платеж принадлежит другому аккаунту": "The payment belongs to a different account",
  "Платежи": "Payments",
  "Платежи пока не добавлены.": "No payments added yet.",
  "По одному прокси в строке (или через запятую). Форматы:": "One proxy per line (or comma-separated). Formats:",
  "Повторите пароль": "Repeat the password",
  "Повторите пароль для подтверждения:": "Repeat the password to confirm:",
  "Повторить": "Retry",
  "Повторяем публикацию после временной ошибки": "Retrying the publication after a temporary error",
  "Подготавливаем браузерную сессию": "Preparing the browser session",
  "Подготавливаем форму перед загрузкой фото": "Preparing the form before uploading photos",
  "Подготавливаю фото {0}/{1}...": "Preparing photo {0}/{1}...",
  "Подготовка...": "Preparing...",
  "Поддерживаются: .txt, .json, .cookies": "Supported: .txt, .json, .cookies",
  "Поддерживаются: JPG, PNG, WEBP, GIF": "Supported: JPG, PNG, WEBP, GIF",
  "Подключение": "Connection",
  "Подключить IP": "Connect IP",
  "Подождите...": "Please wait...",
  "Подписка активна": "Subscription active",
  "Подписка до {0}": "Subscription until {0}",
  "Подписка заморожена": "Subscription frozen",
  "Подписка и профиль": "Subscription and profile",
  "Подписка на заморозке": "Subscription is frozen",
  "Подписка на заморозке: доступ к разделам временно ограничен. Для продолжения работы откройте": "The subscription is frozen and access to the sections is limited for now. To carry on, open",
  "Подписка не активна": "Subscription not active",
  "Подписка не активна. Для доступа к панели оформите подписку в Telegram.": "The subscription is not active. To use the panel, take one out in Telegram.",
  "Подписка не активна. Оформите подписку в Telegram, чтобы открыть доступ к панели.": "The subscription is not active. Take one out in Telegram to unlock the panel.",
  "Подписка не активна. Оформите подписку в Telegram.": "Subscription not active. Take one out in Telegram.",
  "Подписка не активна. Оформите тариф в основном Telegram-боте, затем вернитесь в Sender.": "The subscription is not active. Choose a plan in the main Telegram bot, then come back to Sender.",
  "Подписка снова активна.": "The subscription is active again.",
  "Подписка успешно заморожена.": "The subscription has been frozen.",
  "Подписка: бессрочно": "Subscription: unlimited",
  "Подтвердите новый пароль": "Confirm the new password",
  "Подтвердите отправку": "Confirm sending",
  "Подтвердить": "Confirm",
  "Подтвердить SMS-код": "Confirm the SMS code",
  "Подтвердить код": "Confirm the code",
  "Подтвержден:": "Confirmed:",
  "Подтверждение действия": "Confirm the action",
  "Подтверждение пароля не совпадает": "The password confirmation does not match",
  "Подтверждение телефона": "Phone confirmation",
  "Пожалуйста, вставьте куки": "Please paste the cookies",
  "Пожалуйста, выберите хотя бы один файл": "Please choose at least one file",
  "Поиск завершён": "Search finished",
  "Поиск по диалогам": "Search conversations",
  "Пока нет ответов с email от продавцов.": "No email replies from sellers yet.",
  "Пока нет созданных рассылок.": "No broadcasts created yet.",
  "Пока нет сохраненных реквизитов.": "No saved payment details yet.",
  "Пока пусто. Объявления с добавленным словом в заголовке исчезнут из вашей ленты — на других пользователей список не влияет.": "Empty for now. Listings whose title contains a word you add disappear from your feed — the list does not affect other users.",
  "Пока пусто. Парсер добавляет новые объявления сам — нажмите «Искать сейчас», чтобы не ждать очередного прохода.": "Empty for now. The parser adds new listings by itself — press «Search now» rather than waiting for the next pass.",
  "Показать архив": "Show archive",
  "Показать все": "Show all",
  "Показать список": "Show the list",
  "Показать чаты": "Show chats",
  "Покупатель": "Buyer",
  "Полный доступ к панели управления": "Full access to the control panel",
  "Получатели": "Recipients",
  "Пользователи (": "Users (",
  "Пользователь": "User",
  "Пользователь не найден": "User not found",
  "Пользователь с таким логином уже существует": "A user with that username already exists",
  "Пользователь сессии не найден": "The session's user was not found",
  "Пользовательский": "Custom",
  "Помощь": "Help",
  "Попробовать снова": "Try again",
  "Порт": "Port",
  "После загрузки файла или вставки текста данные аккаунта определятся автоматически.": "Once you upload a file or paste the text, the account details are detected automatically.",
  "После оплаты нажмите «Проверить оплату».": "Once you have paid, press «Check payment».",
  "После смены пароля сессии на других устройствах будут автоматически завершены.": "Changing the password automatically ends sessions on other devices.",
  "Последнее входящее": "Last incoming",
  "Последние рассылки": "Recent broadcasts",
  "Последний ваш ответ": "Your last reply",
  "Потеря соединения с прокси": "Lost connection to the proxy",
  "Потеряно соединение с прокси при публикации объявления.": "The proxy connection was lost while publishing the listing.",
  "Права администратора выданы": "Administrator rights granted",
  "Право выдано": "Permission granted",
  "Право снято": "Permission revoked",
  "Превышено время ожидания прогрева (5 мин)": "The warm-up timed out (5 min)",
  "Предпросмотр": "Preview",
  "Предпросмотр объявления": "Listing preview",
  "Предпросмотр черновика": "Draft preview",
  "Предыдущее изображение": "Previous image",
  "Приватный режим": "Private mode",
  "Приватный режим включён": "Private mode is on",
  "Привяжите номер телефона ниже для верификации аккаунта": "Link a phone number below to verify the account",
  "Привязан": "Linked",
  "Привязка платежа к диалогу": "Linking the payment to a conversation",
  "Применение...": "Applying...",
  "Применить": "Apply",
  "Пример: /delay 35 или /delay +5": "Example: /delay 35 or /delay +5",
  "Пример: /jitter 6 или /jitter +1": "Example: /jitter 6 or /jitter +1",
  "Пример: /msg1 Hallo {seller_name}, ist der Artikel noch verfügbar?": "Example: /msg1 Hallo {seller_name}, ist der Artikel noch verfügbar?",
  "Пример: /msg2 Danke. Können Sie bitte Ihre E-Mail senden?": "Example: /msg2 Danke. Können Sie bitte Ihre E-Mail senden?",
  "Пример: /msg3 Danke, ich melde mich dort.": "Example: /msg3 Danke, ich melde mich dort.",
  "Провайдер": "Provider",
  "Проверить": "Check",
  "Проверить все": "Check all",
  "Проверить прокси": "Check proxy",
  "Проверить просмотры сейчас": "Check views now",
  "Проверить сейчас": "Check now",
  "Проверка": "Check",
  "Проверка сообщений": "Checking messages",
  "Проверка...": "Checking...",
  "Проверяем статус номера…": "Checking the number's status…",
  "Проверяем форму перед отправкой": "Checking the form before submitting",
  "Проверяем...": "Checking...",
  "Прогрев": "Warm-up",
  "Прогрев аккаунта": "Account warm-up",
  "Прогрев не запущен: прокси аккаунта непригоден, а без него сессия раскрыла бы IP сервера.": "The warm-up did not start: the account's proxy is unusable, and without it the session would expose the server's IP.",
  "Прогрев этого аккаунта уже идёт. Дождитесь завершения.": "A warm-up is already running for this account. Wait for it to finish.",
  "Прогресс": "Progress",
  "Продавец": "Seller",
  "Продавец {0}": "Seller {0}",
  "Продавец убрал его с KL — карточка осталась в списке": "The seller took it down from KL — the card stayed in the list",
  "Продлить подписку": "Extend the subscription",
  "Прокси": "Proxy",
  "Бесплатно": "Free",
  "Без фото": "No photos",
  "Сдвинуть влево": "Move left",
  "Сдвинуть вправо": "Move right",
  "Сделать обложкой": "Make cover",
  "Отбор по тегу": "Filter by tag",
  "Все чаты": "All chats",
  "Теги чата": "Chat tags",
  "Название тега": "Tag name",
  "Свой цвет": "Custom colour",
  "Тег": "Tag",
  "Точно удалить?": "Delete for sure?",
  "Тегов пока нет. Создайте первый — например «Ждёт оплату» или «Отправить».": "No tags yet. Create the first one — e.g. “Awaiting payment” or “To ship”.",
  "Изменить тег": "Edit tag",
  "Новый тег": "New tag",
  "Не удалось сохранить теги чата.": "Couldn't save the chat's tags.",
  "Не удалось сохранить тег.": "Couldn't save the tag.",
  "Не удалось удалить тег.": "Couldn't delete the tag.",
  "Введите название тега.": "Enter a tag name.",
  "Тегов не может быть больше 40.": "You can't have more than 40 tags.",
  "Тег с таким названием уже есть.": "A tag with this name already exists.",
  "Неверный цвет тега.": "Invalid tag colour.",
  "Тег не найден.": "Tag not found.",
  "Не удалось определить чат.": "Couldn't identify the chat.",
  "Kleinanzeigen не открыл форму публикации — похоже, сессия аккаунта истекла.": "Kleinanzeigen did not open the listing form — the account session seems to have expired.",
  "Kleinanzeigen не ответил вовремя через прокси аккаунта. Повторите позже.": "Kleinanzeigen did not respond in time through the account proxy. Try again later.",
  "Не удалось открыть форму публикации Kleinanzeigen для чтения PLZ.": "Could not open the Kleinanzeigen listing form to read the postcode.",
  "Аккаунты в диалогах": "Accounts in conversations",
  "Скрыты": "Hidden",
  "Непрочитанные в скрытых аккаунтах": "Unread in hidden accounts",
  "Показать": "Show",
  "Скрыть диалоги этого аккаунта": "Hide this account's conversations",
  "Показать диалоги этого аккаунта": "Show this account's conversations",
  "Диалогов пока нет": "No conversations yet",
  "Скрытые аккаунты пропадают только из списка — сообщения на них по-прежнему приходят.": "Hidden accounts only disappear from the list — their messages still arrive.",
  "Коммерческий аккаунт: в объявлениях обязателен Impressum": "Business account: listings require an Impressum",
  "Прокси невалиден — диалоги не загружаются: {0}": "Invalid proxy — conversations are not loading: {0}",
  "Прокси аккаунта лида недоступен или настроен некорректно.": "The lead account's proxy is unreachable or misconfigured.",
  "Прокси аккаунта настроен некорректно (host/port). Аккаунт исключен из загрузки сообщений.": "The account's proxy is misconfigured (host/port). The account has been excluded from message loading.",
  "Прокси аккаунта не может подключиться к Kleinanzeigen.": "The account's proxy cannot connect to Kleinanzeigen.",
  "Прокси аккаунта не может подключиться к Kleinanzeigen. Проверьте прокси аккаунта и попробуйте снова.": "The account's proxy cannot connect to Kleinanzeigen. Check it and try again.",
  "Прокси аккаунта не найден. Аккаунт исключен из загрузки сообщений.": "The account's proxy was not found. The account has been excluded from message loading.",
  "Прокси аккаунта недавно изменился. Подождите немного и повторите действие.": "The account's proxy changed recently. Wait a moment and try again.",
  "Прокси аккаунта недоступен.": "The account's proxy is unreachable.",
  "Прокси аккаунта недоступен. Аккаунт временно исключен из загрузки сообщений.": "The account's proxy is unreachable. The account has been excluded from message loading for now.",
  "Прокси аккаунта обновлен.": "The account's proxy has been changed.",
  "Прокси активно": "Proxy active",
  "Прокси больше не DE": "The proxy is no longer in DE",
  "Прокси больше не DE: {0}": "The proxy is no longer in DE: {0}",
  "Прокси для аккаунта настроен некорректно (host/port).": "The account's proxy is misconfigured (host/port).",
  "Прокси для аккаунта не найден.": "No proxy was found for the account.",
  "Прокси ещё не проверялся": "The proxy has not been checked yet",
  "Прокси и сессии": "Proxies and sessions",
  "Прокси настроен некорректно (host/port).": "The proxy is misconfigured (host/port).",
  "Прокси настроен некорректно (host/port). Смена прокси остановлена.": "The proxy is misconfigured (host/port). The change was stopped.",
  "Прокси настроен некорректно.": "The proxy is misconfigured.",
  "Прокси не вернул геоданные.": "The proxy returned no location data.",
  "Прокси не задан для проверки cookies.": "No proxy was given for the cookie check.",
  "Прокси не используется: IP совпадает с реальным": "The proxy is not in use: the IP matches your real one",
  "Прокси не может подключиться к Kleinanzeigen.": "The proxy cannot connect to Kleinanzeigen.",
  "Прокси не найден": "Proxy not found",
  "Прокси не отвечает": "The proxy is not responding",
  "Прокси не работает": "The proxy is not working",
  "Прокси обязателен для публикации объявления.": "A proxy is required to publish a listing.",
  "Прокси обязателен для смены имени.": "A proxy is required to change the name.",
  "Прокси парсера": "Parser proxies",
  "Прокси парсера не отвечает — перевод не выполнен.": "The parser proxy is not responding — the translation did not run.",
  "Прокси серверы": "Proxy servers",
  "Прокси удален": "Proxy deleted",
  "Прокси уже привязан к этому аккаунту.": "That proxy is already linked to this account.",
  "Прокси-сервер недоступен": "The proxy server is unreachable",
  "Прокси-сервера": "Proxy servers",
  "Промокод еще не активен": "The promo code is not active yet",
  "Промокод исчерпан": "The promo code is used up",
  "Промокод не найден": "Promo code not found",
  "Промокод не применим к выбранному тарифу": "The promo code does not apply to the chosen plan",
  "Промокод не указан": "No promo code given",
  "Промокод недействителен": "The promo code is not valid",
  "Промокод отключен": "The promo code is disabled",
  "Пропущено": "Skipped",
  "Просматриваем объявление": "Opening the listing",
  "Просмотр полного текста сообщений": "Viewing the full message text",
  "Просмотры": "Views",
  "Просмотры: от {0} до {1}": "Views: {0} to {1}",
  "Профиль": "Profile",
  "Профиль не найден": "Profile not found",
  "Профиль, подписка, уведомления и оформление": "Profile, subscription, notifications and appearance",
  "Публикация": "Publication",
  "Публикация была остановлена пользователем.": "The publication was stopped by the user.",
  "Публикация выполняется": "Publishing in progress",
  "Публикация еще выполняется на сервере. Ожидаю финальный статус...": "The publication is still running on the server. Waiting for the final status...",
  "Публикация завершилась ошибкой": "The publication failed",
  "Публикация завершилась с ошибкой": "The publication failed",
  "Публикация завершилась с ошибкой.": "The publication failed.",
  "Публикация запланирована": "Publication scheduled",
  "Публикация и статусы объявлений": "Publishing and listing statuses",
  "Публикация не завершилась корректно.": "The publication did not finish cleanly.",
  "Варианты параметров этой категории обновлены с Kleinanzeigen — выберите отклонённый параметр заново и опубликуйте ещё раз.": "This category's parameter options have been refreshed from Kleinanzeigen — pick the rejected parameter again and publish once more.",
  "Публикация не подтверждена: KL принял отправку, но объявление не найдено. Проверьте аккаунт на KL.": "The publication is unconfirmed: Kleinanzeigen accepted the submission, but the listing cannot be found. Check the account on KL.",
  "Публикация недоступна до отключения заморозки в настройках.": "Publishing stays unavailable until the freeze is switched off in the settings.",
  "Публикация объявления": "Publishing the listing",
  "Публикация остановлена": "Publication stopped",
  "Публикация с этим requestId уже запущена. Дождитесь завершения.": "A publication with this requestId is already running. Wait for it to finish.",
  "Публикация уже запущена на сервере. Подключаюсь к текущему статусу...": "The publication is already running on the server. Attaching to its current status...",
  "Публикация успешно завершена": "The publication finished successfully",
  "Публикация черновика завершилась ошибкой": "Publishing the draft failed",
  "Публикация черновика завершилась с ошибкой": "Publishing the draft failed",
  "Публикация, редактирование и контроль статусов в едином рабочем процессе.": "Publishing, editing and status tracking in one workflow.",
  "Публикация...": "Publishing...",
  "Публикация: сразу после нажатия кнопки": "Publication: immediately after the button is pressed",
  "Публикую…": "Publishing…",
  "Пул прокси парсера пуст — добавьте прокси в админке": "The parser proxy pool is empty — add proxies in the admin area",
  "Пул пуст — парсер работать не будет.": "The pool is empty — the parser will not run.",
  "Пустое сообщение": "Empty message",
  "Пустое фото.": "Empty photo.",
  "Пустой ответ": "Empty response",
  "Пустой ответ.": "Empty response.",
  "Работает": "Working",
  "Работают": "Working",
  "Развернуть список диалогов": "Expand the conversation list",
  "Развернуть чат": "Expand the chat",
  "Разделы временно заблокированы. Перейдите в Настройки и отключите заморозку.": "The sections are locked for now. Go to Settings and switch the freeze off.",
  "Разделы панели временно заблокированы, пока подписка на заморозке. Отключите заморозку в блоке ниже.": "The panel's sections are locked while the subscription is frozen. Switch the freeze off in the block below.",
  "Разрешены только изображения.": "Only images are allowed.",
  "Рассылка отправлена": "Broadcast sent",
  "Рассылка уведомлений": "Notification broadcast",
  "Рег.": "Reg.",
  "Регистрация": "Registration",
  "Регистрация завершена, но вход не удалось подтвердить.": "Registration finished, but the sign-in could not be confirmed.",
  "Регистрация на Kleinanzeigen: {0}": "Registered on Kleinanzeigen: {0}",
  "Регистрация отклонена Kleinanzeigen.": "Kleinanzeigen rejected the registration.",
  "Регистрация отправлена. Вставьте ссылку из письма для продолжения.": "The registration has been submitted. Paste the link from the email to continue.",
  "Регистрация отправлена. Вставьте ссылку из письма.": "The registration has been submitted. Paste the link from the email.",
  "Регистрация отправлена. Подтвердите ссылку из письма и продолжайте в панели.": "The registration has been submitted. Confirm the link from the email and carry on in the panel.",
  "Регистрация...": "Registering...",
  "Редактирование": "Editing",
  "Редактирование объявления": "Editing the listing",
  "Редактировать": "Edit",
  "Режим массового импорта: найдено": "Bulk import mode: found",
  "Резерв": "Reserve",
  "Резерв...": "Reserving...",
  "Резервировать": "Reserve",
  "Результат": "Result",
  "Рейтинг": "Rating",
  "Рейтинг аккаунта": "Account rating",
  "Рейтинг ещё не загружен — обновите аккаунт": "The rating has not loaded yet — refresh the account",
  "Реквизиты": "Payment details",
  "Реквизиты не найдены.": "The payment details were not found.",
  "Реквизиты удалены": "Payment details deleted",
  "Реквизиты, платежи и генератор шрифтов": "Payment details, payments and the font generator",
  "Реферальный код (необязательно)": "Referral code (optional)",
  "Рост просмотров": "View growth",
  "С возвращением": "Welcome back",
  "С доставкой": "With delivery",
  "Сбор и структурирование данных из карточек объявлений в рабочие списки.": "Collecting and structuring listing data into working lists.",
  "Свежая регистрация": "Recently registered",
  "Свернуть": "Collapse",
  "Свернуть список": "Collapse the list",
  "Светлая": "Light",
  "Сводка за сегодня, {0}": "Today's summary, {0}",
  "Свои объявления": "My listings",
  "Связь с сервером прервалась. Проверяю итоговый статус публикации...": "The connection to the server dropped. Checking the final publication status...",
  "Сделай краткий анализ диалога: стадия, риск, что уже согласовано, что нужно уточнить дальше. Ответ в формате короткого списка.": "Give a brief analysis of the conversation: stage, risk, what has been agreed, and what still needs clarifying. Answer as a short list.",
  "Сделай точный перевод последнего входящего сообщения на русский язык. Сохрани исходный смысл и тон. Коротко отметь возможные двусмысленности.": "Translate the last incoming message into Russian accurately. Keep the original meaning and tone. Briefly note any ambiguities.",
  "Сегодня": "Today",
  "Сейчас выполняется Sender-задача этого аккаунта.": "A Sender task is running for this account.",
  "Сейчас выполняется общая синхронизация PicClick. Дождитесь завершения.": "A full PicClick sync is running. Wait for it to finish.",
  "Сейчас выполняется публикация объявления.": "A listing publication is running.",
  "Сендер": "Sender",
  "Сервер вернул ошибку валидации объявления.": "The server returned a listing validation error.",
  "Не удалось опубликовать": "Couldn't publish",
  "Опубликуется {0}": "Publishes {0}",
  "Публикуется…": "Publishing…",
  "Объявление уже видно покупателям.": "The listing is already visible to buyers.",
  "Kleinanzeigen проверяет объявление — статус обновится во вкладке «Объявления».": "Kleinanzeigen is reviewing the listing — the status will update in the “Listings” tab.",
  "Kleinanzeigen снял объявление сразу после публикации.": "Kleinanzeigen took the listing down right after publishing.",
  "Статус появится во вкладке «Объявления».": "The status will appear in the “Listings” tab.",
  "Временный сбой на стороне Kleinanzeigen. Проверьте, не появилось ли объявление, и повторите публикацию": "A temporary failure on Kleinanzeigen's side. Check whether the listing appeared, and publish again",
  "Прокси не отвечает — соединение оборвалось. Проверьте прокси аккаунта и повторите публикацию.": "The proxy is not responding — the connection dropped. Check the account's proxy and publish again.",
  "Прокси не отвечает — соединение оборвалось во время отправки. Проверьте, не появилось ли объявление на Kleinanzeigen, и только потом повторяйте.": "The proxy is not responding — the connection dropped while sending. Check whether the listing appeared on Kleinanzeigen before trying again.",
  "Kleinanzeigen требует заново подтвердить номер телефона этого аккаунта. Откройте меню аккаунта → «Телефон», подтвердите номер кодом из SMS и опубликуйте объявление снова.": "Kleinanzeigen requires this account's phone number to be confirmed again. Open the account menu → “Phone”, confirm the number with the SMS code and publish the listing again.",
  // Отказы проверки KL (backend/src/klValidationText.js).
  "Kleinanzeigen требует имя продавца, а у аккаунта оно не заполнено. Задайте его в меню аккаунта → «Сменить имя» и повторите.": "Kleinanzeigen requires a seller name, and this account has none. Set it in the account menu → “Change name” and try again.",
  "Для коммерческого аккаунта Kleinanzeigen требует Impressum. Заполните поле «Юридическая информация» в объявлении или Impressum в настройках аккаунта на Kleinanzeigen и повторите.": "Kleinanzeigen requires an Impressum for a commercial account. Fill in “Legal information” in the listing or the Impressum in the account settings on Kleinanzeigen and try again.",
  "Kleinanzeigen не принял объявление при проверке. Проверьте поля и повторите.": "Kleinanzeigen rejected the listing during validation. Check the fields and try again.",
  "Имя продавца": "Seller name",
  "Тип цены": "Price type",
  "Сервер временно перегружен (браузерный движок). Подождите 20-60 секунд и повторите действие.": "The server is overloaded for the moment (browser engine). Wait 20-60 seconds and try again.",
  "Сервер временно перегружен (браузерный движок). Подождите 20-60 секунд и повторите отправку.": "The server is overloaded for the moment (browser engine). Wait 20-60 seconds and send again.",
  "Сервер временно перегружен. Повторите публикацию черновика вручную через 10-20 секунд.": "The server is overloaded for the moment. Publish the draft again by hand in 10-20 seconds.",
  "Сервер не вернул jobId Sender": "The server returned no Sender jobId",
  "Сервис вернул пустой ответ": "The service returned an empty response",
  "Серфинг по категории": "Browsing the category",
  "Сессия аккаунта истекла. Обновите cookie.": "The account's session has expired. Refresh the cookies.",
  "Сессия аккаунта не содержит валидных cookies.": "The account's session holds no valid cookies.",
  "Сессия аккаунта невалидна (401).": "The account's session is invalid (401).",
  "Сессия аккаунта невалидна (403).": "The account's session is invalid (403).",
  "Сессия аккаунта невалидна.": "The account's session is invalid.",
  "Сессия аккаунта невалидна. Обновите cookies (аккаунт исключен из загрузки сообщений).": "The account's session is invalid. Refresh the cookies — it has been excluded from message loading.",
  "Сессия аккаунта невалидна. Обновите cookies.": "The account's session is invalid. Refresh the cookies.",
  "Сессия истекла, пожалуйста, перелогиньтесь в Kleinanzeigen.": "The session has expired — please sign in to Kleinanzeigen again.",
  "Сессия не найдена": "Session not found",
  "Сессия подтверждения не найдена или истекла.": "The confirmation session was not found, or has expired.",
  "Сессия подтверждения принадлежит другому аккаунту.": "The confirmation session belongs to a different account.",
  "Сессия прогрева не найдена": "Warm-up session not found",
  "Сессия регистрации не найдена или истекла.": "The registration session was not found, or has expired.",
  "Сетевая ошибка при соединении через прокси.": "Network error while connecting through the proxy.",
  "Сетевая ошибка при соединении. Проверьте прокси.": "Network error while connecting. Check the proxy.",
  "Сетевая работа:": "Networking:",
  "Синхронизация была прервана. Запустите снова.": "The sync was interrupted. Start it again.",
  "Синхронизация не запущена": "No sync is running",
  "Системное уведомление": "System notification",
  "Скопировано": "Copied",
  "Скопировать ответ": "Copy the reply",
  "Скопировать сообщение": "Copy the message",
  "Скопировать текст": "Copy the text",
  "Скоро": "Soon",
  "Скрыть список": "Hide the list",
  "Следите за статусами, лидами и ошибками в реальном времени.": "Watch statuses, leads and errors in real time.",
  "Следующее изображение": "Next image",
  "Слишком длинное значение attributeMap.": "The attributeMap value is too long.",
  "Слишком длинное описание объявления.": "The listing description is too long.",
  "Слишком длинный заголовок объявления.": "The listing title is too long.",
  "Слишком длинный текст для перевода (макс 5000 символов).": "The text is too long to translate (max 5000 characters).",
  "Слишком много запросов — kleinanzeigen применил лимит. Повторите позже.": "Too many requests — Kleinanzeigen has rate-limited you. Try again later.",
  "Слишком много запросов — kleinanzeigen применил лимит. Подождите и попробуйте позже.": "Too many requests — Kleinanzeigen has rate-limited you. Wait and try again later.",
  "Слишком много изображений в payload.": "Too many images in the payload.",
  "Слишком много попыток. Попробуйте позже.": "Too many attempts. Try again later.",
  "Слишком много файлов. Максимум 10 изображений.": "Too many files. At most 10 images.",
  "Слишком много файлов. Максимум 20 изображений.": "Too many files. At most 20 images.",
  "Слишком много фото. На объявлении может быть максимум 20 изображений.": "Too many photos. A listing can hold at most 20 images.",
  "Слишком частые действия для аккаунта. Подождите немного и повторите попытку.": "Too many actions on this account too quickly. Wait a moment and try again.",
  "Случайная добавка ±": "Random jitter ±",
  "Смена имени аккаунта": "Changing the account name",
  "Смена пароля": "Change password",
  "Смена прокси аккаунта": "Changing the account's proxy",
  "Сменить имя": "Change name",
  "Сменить пароль": "Change password",
  "Сменить прокси": "Change proxy",
  "Сначала выберите аккаунт": "Select an account first",
  "Сначала выберите диалог с аккаунтом.": "Select a conversation with an account first.",
  "Сначала выберите диалог слева": "Select a conversation on the left first",
  "Сначала выполните вход": "Sign in first",
  "Сначала выполните вход: нажмите «Войти» или «Регистрация».": "Sign in first: press «Sign in» or «Register».",
  "Сначала новые": "Newest first",
  "Сначала старые": "Oldest first",
  "С подпиской": "With subscription",
  "Без подписки": "Without subscription",
  "Сначала отправляется регистрация, затем вставляется email-ссылка. Если указан телефон, следующим шагом будет ввод SMS-кода.": "The registration is submitted first, then you paste the email link. If a phone number is given, entering the SMS code comes next.",
  "Сначала протестируйте прокси": "Test the proxy first",
  "Снято с KL": "Removed from KL",
  "Снято с публикации": "Unpublished",
  "Снять все": "Deselect all",
  "Содержимое cookies вручную": "Cookie contents by hand",
  "Соединение не проверялось": "The connection has not been checked",
  "Создайте доступ и войдите в рабочую панель.": "Create access and sign in to the panel.",
  "Создайте доступ к панели": "Create panel access",
  "Создание аккаунта": "Creating the account",
  "Создано": "Created",
  "Создать аккаунт": "Create account",
  "Создать объявление": "Create listing",
  "Сообщений всего": "Messages in total",
  "Сообщения": "Messages",
  "Сортировка": "Sorting",
  "Состояние Sender": "Sender state",
  "Сохранение...": "Saving...",
  "Сохранено · прокси в пуле: {0}": "Saved · proxies in the pool: {0}",
  "Сохранено · прокси не задан": "Saved · no proxy set",
  "Сохранить": "Save",
  "Сохранить запись": "Save record",
  "Сохранить изменения": "Save changes",
  "Сохранить настройки": "Save settings",
  "Сохранить черновик": "Save draft",
  "Список категорий выглядит неполным": "The category list looks incomplete",
  "Средний": "Medium",
  "Срок действия должен быть позже времени старта.": "The expiry must be later than the start time.",
  "Срок действия промокода истек": "The promo code has expired",
  "Срок заморозки: {0} дн.": "Freeze length: {0} days",
  "Ссылка": "Link",
  "Ссылка должна вести на страницу товара eBay.": "The link must point to an eBay item page.",
  "Ссылка из письма:": "Link from the email:",
  "Ссылка на лот": "Item link",
  "Ссылка на лот — заберём title, описание и фото": "Item link — we will pull the title, description and photos",
  "Ссылка повторной отправки не найдена.": "The resend link was not found.",
  "Ссылка подтверждения открыта, SMS-код для телефона отправлен.": "The confirmation link has been opened and the phone SMS code sent.",
  "Ссылка подтверждения открыта.": "The confirmation link has been opened.",
  "Ссылки на объявления": "Listing links",
  "Ставим публикацию в очередь": "Queueing the publication",
  "Стартуйте публикацию, Sender и автообработку сообщений.": "Start publishing, Sender and automatic message handling.",
  "Статус": "Status",
  "Статус на Kleinanzeigen": "Status on Kleinanzeigen",
  "Статус не определен": "Status undetermined",
  "Статус не подтвержден": "Status not confirmed",
  "Статус отправки медиа не найден": "The media sending status was not found",
  "Статус публикации не найден": "Publication status not found",
  "Статус: верифицирован": "Status: verified",
  "Стоп-слова": "Stop words",
  "Страна: {0}": "Country: {0}",
  "Сумма €": "Amount €",
  "Сформируй короткий вежливый ответ продавца на немецком языке (2-5 предложений), по фактам диалога. Без эмодзи и без фантазий.": "Write a short, polite seller reply in German (2-5 sentences) based on the facts of the conversation. No emoji, nothing invented.",
  "Счет создан": "Invoice created",
  "Таймаут при загрузке параметров категории.": "Timed out loading the category fields.",
  "Таймаут соединения с прокси": "Proxy connection timed out",
  "Тайминг": "Timing",
  "Тариф": "Plan",
  "Тариф не выбран": "No plan chosen",
  "Тариф не найден": "Plan not found",
  "Текст cookies слишком большой.": "The cookie text is too large.",
  "Текст кнопки (опционально)": "Button text (optional)",
  "Текст куки:": "Cookie text:",
  "Текст обрезан до 4000 символов": "The text was trimmed to 4000 characters",
  "Текст обязателен для перевода.": "Text is required for translation.",
  "Текст ответа пустой.": "The reply text is empty.",
  "Текст пустой, введите сообщение:": "The text is empty — enter a message:",
  "Текст пустой.": "The text is empty.",
  "Текст сообщения...": "Message text...",
  "Текст уведомления": "Notification text",
  "Текущий": "Current",
  "Текущий пароль": "Current password",
  "Текущий пароль указан неверно": "The current password is wrong",
  "Телефон": "Phone",
  "Телефон DE без +49 (опционально):": "German phone without +49 (optional):",
  "Телефон подтвержден.": "The phone has been confirmed.",
  "Телефон подтвержден. Теперь можно выполнить вход и добавить аккаунт.": "The phone is confirmed. You can now sign in and add the account.",
  "Тема оформления": "Theme",
  "Тестирование...": "Testing...",
  "Тестировать": "Test",
  "Тестируется": "Testing",
  "Тип": "Type",
  "Тип аккаунта:": "Account type:",
  "Тип аккаунта": "Account type",
  "Тип продавца": "Seller type",
  "Тип реквизита": "Payment method type",
  "Только всплески": "Spikes only",
  "Только выбранным ownerId": "Only to the chosen ownerIds",
  "Только на десктопе": "Desktop only",
  "Только самовывоз": "Pickup only",
  "Только что": "Just now",
  "Требуется авторизация": "Authorisation required",
  "Требуется активная подписка": "An active subscription is required",
  "Требуется вход": "Sign-in required",
  "Требуется вход в аккаунт": "You need to sign in to the account",
  "Требуется вход в систему": "You need to sign in",
  "Требуются права администратора": "Administrator rights are required",
  "Ты помощник продавца на Kleinanzeigen. Отвечай строго по делу, без выдуманных фактов. Если контекста мало - так и напиши.": "You are a seller's assistant on Kleinanzeigen. Stay strictly on point and invent nothing. If there is too little context, say so.",
  "Тёмная": "Dark",
  "Тёмная — экономит зрение, подходит для долгой работы. Светлая — выше контраст текста и таблиц. Графит — структура светлой темы, но в строгом тёмно-сером.": "Dark is easier on the eyes over a long session. Light gives text and tables more contrast. Graphite keeps the light theme's structure in a restrained dark grey.",
  "У администратора это право есть всегда": "An administrator always has this right",
  "У аккаунта не назначен прокси — прогрев невозможен.": "The account has no proxy assigned — a warm-up is not possible.",
  "У аккаунта не сохранены cookies.": "The account has no saved cookies.",
  "У аккаунта нет cookies — прогрев невозможен.": "The account has no cookies — a warm-up is not possible.",
  "Убрать {0}": "Remove {0}",
  "Убрать из избранного": "Remove from favourites",
  "Убрать из моей ленты": "Remove from my feed",
  "Убрать": "Remove",
  "Уведомление": "Notification",
  "Уведомление доставится при следующем обновлении у пользователей.": "The notification arrives the next time users refresh.",
  "Уведомление устарело.": "The notification is out of date.",
  "Уведомления": "Notifications",
  "Уведомления Telegram": "Telegram notifications",
  // Смена встроенного прокси Umbrella
  "Прокси сменён": "Proxy switched",
  "Подключён прокси Umbrella": "Umbrella proxy connected",
  "Каждому аккаунту — свой прокси из пула": "Each account gets its own proxy from the pool",
  "Встроенный прокси · подключить": "Built-in proxy · connect",
  "Меняем...": "Switching...",
  "Следующий прокси Umbrella — по кругу, неработающие пропускаются": "Next Umbrella proxy, in turn; ones that don't respond are skipped",
  "Свои прокси": "Your proxies",
  "Сменить прокси Umbrella на следующий": "Switch to the next Umbrella proxy",
  "Других рабочих прокси Umbrella сейчас нет.": "There are no other working Umbrella proxies right now.",
  "Встроенный прокси панели не настроен.": "The panel's built-in proxy isn't set up.",
  // Предпросмотр объявления (components/AdPreviewDialog.jsx)
  "Так объявление увидят на Kleinanzeigen": "This is how buyers will see it on Kleinanzeigen",
  "Где": "Location",
  "PLZ не указан": "No postcode",
  "Запланирована на {0}": "Scheduled for {0}",
  "Сразу после нажатия «Опубликовать»": "Right after you press “Publish”",
  "Предыдущее фото": "Previous photo",
  "Следующее фото": "Next photo",
  "Фото объявления": "Listing photo",
  "Публикуем...": "Publishing...",
  // Массовые действия с объявлениями (ActiveAdsTab)
  "В резерв": "Reserve",
  "В резерв: {0} из {1}": "Reserved: {0} of {1}",
  "Активировано: {0} из {1}": "Activated: {0} of {1}",
  "Удалено: {0} из {1}": "Deleted: {0} of {1}",
  "Удалить объявлений: {0}": "Delete {0} listings",
  "Объявления будут удалены с Kleinanzeigen. Вернуть их будет нельзя.": "The listings will be deleted from Kleinanzeigen. This can't be undone.",
  "Не удалось выполнить действие": "The action failed",
  "Остановлено, не тронуто: {0}": "Stopped, left untouched: {0}",
  "Ошибки: {0}": "Errors: {0}",
  "Среди выбранных таких нет": "None of the selected listings fit",
  "Выбрать все ({0})": "Select all ({0})",
  "Выполняется: {0} из {1}": "In progress: {0} of {1}",
  "Остановить": "Stop",
  "Уже начатые доделаются, остальные не тронутся": "Listings already in progress will finish; the rest won't be touched",
  "Снять выбор": "Deselect",
  "Выбрать объявление": "Select listing",
  // Редактор фото в окне публикации (components/PhotoEditor.jsx)
  "Редактировать фото": "Edit photo",
  "Загружаем фото…": "Loading photo…",
  "Не удалось открыть фото": "Couldn't open the photo",
  "Повернуть влево": "Rotate left",
  "Повернуть вправо": "Rotate right",
  "Обрезка": "Crop",
  "Свободно": "Free",
  "Яркость": "Brightness",
  "Сбросить": "Reset",
  "Не удалось сохранить фото. Попробуйте ещё раз.": "Couldn't save the photo. Please try again.",
  // Горячие клавиши в сообщениях (utils/messageHotkeys.js)
  "Горячие клавиши": "Keyboard shortcuts",
  "Работают и из поля ответа": "They work from the reply field too",
  "Все клавиши: {0}": "All shortcuts: {0}",
  "Следующий / предыдущий диалог": "Next / previous conversation",
  "Следующий непрочитанный": "Next unread",
  "Вставить подсказку нейросети": "Insert the AI suggestion",
  "Отправить и открыть следующий непрочитанный": "Send and open the next unread",
  "Архивировать и открыть следующий": "Archive and open the next one",
  "Вставить быстрый ответ с этим номером": "Insert the quick reply with that number",
  "Закрыть диалог": "Close conversation",
  "Эта подсказка": "This help",
  "Непрочитанных больше нет": "No more unread conversations",
  "Быстрого ответа № {0} нет": "There's no quick reply #{0}",
  "Переводчик: открыть или закрыть": "Translator: open or close",
  // Переводчик у поля ответа (components/ComposerTranslator.jsx)
  "Переводчик": "Translator",
  "Немецкий": "German",
  "Русский": "Russian",
  "Английский": "English",
  "Украинский": "Ukrainian",
  "Польский": "Polish",
  "Турецкий": "Turkish",
  "Арабский": "Arabic",
  "Румынский": "Romanian",
  "Болгарский": "Bulgarian",
  "Итальянский": "Italian",
  "Французский": "French",
  "Испанский": "Spanish",
  "Язык текста": "Source language",
  "Язык перевода": "Target language",
  "Поменять языки местами": "Swap languages",
  "Закрыть переводчик": "Close the translator",
  "Текст для перевода": "Text to translate",
  "Переводим…": "Translating…",
  "Здесь будет перевод": "The translation appears here",
  "Вставить перевод в поле ответа": "Put the translation into the reply",
  "В ответ": "Use in reply",
  "Определить язык": "Detect language",
  "Авто · {0}": "Auto · {0}",
  "Перевод на {0}": "Translated into {0}",
  // Поиск и порядок объявлений (ActiveAdsTab) — для больших аккаунтов
  "Меньше просмотров": "Fewest views",
  "Чаще в избранном": "Most favourited",
  "Сначала дешевле": "Cheapest first",
  "Сначала дороже": "Most expensive first",
  "Поиск по названию или номеру": "Search by title or number",
  "Поиск по объявлениям": "Search listings",
  "Статус объявлений": "Listing status",
  "Порядок объявлений": "Listing order",
  "Найдено {0} из {1}": "Found {0} of {1}",
  "По этому отбору объявлений нет": "No listings match this filter",
  "Сбросить поиск и статус": "Clear search and status",
  "Показать ещё {0} · осталось {1}": "Show {0} more · {1} left",
  "Скрытые": "Hidden",
  "Вернуть": "Restore",
  "Вернуть в панель": "Show in the panel again",
  "Скрыть из панели": "Hide from the panel",
  "Скрыть из панели (на Kleinanzeigen не меняется)": "Hide from the panel (nothing changes on Kleinanzeigen)",
  "Убрать из панели. На Kleinanzeigen объявление не меняется": "Remove from the panel. The listing doesn't change on Kleinanzeigen",
  "Все объявления скрыты из панели": "All listings are hidden from the panel",
  "Показать скрытые": "Show hidden",
  "Не удалось скрыть": "Couldn't hide",
  "Не удалось вернуть": "Couldn't restore",
  // Расход нейросети в администрировании (components/AdminAiUsageSection.jsx)
  "Расход нейросети": "AI usage",
  " · за сутки {0} токенов": " · {0} tokens in 24 h",
  " · всплеск: {0}": " · spikes: {0}",
  "Сутки": "24 hours",
  " токенов · {0} запросов · на входе {1}, на выходе {2}": " tokens · {0} requests · {1} in, {2} out",
  "По ответам Google: токены на входе и на выходе вместе. Сутки, неделя и месяц — последние 24 часа, 7 и 30 дней. Подсвечен, у кого за сутки в 3 раза больше обычного дня.": "From Google's responses: input and output tokens together. 24 hours, week and month are the last 24 hours, 7 and 30 days. Highlighted: users who spent 3× more in 24 hours than on a usual day.",
  "За этот период нейросетью никто не пользовался": "Nobody used AI in this period",
  "×{0} к обычному дню": "×{0} vs a usual day",
  "всплеск": "spike",
  "{0} запросов · сутки {1} · неделя {2} · месяц {3}": "{0} requests · 24 h {1} · week {2} · month {3}",
  " · обычный день ≈ {0}": " · usual day ≈ {0}",
  "За этот период — без расхода": "No usage in this period",
  "{0} запр.": "{0} req.",
  "AI-ассистент": "AI assistant",
  "Подсказка ответа": "Reply suggestion",
  "Переводчик в поле ответа": "Reply-field translator",
  "Подбор категории": "Category suggestion",
  "Уникализация текста": "Text rewriting",
  // Архив из списка диалогов (MessagesTab)
  "Из архива": "Unarchive",
  "В архив": "Archive",
  // Развёрнутое поле ответа на телефоне (MessagesTab)
  "Развернуть поле ответа": "Expand the reply field",
  "Фото, быстрые ответы, переводчик": "Photo, quick replies, translator",
  "Свернуть поле ответа": "Collapse the reply field",
  // Push на это устройство (utils/webPush.js)
  "Уведомления на этом устройстве": "Notifications on this device",
  "Проверяем…": "Checking…",
  "Включено: сообщения покупателей приходят на это устройство": "On: buyer messages arrive on this device",
  "Сообщения покупателей — даже когда панель закрыта": "Buyer messages, even when the panel is closed",
  "На iPhone — только из панели на экране «Домой»: «Поделиться» → «На экран «Домой»», затем откройте её оттуда": "On iPhone this only works from the panel on the Home Screen: Share → Add to Home Screen, then open it from there",
  "Нужна iOS 16.4 или новее": "Requires iOS 16.4 or later",
  "Этот браузер не поддерживает push-уведомления": "This browser doesn't support push notifications",
  "Уведомления запрещены в настройках браузера или телефона — разрешите их там": "Notifications are blocked in the browser or phone settings. Allow them there",
  "Недоступно в демо": "Not available in the demo",
  "Этот браузер не поддерживает уведомления": "This browser doesn't support notifications",
  "Уведомления включены": "Notifications are on",
  "Сюда будут приходить новые сообщения покупателей": "New buyer messages will arrive here",
  "Уведомления включены, но проверочное не дошло": "Notifications are on, but the test one didn't arrive",
  "Выключите и включите их снова": "Turn them off and on again",
  "Уведомления запрещены": "Notifications are blocked",
  "Разрешите их для панели в настройках браузера или телефона": "Allow them for the panel in the browser or phone settings",
  "Не удалось включить уведомления": "Couldn't turn on notifications",
  "Уведомления на телефон сейчас недоступны": "Phone notifications are unavailable right now",
  "Браузер прислал неподходящую подписку на уведомления": "The browser sent an unsuitable notification subscription",
  "Удаление": "Deletion",
  "Удаление в парсере у всех": "Deleting parser listings for everyone",
  "Все прокси": "All proxies",
  "Приватный: вкл": "Private: on",
  "Видит и может использовать все прокси панели, как администратор": "Sees and can use every proxy in the panel, like an admin",
  "{0}: доступ ко всем прокси {1}.": "{0}: access to all proxies {1}.",
  "разрешён": "granted",
  "закрыт": "revoked",
  "Удаление объявления": "Deleting the listing",
  "Удаление прокси": "Deleting the proxy",
  "Удаление...": "Deleting...",
  "Удалено": "Deleted",
  "Удалено лидов: {0}": "Leads deleted: {0}",
  "Удалено у всех": "Deleted for everyone",
  "Удалить": "Delete",
  "Удалить «{0}» из ленты всех пользователей?": "Remove «{0}» from every user's feed?",
  "Удалить аккаунт": "Delete account",
  "Удалить все email лиды ({0})?": "Delete all email leads ({0})?",
  "Удалить запись": "Delete record",
  "Удалить лид": "Delete lead",
  "Удалить объявление \"{0}\"?": "Delete the listing \"{0}\"?",
  "Удалить прокси": "Delete proxy",
  "Удалить прокси \"{0}\"?": "Delete the proxy \"{0}\"?",
  "Удалить у всех": "Delete for everyone",
  "Удалить у всех пользователей": "Delete for every user",
  "Удалить фото": "Delete photo",
  "Удалить черновик?": "Delete the draft?",
  "Удалить этот email лид?": "Delete this email lead?",
  "Уже есть доступ? ": "Already have access? ",
  "Укажите ownerId получателей (через запятую).": "List the recipients' ownerIds, comma-separated.",
  "Укажите имя профиля.": "Enter a profile name.",
  "Укажите количество дней (days) или действительный planId": "Give a number of days, or a valid planId",
  "Укажите количество часов": "Enter the number of hours",
  "Укажите корректную ссылку на товар eBay.": "Give a valid eBay item link.",
  "Укажите корректный email.": "Give a valid email address.",
  "Укажите ссылки или поисковый запрос": "Give links or a search query",
  "Укажите хотя бы один прокси": "Give at least one proxy",
  "Укажите часы (1-8760)": "Give a number of hours (1-8760)",
  "Управление подписками": "Subscription management",
  "Уровень": "Level",
  "Уровень уведомления": "Notification level",
  "Условия": "Terms",
  "Файл не найден.": "File not found.",
  "Файл с cookies (.json / .txt)": "Cookie file (.json / .txt)",
  "Файл с куки:": "Cookie file:",
  "Файл слишком большой. Максимум 10MB на изображение.": "The file is too large. At most 10MB per image.",
  "Файл фотографии пуст.": "The photo file is empty.",
  "Файлы изображений не найдены на сервере.": "The image files were not found on the server.",
  "Фиксированная": "Fixed",
  "Фолл.": "Foll.",
  "Фолл.:": "Foll.:",
  "Фоновый мониторинг отключен (KL_BACKGROUND_MESSAGES_SYNC=0).": "Background monitoring is off (KL_BACKGROUND_MESSAGES_SYNC=0).",
  "Форма не была отправлена — страница осталась прежней. См. скриншоты.": "The form was not submitted — the page did not change. See the screenshots.",
  "Форма отправлена, но результат неопределённый. См. скриншоты.": "The form was submitted, but the outcome is unclear. See the screenshots.",
  "Форма регистрации не найдена на странице.": "The registration form was not found on the page.",
  "Форматы распознаются автоматически:": "Formats are detected automatically:",
  "Фото": "Photos",
  "Фото (опционально)": "Photos (optional)",
  "Фото {0}": "Photo {0}",
  "Фото из черновика:": "Photos from the draft:",
  "Фото пока не добавлены": "No photos added yet",
  "Фотографии еще загружаются. Пожалуйста, подождите завершения загрузки и повторите попытку.": "The photos are still uploading. Wait for them to finish and try again.",
  "Фотографии загружены": "Photos uploaded",
  "Фотографии не загрузились (не удалось подтвердить результат загрузки на странице). Проверьте изображения и повторите попытку.": "The photos did not upload — the result could not be confirmed on the page. Check the images and try again.",
  "Фотографии не загрузились (превью не появилось на странице). Проверьте изображения и повторите попытку.": "The photos did not upload — no preview appeared on the page. Check the images and try again.",
  "Функция бота временно недоступна.": "This bot feature is unavailable for now.",
  "Функция отправки 3-го сообщения не настроена.": "Sending the 3rd message is not configured.",
  "Цена": "Price",
  "Цена (€)": "Price (€)",
  "Цена до": "Price to",
  "Цена не менялась.": "The price has not changed.",
  "Цена не указана": "No price given",
  "Цена объявления не заполнена.": "The listing price is empty.",
  "Цена от": "Price from",
  "Цена: по возрастанию": "Price: low to high",
  "Цена: по убыванию": "Price: high to low",
  "Цену": "The price",
  "Частный": "Private",
  "Часть фото пропущена: {0}.": "Some photos were skipped: {0}.",
  "Чат Telegram не привязан к владельцу аккаунтов.": "The Telegram chat is not linked to the accounts' owner.",
  "Чат не авторизован. Нажмите «Войти» или «Регистрация».": "This chat is not signed in. Press «Sign in» or «Register».",
  "Чаты": "Chats",
  "Чаты:": "Chats:",
  "Черновик": "Draft",
  "Черновик «": "Draft «",
  "Черновик не найден": "Draft not found",
  "Черновик не найден.": "Draft not found.",
  "Черновик отправлен на публикацию": "The draft has been submitted for publication",
  "Черновик сохранен": "Draft saved",
  "Черновик сохранен и запланирован": "Draft saved and scheduled",
  "Черновик удален": "Draft deleted",
  "Черновик успешно опубликован": "The draft was published",
  "Черновики": "Drafts",
  "Черновиков пока нет. Откройте \"Создать объявление\" и сохраните черновик.": "No drafts yet. Open \"Create listing\" and save one.",
  "Шаблоны 1/2/3 сообщений обязательны для запуска Sender.": "Templates for messages 1/2/3 are required to start Sender.",
  "Шаблоны 1/2/3 сообщений обязательны.": "Templates for messages 1/2/3 are required.",
  "Шаблоны поддерживают {seller_name}.": "Templates support {seller_name}.",
  "Шаблоны сообщений": "Message templates",
  "Шагов выполнено:": "Steps completed:",
  "Шрифты": "Fonts",
  "Юридическая информация": "Legal information",
  "Язык интерфейса": "Interface language",
  "аккаунт": "account",
  "активен": "active",
  "без прокси": "no proxy",
  "блок(ов) cookies": "cookie block(s)",
  "браузерный fallback": "browser fallback",
  "браузерный запасной путь отключён": "the browser fallback is disabled",
  "в избранном": "in favourites",
  "валидных": "valid",
  "временно ограничен": "temporarily limited",
  "все": "all",
  "выберите": "select",
  "выбор категории": "choosing the category",
  "выкл.": "off",
  "диагностики аккаунта": "account diagnostics",
  "диалог": "conversation",
  "диалога": "conversations",
  "диалогов": "conversations",
  "дн.": "days",
  "дн. · Использовано:": "days · Used:",
  "дополнительные поля": "extra fields",
  "дубликаты убраны: {0}": "duplicates removed: {0}",
  "загрузка формы": "loading the form",
  "загрузка формы правки": "loading the edit form",
  "загрузки PLZ": "loading the postcode",
  "загрузки PLZ прокси": "loading the proxy postcode",
  "загрузки диалога": "loading the conversation",
  "загрузки дочерних категорий": "loading the child categories",
  "загрузки изображения": "loading the image",
  "загрузки категорий": "loading the categories",
  "загрузки параметров категории": "loading the category fields",
  "загрузки сообщений": "loading the messages",
  "записей. Удалите лишние, чтобы добавить новую.": "records. Delete some to add another.",
  "запрещено": "not allowed",
  "и еще": "and",
  "и отключите заморозку.": "and switch the freeze off.",
  "из": "of",
  "из 20": "of 20",
  "или": "or",
  "интервал между отправками": "interval between sends",
  "к автоматизации": "to automation",
  "категорию": "a category",
  "фото": "a photo",
  "Добавьте хотя бы одно фото": "Add at least one photo",
  "код друга": "a friend's code",
  "конвертировано в JPG: {0}": "converted to JPG: {0}",
  "минимум 6 символов": "at least 6 characters",
  "мониторинг работает": "monitoring is running",
  "мс": "ms",
  "на KL сейчас": "on KL right now",
  "название": "a title",
  "не выбрана": "not selected",
  "не найден": "not found",
  "не привязан": "not linked",
  "не проверялся": "not checked",
  "недоступен": "unavailable",
  "нет новых": "nothing new",
  "новое": "new",
  "новых": "new",
  "обложка": "cover",
  "обновление": "refresh",
  "объявл.": "listings",
  "обычных аккаунтов": "regular accounts",
  "обязательно": "required",
  "обязательный параметр": "required field",
  "обязательных параметра": "required fields",
  "обязательных параметров": "required fields",
  "ожидает 3-е": "awaiting the 3rd",
  "описание": "a description",
  "опрос каждые": "polled every",
  "опционально": "optional",
  "ошибка": "error",
  "ошибка загрузки": "loading error",
  "ошибка отправки": "sending error",
  "ошибок": "errors",
  "панель": "panel",
  "параметр": "field",
  "повторите пароль": "repeat the password",
  "поддержка {seller_name}": "supports {seller_name}",
  "привязан": "linked",
  "приостановлен": "paused",
  "проверка": "checking",
  "проверка…": "checking…",
  "просм. ·": "views ·",
  "пуш": "boost",
  "раз /": "times /",
  "разрешено": "allowed",
  "резкий рост": "sharp growth",
  "рост": "growth",
  "с": "s",
  "с, сессия:": "s, session:",
  "сек": "sec",
  "файл(ов)": "file(s)",
  "фото: {0}": "photos: {0}",
  "цену": "a price",
  "ч": "h",
  "← Назад": "← Back",
  "✅ Kleinanzeigen Backend работает!": "✅ The Kleinanzeigen backend is running!",
  "✅ Прокси работает!": "✅ The proxy works!",
  "✅ Прокси удален!": "✅ Proxy deleted!",
  "🔄 Обновить": "🔄 Refresh",
  "🔗 Управление прокси": "🔗 Proxy management",
  // Оценки собеседников
  "Плохо": "Bad",
  "Нормально": "Okay",
  "Хорошо": "Good",
  "Оценки собеседника": "Contact ratings",
  "Нет ссылки на профиль собеседника — оценить нельзя": "No profile link for this contact — rating is unavailable",
  "Оценить собеседника": "Rate this contact",
  "Оценить": "Rate",
  "Собеседник": "Contact",
  "Оценка собеседника": "Contact rating",
  "Ваша оценка": "Your rating",
  "Как прошло общение?": "How did it go?",
  "Комментарий — по желанию: что случилось, как платил, пришёл ли": "Comment (optional): what happened, how they paid, whether they showed up",
  "Оценку увидят все пользователи панели в диалогах с этим человеком": "All panel users will see this rating in conversations with this person",
  "Вы оценили {0} · аккаунт {1}": "You rated on {0} · account {1}",
  "Вы оценили {0}": "You rated on {0}",
  "Убрать оценку": "Remove rating",
  "Сохраняю...": "Saving...",
  "Оценки других пользователей панели": "Ratings from other panel users",
  "Без комментария": "No comment",
  "Не удалось сохранить оценку. Попробуйте ещё раз.": "Could not save the rating. Please try again.",
  "Не удалось убрать оценку. Попробуйте ещё раз.": "Could not remove the rating. Please try again.",
  "Введите сообщение": "Type a message",
  // Уведомления об ошибках действий в сообщениях
  "Сообщение не отправлено": "Message not sent",
  "Фото не отправлено": "Photo not sent",
  "Предложение не отклонено": "Offer not declined",
  "Ответ не пришёл": "No response",
  "Отправка не подтверждена": "Sending not confirmed",
  "Нет связи с сервером панели. Проверьте интернет и повторите.": "No connection to the panel server. Check your internet and try again.",
  "Прокси аккаунта не отвечает. Проверьте прокси и повторите.": "The account's proxy is not responding. Check the proxy and try again.",
  "Не удалось определить диалог. Откройте его заново и повторите.": "Could not identify the conversation. Open it again and retry.",
  "Фото можно отправить только в уже открытый диалог. Откройте его и повторите.": "Photos can only be sent to an existing conversation. Open it and try again.",
  "Можно отправлять только изображения.": "Only images can be sent.",
  "Сервер не ответил вовремя.": "The server did not respond in time.",
  "Kleinanzeigen не подтвердил отправку.": "Kleinanzeigen did not confirm the sending.",
  "С этим аккаунтом уже выполняется другое действие.": "Another action is already running for this account.",
  "Сессия аккаунта истекла.": "The account session has expired.",
  "Переписку с этого аккаунта загрузить нельзя.": "Conversations can't be loaded from this account.",
  "Повторите позже или смените прокси аккаунта.": "Try again later or change the account's proxy.",
  "У аккаунта нет рабочего прокси.": "The account has no working proxy.",
  "Аккаунт не найден.": "Account not found.",
  "Диалог ещё не загрузился. Обновите диалог и повторите.": "The conversation hasn't loaded yet. Refresh it and try again.",
  "Kleinanzeigen просит подтвердить cookies на этом прокси.": "Kleinanzeigen wants cookies accepted on this proxy.",
  "Размер фото не должен превышать 10 МБ.": "A photo must not exceed 10 MB.",
  "Кол-во фото не должно превышать 10 за раз.": "No more than 10 photos at a time.",
  "Сервер панели перегружен. Повторите позже.": "The panel server is overloaded. Try again later.",
  "Авторизация истекла. Обновите страницу и войдите снова.": "Your sign-in has expired. Reload the page and sign in again.",
  "Доступ к панели закончился. Продлите подписку, чтобы продолжить.": "Your panel access has ended. Renew your subscription to continue.",
  "Что-то пошло не так. Повторите позже.": "Something went wrong. Try again later.",
  "Не удалось начать вход через Telegram": "Couldn't start Telegram sign-in",
  "Вход отменён в Telegram.": "Sign-in was cancelled in Telegram.",
  "Время на подтверждение вышло. Нажмите кнопку ещё раз.": "Confirmation timed out. Press the button again.",
  "Зарегистрироваться через Telegram": "Sign up with Telegram",
  "Войти через Telegram": "Sign in with Telegram",
  "Подтвердите вход в Telegram": "Confirm sign-in in Telegram",
  "Откройте бота": "Open the bot",
  ", нажмите «Старт» и подтвердите вход — панель откроется сама.": ", tap “Start” and confirm — the panel will open by itself.",
  "Входим в панель...": "Signing you in...",
  "Ждём подтверждения в боте...": "Waiting for confirmation in the bot...",
  "Открыть Telegram": "Open Telegram",
  "сейчас": "now",
  "вчера": "yesterday",
  "Непрочитанное": "Unread",
  "Последние диалоги": "Recent chats",
  "Все диалоги": "All chats",
  "до {0}": "until {0}",
  "Не отвечает": "Not responding",
  "Применяем...": "Applying...",
  "Название, адрес или город": "Name, address or city",
  "Прокси ещё не добавлены.": "No proxies added yet.",
  "Ничего не нашлось": "Nothing found",
  "{0} мс": "{0} ms",
  "Подписка": "Subscription",
  "Не оформлена": "Not purchased",
  "Заморожена": "Frozen",
  "Бессрочно": "No expiry",
  "Не активна": "Inactive",
  "Заморозка": "Freeze",
  "Недоступна": "Unavailable",
  "На текущем тарифе": "On the current plan",
  "Включена": "On",
  "Выключена": "Off",
  "Дни": "Days",
  "Пароль задан": "Password set",
  "Введите новый логин": "Enter a new username",
  "Введите текущий пароль": "Enter your current password",
  "Логин изменён": "Username changed",
  "Теперь для входа используйте логин {0}": "From now on, sign in as {0}",
  "Не удалось сменить логин": "Couldn't change the username",
  "Выберите изображение: JPG, PNG или WebP": "Choose an image: JPG, PNG or WebP",
  "Файл слишком большой. Максимум 8 МБ.": "The file is too large. 8 MB max.",
  "Фото обновлено": "Photo updated",
  "Не удалось загрузить фото": "Couldn't upload the photo",
  "Не удалось удалить фото": "Couldn't remove the photo",
  "Сменить фото": "Change photo",
  "Для входа в панель: {0}": "Used to sign in: {0}",
  "Новый логин": "New username",
  "Латиница, цифры, точка, дефис и подчёркивание — от 3 до 40 символов.": "Latin letters, digits, dot, hyphen and underscore — 3 to 40 characters.",
  "Фото профиля": "Profile photo",
  "JPG, PNG или WebP до 8 МБ. При входе через Telegram фото подтягивается оттуда само.": "JPG, PNG or WebP up to 8 MB. Signing in with Telegram pulls your photo from there automatically.",
  "Заменить": "Replace",
  "Загрузить": "Upload",
  "Аккаунт создан через Telegram, своего пароля у него пока нет. Задайте его, чтобы входить и по логину.": "This account was created via Telegram and has no password yet. Set one to also sign in with your username.",
  "Задать пароль": "Set password",
  "Изменить": "Change",
  "Выберите изображение": "Choose an image",
  "Не удалось сохранить аватар": "Couldn't save the photo",
  "Введите новый пароль": "Enter a new password",
  "Работа": "Work",
  "Аккаунты онлайн": "Accounts online",
  "все на связи": "all connected",
  "аккаунтов нет": "no accounts yet",
  "1 офлайн — {0}": "1 offline — {0}",
  "{0} офлайн": "{0} offline",
  "в {0} диалоге": "in {0} chat",
  "в {0} диалогах": "in {0} chats",
  "всё прочитано": "all caught up",
  "Сообщений сегодня": "Messages today",
  "всего {0}": "{0} total",
  "Прокси в работе": "Proxies up",
  "только встроенный": "built-in only",
  "{0} не отвечают": "{0} not responding",
  "все отвечают": "all responding",
  "Активность за неделю": "Activity this week",
  "{0} диалог": "{0} chat",
  "{0} диалога": "{0} chats",
  "{0} диалогов": "{0} chats",
  "Быстрые действия": "Quick actions",
  "Все аккаунты": "All accounts",
  "Офлайн": "Offline",
  "Мои объявления": "My ads",
  "Новый шаблон ответа...": "New reply template...",
  "Нажмите на ответ, чтобы вставить его в сообщение": "Click a reply to insert it into the message",
  "Шаблоны для частых ответов": "Templates for frequent replies",
  "QR-код для оплаты": "Payment QR code",
  "{0} · счёт на {1} USDT": "{0} · invoice for {1} USDT",
  "Доступ открыт": "Access unlocked",
  "Доступ открыт до {0}": "Access unlocked until {0}",
  "Если есть": "If you have one",
  "Ждём оплату": "Waiting for payment",
  "Изменить тариф": "Change plan",
  "К оплате": "To pay",
  "Не удалось загрузить тарифы": "Couldn't load plans",
  "Ожидаем оплату": "Awaiting payment",
  "Оплата в USDT через CryptoBot или xRocket": "Pay in USDT via CryptoBot or xRocket",
  "Оплата временно недоступна. Напишите в поддержку.": "Payments are temporarily unavailable. Please contact support.",
  "Оплата подписки": "Subscription payment",
  "Оплата получена": "Payment received",
  "Оплатить": "Pay",
  "Открыть в {0}": "Open in {0}",
  "Оформите подписку прямо здесь — доступ откроется сразу после оплаты. А пока загляните в демо: все разделы работают на вымышленных данных, ничего не уходит на Kleinanzeigen и не тратит нейросеть.": "Subscribe right here — access opens right after payment. Meanwhile, take a look at the demo: every section runs on made-up data, nothing reaches Kleinanzeigen and no AI is used.",
  "Перейти в панель": "Go to the panel",
  "Проверить оплату": "Check payment",
  "Промокод": "Promo code",
  "Скидка {0}% применена": "{0}% discount applied",
  "Создать новый счёт": "Create a new invoice",
  "Создаём счёт...": "Creating invoice...",
  "Срок счёта вышел. Создайте новый — тариф и промокод сохранятся.": "The invoice has expired. Create a new one — your plan and promo code are kept.",
  "Счёт истёк": "Invoice expired",
  "Счёт открылся в Telegram. Оплатите его и вернитесь сюда — подписка включится сама.": "The invoice opened in Telegram. Pay it and come back — the subscription turns on by itself.",
  "Счёт открылся в новой вкладке. Можно оплатить и с телефона — отсканируйте QR. Подписка включится сама.": "The invoice opened in a new tab. You can also pay from your phone — scan the QR. The subscription turns on by itself.",
  "Тариф {0}": "Plan {0}",
  "Тарифы сейчас недоступны. Попробуйте позже.": "Plans are unavailable right now. Try again later.",
  "Чем оплатить": "Pay with",
  "≈ {0} в день": "≈ {0} per day",
  "Это ваш текущий логин": "That's already your username",
  "Этот логин уже занят": "This username is already taken",
  "Не удалось прочитать изображение. Подойдут JPG, PNG или WebP.": "Couldn't read the image. Use JPG, PNG or WebP.",
  "В демо-режиме логин не меняется: это песочница, а не ваш аккаунт.": "The username can't be changed in demo mode: this is a sandbox, not your account.",
  "В демо-режиме фото не меняется: это песочница, а не ваш аккаунт.": "The photo can't be changed in demo mode: this is a sandbox, not your account.",
  // Админка: время, блокировка, удаление, промокоды
  "Убавить время?": "Reduce time?",
  "Убавить": "Reduce",
  "Время убавлено": "Time reduced",
  "Не удалось изменить время": "Couldn't change the time",
  "Заблокировать": "Ban",
  "Пользователь заблокирован": "User banned",
  "Блокировка снята": "Ban lifted",
  "Не удалось изменить блокировку": "Couldn't change the ban",
  "Пользователь удалён": "User deleted",
  "Не удалось удалить пользователя": "Couldn't delete the user",
  "Пользователь удалится насовсем. Это не отменить.": "The user will be deleted for good. This can't be undone.",
  "Пользователя сразу выкинет из панели и бота, войти снова он не сможет. Данные и аккаунты KL останутся — блокировку можно снять.": "The user is signed out of the panel and the bot right away and can't sign in again. Their data and KL accounts stay — the ban can be lifted.",
  "Введите код промокода": "Enter a promo code",
  "Промокод создан": "Promo code created",
  "Не удалось создать промокод": "Couldn't create the promo code",
  "Им больше нельзя будет воспользоваться. Уже оплаченные с ним подписки не изменятся.": "It can no longer be used. Subscriptions already paid with it won't change.",
  "Промокод удалён": "Promo code deleted",
  "Не удалось удалить промокод": "Couldn't delete the promo code",
  "Время подписки": "Subscription time",
  "− Убавить": "− Reduce",
  "заблокирован": "banned",
  "Разблокировать": "Unban",
  "Промокоды": "Promo codes",
  "Новый промокод": "New promo code",
  "Код": "Code",
  "Скидка, %": "Discount, %",
  "Всего применений": "Total uses",
  "На пользователя": "Per user",
  "Действует, дней": "Valid, days",
  "0 — без лимита": "0 — no limit",
  "0 — бессрочно": "0 — no expiry",
  "Все тарифы": "All plans",
  "Скидка от 1 до 99 %. В лимитах и сроке 0 — без ограничений.": "Discount from 1 to 99%. 0 in the limits and validity means no limit.",
  "Промокодов пока нет.": "No promo codes yet.",
  "бессрочно": "no expiry",
  "все тарифы": "all plans",
  "истёк": "expired",
  "исчерпан": "used up",
  "Подписка {0} станет короче на {1} ч. Если срок дойдёт до текущего момента, она закончится.": "{0}'s subscription will be {1} h shorter. If it reaches the current moment, it ends.",
  "Все активные подписки станут короче на {0} ч. Те, что дойдут до текущего момента, закончатся.": "All active subscriptions will be {0} h shorter. Those that reach the current moment will end.",
  "−{0}ч для {1} подписок": "−{0}h for {1} subscriptions",
  "Заблокировать {0}?": "Ban {0}?",
  "Удалить {0}?": "Delete {0}?",
  "Пользователь удалится насовсем вместе со своими аккаунтами KL ({0}). Это не отменить.": "The user will be deleted for good along with their KL accounts ({0}). This can't be undone.",
  "{0} и аккаунты KL: {1}": "{0} and KL accounts: {1}",
  "{0} — скидка {1}%": "{0} — {1}% off",
  "Удалить промокод {0}?": "Delete promo code {0}?",
  "применений {0} из {1}": "used {0} of {1}",
  "применений {0}": "used {0}",
  "по {0} на пользователя": "{0} per user",
  "тариф {0}": "plan {0}",
  // Парсер: сводка, фильтры, карточки
  "Сводка ленты": "Feed summary",
  "В ленте": "In the feed",
  "с текущими фильтрами": "with current filters",
  "Всплески": "Spikes",
  "просмотры растут быстрее обычного": "views growing faster than usual",
  "закреплено: {0}": "pinned: {0}",
  "отмечены сердечком": "marked with a heart",
  "Открыть объявление": "Open the listing",
  "Лидер роста": "Fastest growing",
  "на этой странице": "on this page",
  "Фильтры": "Filters",
  "Цена, €": "Price, €",
  "от": "from",
  "до": "to",
  "Снять фильтр": "Remove filter",
  "Сбросить все": "Reset all",
  "Лента пуста": "The feed is empty",
  "Под эти фильтры сейчас ничего не подходит — ослабьте их или сбросьте.": "Nothing matches these filters right now — loosen or reset them.",
  "Сбросить фильтры": "Reset filters",
  "Всплеск": "Spike",
  "Пуш": "Bump",
  "С момента публикации": "Since publication",
  "Просмотров в час": "Views per hour",
  "от {0} €": "from {0} €",
  "до {0} €": "up to {0} €",
  "Показать оригинал": "Show original",
  "Скрыть": "Hide",
  "Статистика аккаунтов": "Account statistics",
  "Селфрег": "Self-registered",
  "Без даты регистрации": "No registration date",
  "Собирается молча: пользователи панели этого не видят. Время жизни — от первой успешной публикации через панель до бана; ≈ — дата первой публикации восстановлена по истории публикаций. Аккаунты без публикаций через панель в среднее не входят.": "Collected silently: panel users do not see it. Lifetime runs from the first successful publication through the panel to the ban; ≈ means the first publication date was restored from the publication history. Accounts with no publications through the panel are left out of the averages.",
  "Статистика не загрузилась": "Statistics did not load",
  "Жизнь до бана: ": "Lifetime until ban: ",
  "Публикации {0}: ": "Publications {0}: ",
  "Публикации": "Publications",
  "Период публикаций": "Publication period",
  "День": "Day",
  "Неделя": "Week",
  "Месяц": "Month",
  "Всё время": "All time",
  "за день": "for the day",
  "за неделю": "for the week",
  "за месяц": "for the month",
  "за всё время": "for all time",
  " (по {0}{1})": " (from {0}{1})",
  ", ≈ {0}": ", ≈ {0}",
  "Забанены без публикаций через панель: {0}": "Banned without publications through the panel: {0}",
  "Частые отказы: ": "Frequent failures: ",
  "Пока ни одного": "None yet",
  "удалён": "deleted",
  "вернулся": "recovered",
  "скрыть": "hide",
  "показать": "show",
  "до статистики": "before statistics",
  "селфрег": "self-reg",
  "обычный": "regular",
  "без даты": "no date",
  "Аккаунтов: {0} · забанено: {1}": "Accounts: {0} · banned: {1}",
  " медиана · {0} в среднем": " median · {0} on average",
  " успешных ({0} из {1})": " successful ({0} of {1})",
  "Забаненные аккаунты ({0})": "Banned accounts ({0})",
  "Пользователь: {0}": "User: {0}",
  "Первая публикация {0}{1} → бан {2}": "First publication {0}{1} → banned {2}",
  "Публикаций через панель не было · бан {0}": "No publications through the panel · banned {0}",
  "прожил {0}{1}": "lived {0}{1}",
  "Причина: {0}": "Reason: {0}",
  "Публикации {0}: {1} успешных, {2} неудачных": "Publications {0}: {1} successful, {2} failed",
  "Объявления при бане: {0}": "Listings at ban: {0}",
  "{0} д {1} ч": "{0} d {1} h",
  "{0} ч {1} мин": "{0} h {1} min",
  "Обои переписки": "Chat wallpaper",
  "Фон под сообщениями в открытом диалоге. Рисуется цветом выбранной темы и запоминается в этом браузере.": "The background under messages in an open conversation. Drawn in the colour of the selected theme and remembered in this browser.",
  "Без обоев": "No wallpaper",
  "Волны": "Waves",
  "Соты": "Honeycomb",
  "Топография": "Topography",
  "Звёзды": "Stars",
  "Полосы": "Stripes",
  "Дождь": "Rain",
  "Сияние": "Glow",
  "Прокси пользователей (": "User proxies (",
  "Поиск по пользователю, адресу или аккаунту": "Search by user, address or account",
  "Пользователи ещё не добавили ни одного прокси": "Users have not added any proxies yet",
  "Без пользователя": "No user",
  "аккаунты": "accounts",
  "без аккаунтов": "no accounts",
  "Соединение сообщений": "Messages connection",
  " · через прокси {0} из {1}": " · via proxy {0} of {1}",
  "По умолчанию сообщения у всех аккаунтов идут через прокси. Прямое соединение — исключение для отдельного аккаунта. Вернуть на прокси можно только аккаунт с рабочим прокси — пользователь ничего не заметит.": "By default, messages of every account go through its proxy. A direct connection is an exception for a single account. Only an account with a working proxy can be moved back to the proxy — the user will not notice anything.",
  "Поиск по пользователю, аккаунту или прокси": "Search by user, account or proxy",
  "Не загрузилось — повторить": "Did not load — retry",
  "Аккаунтов пока нет": "No accounts yet",
  "Прямое": "Direct",
  "прокси не привязан": "no proxy attached",
  "прокси не настроен": "proxy not configured",
  "пинг {0} мс": "ping {0} ms",
  " · сообщения сейчас не грузятся": " · messages are not loading now",
  " · по умолчанию": " · default",
  "Соединение сообщений: {0}": "Messages connection: {0}",
  "Не удалось переключить соединение": "Could not switch the connection",
  "Показать перевод": "Show translation",
  // Понятные тексты технических ошибок (backend/src/userFacingError.js) и обрыва
  // связи с сервером панели (api.js).
  "Kleinanzeigen не принял сессию аккаунта (401). Обновите cookie или войдите в аккаунт заново.": "Kleinanzeigen did not accept the account session (401). Update the cookies or log in to the account again.",
  "Прокси не принял логин и пароль (407). Проверьте данные прокси.": "The proxy did not accept the login and password (407). Check the proxy details.",
  "Прокси не отвечает. Проверьте прокси и повторите.": "The proxy is not responding. Check the proxy and try again.",
  "Не удалось подключиться: прокси или сервер отклонил соединение. Проверьте прокси и повторите.": "Could not connect: the proxy or the server refused the connection. Check the proxy and try again.",
  "Не удалось найти адрес сервера. Проверьте прокси и повторите.": "Could not resolve the server address. Check the proxy and try again.",
  "Соединение оборвалось. Повторите ещё раз.": "The connection dropped. Please try again.",
  "Файл не найден на сервере панели. Загрузите его заново.": "The file was not found on the panel server. Upload it again.",
  "Внутренняя ошибка панели. Повторите ещё раз — если ошибка не уходит, напишите в поддержку.": "Internal panel error. Please try again — if it keeps happening, contact support.",
  "Запрос прерван. Повторите ещё раз.": "The request was interrupted. Please try again.",
  "Сервер панели не ответил вовремя. Повторите ещё раз.": "The panel server did not respond in time. Please try again.",
  "Нет связи с сервером панели. Проверьте интернет и повторите.": "No connection to the panel server. Check your internet connection and try again.",
  // Ключи подписки: выпуск в администрировании (AdminRedeemKeysSection),
  // активация в настройках и на экране «Подписка не активна» (RedeemKeyForm)
  "Ключи подписки": "Subscription keys",
  " · свободных {0}": " · {0} unused",
  "Выпустить ключи": "Create keys",
  "Срок подписки": "Subscription length",
  "Своё число дней": "Custom number of days",
  "Сколько ключей": "Number of keys",
  "Активировать в течение": "Must be redeemed within",
  "Без срока": "No deadline",
  "7 дней": "7 days",
  "30 дней": "30 days",
  "90 дней": "90 days",
  "Для чего": "Purpose",
  "Например: розыгрыш в канале": "For example: channel giveaway",
  "{0} × {1} — дни добавятся к подписке того, кто активирует ключ": "{0} × {1}: the days go to whoever redeems the key",
  "Срок — от 1 до 365 дней, за раз — до {0} ключей": "Length: 1 to 365 days, up to {0} keys at a time",
  "Выпустить": "Create",
  " · по {0}": " · {0} each",
  "Скопировать все": "Copy all",
  "Не скопировалось": "Couldn't copy",
  "Буфер обмена недоступен — выделите ключ и скопируйте вручную.": "The clipboard isn't available. Select the key and copy it manually.",
  "Свободные": "Unused",
  "Активированные": "Redeemed",
  "Активированных ключей пока нет": "No redeemed keys yet",
  "Свободных ключей нет — выпустите новые": "No unused keys. Create new ones",
  "активировал {0} · {1}": "redeemed by {0} · {1}",
  "истёк {0}": "expired {0}",
  "активировать до {0}": "redeem by {0}",
  "без срока активации": "no redemption deadline",
  "выпущен {0}": "created {0}",
  "активирован": "redeemed",
  "Удалить ключ": "Delete key",
  "Удалить ключ {0}?": "Delete key {0}?",
  "Пропадёт только запись в списке — дни, которые ключ уже добавил, у пользователя останутся.": "Only the list entry goes away. The days this key already added stay with the user.",
  "Ключ перестанет активироваться. Если его уже кому-то отдали, он не сработает.": "The key will stop working. If you've already given it to someone, it won't redeem.",
  "Не удалось выпустить ключи": "Couldn't create keys",
  "Не удалось удалить ключ": "Couldn't delete the key",
  "Не удалось загрузить ключи": "Couldn't load the keys",
  "Ключ не найден": "Key not found",
  "Срок ключа — от 1 до 365 дней": "Key length must be 1 to 365 days",
  "За раз — от 1 до 50 ключей": "1 to 50 keys at a time",
  "Ключ подписки": "Subscription key",
  "Введите ключ — он выглядит так: UMB-XXXX-XXXX-XXXX.": "Enter the key. It looks like this: UMB-XXXX-XXXX-XXXX.",
  "Не удалось активировать ключ": "Couldn't redeem the key",
  "Это не похоже на ключ. Он выглядит так: UMB-XXXX-XXXX-XXXX.": "That doesn't look like a key. It looks like this: UMB-XXXX-XXXX-XXXX.",
  "Такого ключа нет. Проверьте, что он введён без ошибок.": "There's no such key. Check that it's typed correctly.",
  "Этот ключ уже активирован.": "This key has already been redeemed.",
  "Срок активации этого ключа истёк.": "This key's redemption deadline has passed.",
  "Ключ не принят.": "The key wasn't accepted.",
  "Не удалось продлить подписку. Ключ остался свободным — попробуйте ещё раз.": "Couldn't extend the subscription. The key is still unused, so try again.",
  "В демо ключ не активируется — выйдите из демо и введите его в настройках своего аккаунта.": "Keys can't be redeemed in the demo. Leave the demo and enter the key in your account settings.",
  "Ключ активирован": "Key redeemed",
  "Добавлено дней: {0}. Подписка действует до {1}.": "Days added: {0}. Subscription active until {1}.",
  "Добавлено дней: {0}.": "Days added: {0}.",
  "Ключ из розыгрыша или от администратора. Дни добавятся к подписке сразу после активации.": "A key from a giveaway or from the admin. The days are added to your subscription as soon as you redeem it.",
  "Ввести ключ": "Enter key",
  "Ключ из розыгрыша или от администратора. Дни добавятся сразу, и панель откроется.": "A key from a giveaway or from the admin. The days are added right away and the panel opens.",
  "Есть ключ подписки? Активировать": "Have a subscription key? Redeem it",
  "Ключ активирован: +{0}. Открываем панель…": "Key redeemed: +{0}. Opening the panel…",
  // Отложенные сообщения (components/ScheduledMessages.jsx, MessagesTab)
  "Отправить позже": "Send later",
  "Перенести отправку": "Reschedule",
  "по Берлину": "Berlin time",
  "Через 10 минут": "In 10 minutes",
  "Через 30 минут": "In 30 minutes",
  "Завтра утром": "Tomorrow morning",
  "Выбрать время…": "Pick a time…",
  "Дата": "Date",
  "Время": "Time",
  "Отправить {0}": "Send {0}",
  "Отложить": "Schedule",
  "Отменить, если покупатель ответит": "Cancel if the buyer replies",
  "сегодня в {0}": "today at {0}",
  "завтра в {0}": "tomorrow at {0}",
  "{0} в {1}": "{0} at {1}",
  "завтра": "tomorrow",
  "Укажите дату и время.": "Pick a date and time.",
  "Время отправки должно быть хотя бы через минуту.": "The send time must be at least a minute from now.",
  "Отложить можно не больше чем на 30 дней.": "You can schedule up to 30 days ahead.",
  "Не отправлено": "Not sent",
  "Отправляется…": "Sending…",
  "Отправится {0}": "Sends {0}",
  "Отменится, если покупатель ответит раньше": "Cancelled if the buyer replies first",
  "· до ответа": "· until a reply",
  "Сейчас": "Now",
  "Отложить нельзя": "Can't schedule",
  "У этого диалога ещё нет номера на Kleinanzeigen — отправьте первое сообщение сразу.": "This conversation has no Kleinanzeigen ID yet. Send the first message right away.",
  "Отложить можно только текст": "Only text can be scheduled",
  "Фото отправьте сразу, а текст — отдельным отложенным сообщением.": "Send photos right away and schedule the text as a separate message.",
  "Нечего откладывать": "Nothing to schedule",
  "Напишите текст сообщения.": "Write the message text.",
  "Не удалось отложить сообщение": "Couldn't schedule the message",
  "Не удалось отложить сообщение.": "Couldn't schedule the message.",
  "Если покупатель ответит раньше, сообщение отменится.": "If the buyer replies first, the message is cancelled.",
  "Не получилось": "That didn't work",
  "Фото, быстрые ответы, переводчик, отправить позже": "Photo, quick replies, translator, send later",
  "Отправить · правый щелчок или удержание — отправить позже": "Send · right-click or hold to send later",
  "Отложенное сообщение не отправлено": "Scheduled message not sent",
  "Отложенное сообщение отправится {0}": "Scheduled message sends {0}",
  "не ушло": "not sent",
  "Сначала напишите сообщение": "Write a message first",
  "Отложить можно только сообщение в открытый диалог.": "Only a message to an open conversation can be scheduled.",
  "Не указано время отправки.": "No send time given.",
  "Отложить сообщение можно не больше чем на 30 дней.": "A message can be scheduled up to 30 days ahead.",
  "Отложенных сообщений уже 200 — дождитесь отправки или отмените лишние.": "You already have 200 scheduled messages. Wait for them to send or cancel some.",
  "Отложенное сообщение не найдено — возможно, оно уже отправлено или отменено.": "Scheduled message not found. It may have been sent or cancelled already.",
  "Сообщение уже отправляется.": "The message is already being sent.",
  "Сообщение уже отправляется — отменить его нельзя.": "The message is already being sent and can't be cancelled.",
  "Не удалось изменить время.": "Couldn't change the time.",
  "Не удалось отправить сообщение.": "Couldn't send the message.",
  "Не удалось отменить сообщение.": "Couldn't cancel the message.",
  "Сообщение длиннее 4000 знаков.": "The message is longer than 4000 characters.",
  "Аккаунт удалён из панели.": "The account was removed from the panel.",
  "Сервер перезапускался во время отправки — сообщение могло уйти. Загляните в диалог, прежде чем отправлять снова.": "The server restarted while sending, so the message may have gone out. Check the conversation before sending again.",
  "Kleinanzeigen не ответил на отправку — сообщение могло уйти. Загляните в диалог, прежде чем отправлять снова.": "Kleinanzeigen didn't respond to the send, so the message may have gone out. Check the conversation before sending again.",
  "Диалог не найден.": "Conversation not found.",
  "Kleinanzeigen временно ограничил аккаунт — защита от ботов.": "Kleinanzeigen has temporarily limited the account (bot protection).",
  "Сервер был перегружен и не смог отправить сообщение.": "The server was overloaded and couldn't send the message.",
  "Kleinanzeigen не ответил на отправку. Проверьте прокси аккаунта и повторите.": "Kleinanzeigen didn't respond to the send. Check the account proxy and try again.",
  "Активного предложения в диалоге уже нет — возможно, оно отклонено или истекло. Обновите диалог.": "There's no active offer in this conversation anymore — it may already be declined or expired. Refresh the conversation.",
  "Kleinanzeigen не принял отклонение. Обновите диалог и проверьте, прежде чем повторять.": "Kleinanzeigen didn't accept the decline. Refresh the conversation and check before trying again.",
  // Заморозка подписки на сервере
  "Подписка на заморозке. Отключите заморозку в настройках, чтобы продолжить работу.": "Your subscription is frozen. Turn off the freeze in Settings to keep working.",
  // Рассылки в админке: удаление и видимость
  "Удалить рассылку «{0}»?": "Delete the broadcast “{0}”?",
  "Она пропадёт из уведомлений у всех пользователей в течение минуты. Сообщения, уже ушедшие в Telegram, останутся.": "It disappears from everyone's notifications within a minute. Messages already sent to Telegram stay.",
  "Рассылка удалена": "Broadcast deleted",
  "Не удалось удалить рассылку": "Couldn't delete the broadcast",
  "Удалить рассылку": "Delete broadcast",
  "скрыта из уведомлений": "hidden from notifications",
  "в уведомлениях до {0}": "in notifications until {0}",
  "Рассылка не найдена": "Broadcast not found",
  // Пустой раздел «Аккаунты» на компьютере
  "Пока нет аккаунтов": "No accounts yet",
  "Добавьте аккаунт Kleinanzeigen — его диалоги, объявления и статистика сразу появятся в панели.": "Add a Kleinanzeigen account and its conversations, listings and stats show up in the panel right away.",
  "Файл .txt или .json из браузера — или просто текст": "A .txt or .json file from the browser, or just the text",
  "Свой прокси или встроенный Umbrella": "Your own proxy or the built-in Umbrella one",
  "Имя, почта и объявления подтянутся сами": "Name, email and listings are filled in automatically",
  // Выход из аккаунта панели (настройки и нижняя строка сайдбара)
  "Выйти из аккаунта?": "Sign out?",
  "Сессия в этом браузере завершится. Аккаунты Kleinanzeigen, объявления и подписка останутся — чтобы вернуться, войдите снова.": "Your session in this browser will end. Your Kleinanzeigen accounts, listings and subscription stay. To come back, sign in again.",
  "Выход из аккаунта": "Sign out",
  "Завершить сессию в этом браузере. Аккаунты, объявления и подписка останутся.": "End the session in this browser. Accounts, listings and subscription stay.",
};

// Серверные тексты ошибок, в которых есть имя сервиса или код ответа: их не
// перечислить ключами, поэтому они переводятся по выкройке.
const SERVICE_NAMES = {
  "Kleinanzeigen": "Kleinanzeigen",
  "PicClick": "PicClick",
  "Telegram": "Telegram",
  "Сервис перевода": "The translation service",
  "ИИ-сервис": "The AI service",
  "Платёжный сервис": "The payment service"
};
const svc = (name) => SERVICE_NAMES[name] || name;
// Имя сервиса — только из списка: иначе (.+) захватывал и русское начало
// составной ошибки («Не удалось проверить сессию аккаунта — Kleinanzeigen …»).
const S = `(${Object.keys(SERVICE_NAMES).join("|")})`;
const rx = (body) => new RegExp(`^${S} ${body}$`);
// «Art» → the “Art” parameter; без имени — a category parameter.
const klParam = (name) => (name ? `the “${name}” parameter` : "a category parameter");

export const EN_PATTERNS = [
  [/^Слишком много неверных ключей подряд\. Попробуйте через (\d+) мин\.$/, (m) => `Too many wrong keys in a row. Try again in ${m[1]} min.`],
  [rx("не ответил вовремя\\. Повторите ещё раз\\."), (m) => `${svc(m[1])} did not respond in time. Please try again.`],
  [rx("временно не отвечает \\(ошибка (\\d+)\\)\\. Повторите чуть позже\\."), (m) => `${svc(m[1])} is temporarily unavailable (error ${m[2]}). Please try again a bit later.`],
  [rx("отклонил запрос \\((\\d+)\\) — похоже, сработала защита от ботов\\. Подождите немного и повторите\\."), (m) => `${svc(m[1])} rejected the request (${m[2]}) — bot protection seems to have kicked in. Wait a little and try again.`],
  [rx("отклонил запрос \\((\\d+)\\)\\."), (m) => `${svc(m[1])} rejected the request (${m[2]}).`],
  [rx("не нашёл запрошенное \\(404\\)\\."), (m) => `${svc(m[1])} could not find what was requested (404).`],
  [rx("просит подождать: слишком много запросов \\(429\\)\\. Повторите через несколько минут\\."), (m) => `${svc(m[1])} asks to wait: too many requests (429). Try again in a few minutes.`],
  [rx("прислал неожиданный ответ\\. Повторите ещё раз\\."), (m) => `${svc(m[1])} sent an unexpected response. Please try again.`],
  // Отказы проверки KL с названием параметра или поля (backend/src/klValidationText.js).
  // Точные фразы — раньше общих «…: <фраза KL>», которые иначе перехватили бы их.
  [/^Kleinanzeigen не принял значение параметра (?:«(.+)»|категории): такого варианта в этой категории больше нет\. Выберите другое значение и повторите\.$/,
    (m) => `Kleinanzeigen did not accept the value of ${klParam(m[1])}: this option no longer exists in this category. Choose another value and try again.`],
  [/^Kleinanzeigen требует заполнить параметр (?:«(.+)»|категории) в этой категории\. Заполните его и повторите\.$/,
    (m) => `Kleinanzeigen requires ${klParam(m[1])} to be filled in for this category. Fill it in and try again.`],
  [/^Kleinanzeigen не принял значение параметра (?:«(.+)»|категории)\. Проверьте его и повторите\.$/,
    (m) => `Kleinanzeigen did not accept the value of ${klParam(m[1])}. Check it and try again.`],
  [/^Kleinanzeigen не принял значение параметра (?:«(.+?)»|категории): (.+)$/,
    (m) => `Kleinanzeigen did not accept the value of ${klParam(m[1])}: ${m[2]}`],
  [/^Kleinanzeigen не принял поле «(.+)»\. Проверьте его и повторите\.$/,
    (m) => `Kleinanzeigen did not accept the “${EN[m[1]] || m[1]}” field. Check it and try again.`],
  [/^Kleinanzeigen не принял поле «(.+?)»: (.+)$/,
    (m) => `Kleinanzeigen did not accept the “${EN[m[1]] || m[1]}” field: ${m[2]}`],
  [/^Kleinanzeigen не принял объявление: (.+)$/, (m) => `Kleinanzeigen did not accept the listing: ${m[1]}`]
];

export default EN;
